// GENERATED FILE:
export default {
  "en": {
    "gui.alerts.lostPeripheralConnection": "Scratch lost connection to {extensionName}.",
    "gui.alerts.tryAgain": "Try Again",
    "gui.alerts.download": "Download",
    "gui.connection.reconnect": "Reconnect",
    "gui.alerts.uploadFirmware": "Upload firmware",
    "gui.backpack.costumeLabel": "costume",
    "gui.backpack.soundLabel": "sound",
    "gui.backpack.scriptLabel": "script",
    "gui.backpack.spriteLabel": "sprite",
    "gui.backpack.header": "Backpack",
    "gui.backpack.errorBackpack": "Error loading backpack",
    "gui.backpack.loadingBackpack": "Loading...",
    "gui.backpack.more": "More",
    "gui.backpack.emptyBackpack": "Backpack is empty",
    "gui.unsupportedBrowser.label": "Browser is not supported",
    "gui.unsupportedBrowser.errorLabel": "An Error Occurred",
    "gui.unsupportedBrowser.notRecommended": "We are very sorry, but it looks like you are using a browser version that Scratch does not support. We recommend updating to the latest version of a supported browser such as Google Chrome, Mozilla Firefox, Microsoft Edge, or Apple Safari.",
    "gui.unsupportedBrowser.description": "We are very sorry, but Scratch does not support this browser. We recommend updating to the latest version of a supported browser such as Google Chrome, Mozilla Firefox, Microsoft Edge, or Apple Safari.",
    "gui.unsupportedBrowser.back": "Back",
    "gui.unsupportedBrowser.previewfaq": "To learn more, go to the {previewFaqLink}.",
    "gui.unsupportedBrowser.previewfaqlinktext": "FAQ",
    "gui.cards.all-tutorials": "Tutorials",
    "gui.cards.shrink": "Shrink",
    "gui.cards.expand": "Expand",
    "gui.cards.close": "Close",
    "gui.cards.more-things-to-try": "More things to try!",
    "gui.cards.see-more": "See more",
    "gui.comingSoon.message1": "Don't worry, we're on it {emoji}",
    "gui.comingSoon.message2": "Coming Soon...",
    "gui.comingSoon.message3": "We're working on it {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "No devices found",
    "gui.connection.auto-scanning.prescan": "Have your device nearby, then begin searching.",
    "gui.connection.auto-scanning.pressbutton": "Press the button on your device.",
    "gui.connection.auto-scanning.start-search": "Start Searching",
    "gui.connection.connecting-searchbutton": "Searching...",
    "gui.connection.auto-scanning.try-again": "Try again",
    "gui.connection.connected": "Connected",
    "gui.connection.disconnect": "Disconnect",
    "gui.connection.go-to-editor": "Go to Editor",
    "gui.connection.connecting-cancelbutton": "Connecting...",
    "gui.connection.accessDeniedError.errorMessage": "Oops, serialport access denied, please check whether the serial port is occupied.",
    "gui.connection.unknownErrorCode31.errorMessage": "Oops, Unknown error code 31, it is recommended to re-plug the device.",
    "gui.connection.error.errorMessage": "Oops, looks like something went wrong.",
    "gui.connection.error.tryagainbutton": "Try again",
    "gui.connection.error.helpbutton": "Help",
    "gui.connection.peripheral-name-label": "Device name",
    "gui.connection.connect": "Connect",
    "gui.connection.scanning.listAll": "Show all connectable devices",
    "gui.connection.scanning.lookingforperipherals": "Looking for devices",
    "gui.connection.scanning.noPeripheralsFound": "No devices found",
    "gui.connection.scanning.instructions": "Select your device in the list above.",
    "gui.connection.search": "Refresh",
    "gui.connection.unavailable.installscratchlink": "Make sure you have Scratch Link installed and running",
    "gui.connection.unavailable.connectUsbEnableBluetooth": "Check that USB cable is connected or Bluetooth is enabled",
    "gui.connection.unavailable.tryagainbutton": "Try again",
    "gui.connection.unavailable.helpbutton": "Help",
    "gui.controls.go": "Go",
    "gui.controls.stop": "Stop",
    "gui.crashMessage.label": "Oops! Something went wrong.",
    "gui.crashMessage.description": "We are so sorry, but it looks like Scratch has crashed. This bug has been automatically reported to the Scratch Team. Please refresh your page to try again.",
    "gui.crashMessage.errorNumber": "Your error was logged with id {errorId}",
    "gui.crashMessage.reload": "Reload",
    "gui.customProcedures.myblockModalTitle": "Make a Block",
    "gui.customProcedures.addAnInputNumber": "Add an input",
    "gui.customProcedures.numberType": "number",
    "gui.customProcedures.addAnInputText": "Add an input",
    "gui.customProcedures.TextType": "text",
    "gui.customProcedures.addAnInputBoolean": "Add an input",
    "gui.customProcedures.booleanType": "boolean",
    "gui.customProcedures.addALabel": "Add a label",
    "gui.customProcedures.runWithoutScreenRefresh": "Run without screen refresh",
    "gui.customProcedures.cancel": "Cancel",
    "gui.customProcedures.ok": "OK",
    "gui.deviceTypeModal.deviceTypeTitle": "Choose a Programming Type",
    "gui.deviceTypeModal.arduino": "Arduino",
    "gui.deviceTypeModal.python": "Python",
    "gui.deviceTypeModal.microPython": "MicroPython",
    "gui.deviceTypeModal.cancel": "Cancel",
    "gui.SpriteInfo.direction": "Direction",
    "gui.directionPicker.rotationStyles.allAround": "All Around",
    "gui.directionPicker.rotationStyles.leftRight": "Left/Right",
    "gui.directionPicker.rotationStyles.dontRotate": "Do not rotate",
    "gui.gui.addExtension": "Add Extension",
    "gui.gui.codeTab": "Code",
    "gui.gui.backdropsTab": "Backdrops",
    "gui.gui.costumesTab": "Costumes",
    "gui.gui.soundsTab": "Sounds",
    "gui.hardwareConsole.send": "Send",
    "gui.hardwareConsole.buadrate": "Buadrate",
    "gui.hardwareConsole.endOfLine": "End of line",
    "gui.hardwareConsole.hexform": "Hex form",
    "gui.hardwareConsole.autoScroll": "Auto scroll",
    "gui.hardwareHeader.upload": "Upload",
    "gui.stageHeader.codeStageSizeLarge": "Switch to large stage",
    "gui.stageHeader.codeStageSizeSmall": "Switch to small stage",
    "gui.stageHeader.hideStage": "Hide stage",
    "gui.extensionLibrary.comingSoon": "Coming Soon",
    "gui.extensionLibrary.requires": "Requires",
    "gui.extensionLibrary.collaboration": "Collaboration with",
    "gui.extensionLibrary.manufactor": "Manufactor",
    "gui.extensionLibrary.version": "Version",
    "gui.extensionLibrary.author": "Author",
    "gui.extensionLibrary.programMode": "Program mode",
    "gui.extensionLibrary.programLanguage": "Program language",
    "gui.extensionLibrary.deviceLearnMore": "Learn more",
    "gui.extensionLibrary.extensionHelp": "Help",
    "gui.extensionLibrary.Processing": "Processing...",
    "gui.extensionLibrary.loaded": "Loaded",
    "gui.extensionLibrary.notLoaded": "Not loaded",
    "gui.library.filterPlaceholder": "Search",
    "gui.library.allTag": "All",
    "gui.loader.message1": "Creating blocks …",
    "gui.loader.message2": "Loading sprites …",
    "gui.loader.message3": "Loading sounds …",
    "gui.loader.message4": "Loading extensions …",
    "gui.loader.message5": "Herding cats …",
    "gui.loader.message6": "Transmitting nanos …",
    "gui.loader.message7": "Inflating gobos …",
    "gui.loader.message8": "Preparing emojis …",
    "gui.loader.headline": "Loading Project",
    "gui.loader.creating": "Creating Project",
    "gui.accountMenu.profile": "Profile",
    "gui.accountMenu.myStuff": "My Stuff",
    "gui.accountMenu.myClasses": "My Classes",
    "gui.accountMenu.myClass": "My Class",
    "gui.accountMenu.accountSettings": "Account settings",
    "gui.accountMenu.signOut": "Sign out",
    "gui.authorInfo.byUser": "by {username}",
    "gui.menuBar.seeProjectPage": "See Project Page",
    "general.username": "Username",
    "general.password": "Password",
    "general.signIn": "Sign in",
    "login.needHelp": "Need Help?",
    "form.validationRequired": "This field is required",
    "gui.menuBar.LanguageSelector": "language selector",
    "gui.menuBar.tutorialsLibrary": "Tutorials",
    "gui.menuBar.community": "Open Community",
    "gui.menuBar.wiki": "Wiki",
    "gui.menuBar.restoreSprite": "Restore Sprite",
    "gui.menuBar.restoreSound": "Restore Sound",
    "gui.menuBar.restoreCostume": "Restore Costume",
    "gui.menuBar.restore": "Restore",
    "gui.menuBar.saveNow": "Save now",
    "gui.menuBar.saveAsCopy": "Save as a copy",
    "gui.menuBar.remix": "Remix",
    "gui.menuBar.new": "New",
    "gui.menuBar.checkUpdate": "Check update",
    "gui.menuBar.installDriver": "Install driver",
    "gui.menuBar.clearCacheAndRestart": "Clear cache and restart",
    "gui.menuBar.file": "File",
    "gui.menuBar.downloadToComputer": "Save to your computer",
    "gui.menuBar.edit": "Edit",
    "gui.menuBar.turboModeOff": "Turn off Turbo Mode",
    "gui.menuBar.turboModeOn": "Turn on Turbo Mode",
    "gui.menuBar.noDeviceSelected": "No device selected",
    "gui.menuBar.noConnection": "Unconnected",
    "gui.menuBar.uploadFirmware": "Upload Firmware",
    "gui.menu-bar.programMode": "Program Mode",
    "gui.gui.projectTitlePlaceholder": "Project title here",
    "gui.menuBar.saveNowLink": "Save Now",
    "gui.menuBar.isShared": "Shared",
    "gui.menuBar.share": "Share",
    "gui.modal.help": "Help",
    "gui.modal.back": "Back",
    "gui.monitor.listMonitor.empty": "(empty)",
    "gui.monitor.listMonitor.listLength": "length {length}",
    "gui.monitor.contextMenu.default": "normal readout",
    "gui.monitor.contextMenu.large": "large readout",
    "gui.monitor.contextMenu.slider": "slider",
    "gui.monitor.contextMenu.sliderRange": "change slider range",
    "gui.monitor.contextMenu.import": "import",
    "gui.monitor.contextMenu.export": "export",
    "gui.playButton.play": "Play",
    "gui.playButton.stop": "Stop",
    "gui.gui.variableScopeOptionAllSprites": "For all sprites",
    "gui.gui.variableScopeOptionSpriteOnly": "For this sprite only",
    "gui.gui.cloudVariableOption": "Cloud variable (stored on server)",
    "gui.gui.variablePromptAllSpritesMessage": "This variable will be available to all sprites.",
    "gui.gui.listPromptAllSpritesMessage": "This list will be available to all sprites.",
    "gui.prompt.cancel": "Cancel",
    "gui.prompt.ok": "OK",
    "gui.playbackStep.stopMsg": "Stop",
    "gui.playbackStep.playMsg": "Play",
    "gui.playbackStep.loadingMsg": "Loading...",
    "gui.playbackStep.saveMsg": "Save",
    "gui.playbackStep.reRecordMsg": "Re-record",
    "gui.recordModal.title": "Record Sound",
    "gui.recordingStep.beginRecord": "Begin recording by clicking the button below",
    "gui.recordingStep.permission": "{arrow}We need your permission to use your microphone",
    "gui.recordingStep.stop": "Stop recording",
    "gui.recordingStep.record": "Record",
    "gui.sliderModal.min": "Minimum value",
    "gui.sliderModal.max": "Maximum value",
    "gui.sliderModal.title": "Change slider range",
    "gui.sliderPrompt.cancel": "Cancel",
    "gui.sliderPrompt.ok": "OK",
    "gui.soundEditor.sound": "Sound",
    "gui.soundEditor.play": "Play",
    "gui.soundEditor.stop": "Stop",
    "gui.soundEditor.copy": "Copy",
    "gui.soundEditor.paste": "Paste",
    "gui.soundEditor.copyToNew": "Copy to New",
    "gui.soundEditor.delete": "Delete",
    "gui.soundEditor.save": "Save",
    "gui.soundEditor.undo": "Undo",
    "gui.soundEditor.redo": "Redo",
    "gui.soundEditor.faster": "Faster",
    "gui.soundEditor.slower": "Slower",
    "gui.soundEditor.echo": "Echo",
    "gui.soundEditor.robot": "Robot",
    "gui.soundEditor.louder": "Louder",
    "gui.soundEditor.softer": "Softer",
    "gui.soundEditor.reverse": "Reverse",
    "gui.soundEditor.fadeOut": "Fade out",
    "gui.soundEditor.fadeIn": "Fade in",
    "gui.soundEditor.mute": "Mute",
    "gui.SpriteInfo.spritePlaceholder": "Name",
    "gui.SpriteInfo.sprite": "Sprite",
    "gui.SpriteInfo.show": "Show",
    "gui.SpriteInfo.size": "Size",
    "gui.spriteSelectorItem.contextMenuDuplicate": "duplicate",
    "gui.spriteSelectorItem.contextMenuExport": "export",
    "gui.spriteSelectorItem.contextMenuDelete": "delete",
    "gui.spriteSelector.addSpriteFromLibrary": "Choose a Sprite",
    "gui.spriteSelector.addSpriteFromPaint": "Paint",
    "gui.spriteSelector.addSpriteFromSurprise": "Surprise",
    "gui.spriteSelector.addSpriteFromFile": "Upload Sprite",
    "gui.stageHeader.stageSizeLarge": "Switch to large stage",
    "gui.stageHeader.stageSizeSmall": "Switch to small stage",
    "gui.stageHeader.stageSizeFull": "Enter full screen mode",
    "gui.stageHeader.stageSizeUnFull": "Exit full screen mode",
    "gui.stageHeader.fullscreenControl": "Full Screen Control",
    "gui.spriteSelector.addBackdropFromLibrary": "Choose a Backdrop",
    "gui.stageSelector.addBackdropFromPaint": "Paint",
    "gui.stageSelector.addBackdropFromSurprise": "Surprise",
    "gui.stageSelector.addBackdropFromFile": "Upload Backdrop",
    "gui.stageSelector.stage": "Stage",
    "gui.stageSelector.backdrops": "Backdrops",
    "gui.telemetryOptIn.label": "Report statistics to improve Scratch",
    "gui.telemetryOptIn.body1": "The Scratch Team is always looking to better understand how Scratch is used around the world. To help support this effort, you can allow Scratch to automatically send usage information to the Scratch Team.",
    "gui.telemetryOptIn.body2": "The information we collect includes language selection, blocks usage, and some events like saving, loading, and uploading a project. We DO NOT collect any personal information. Please see our {privacyPolicyLink} for more information.",
    "gui.telemetryOptIn.privacyPolicyLink": "Privacy Policy",
    "gui.telemetryOptIn.optInText": "Share my usage data with the Openblock Team",
    "gui.telemetryOptIn.optInTooltip": "Enable telemetry",
    "gui.telemetryOptIn.optOutText": "Do not share my usage data with the Openblock Team",
    "gui.telemetryOptIn.optOutTooltip": "Disable telemetry",
    "gui.telemetryOptIn.settingWasUpdated": "Your setting was updated.",
    "gui.telemetryOptIn.buttonClose": "Close",
    "gui.turboMode.active": "Turbo Mode",
    "gui.updateModal.close": "Close",
    "gui.updateModal.downloading": "Downloading",
    "gui.updateModal.abort": "Abort",
    "gui.updateModel.tileCheckingForUpdate": "Checking for update",
    "gui.updateModel.checkingTips": "Depending on your network, this step may take a few seconds to a dozen seconds, please wait.",
    "gui.updateModel.tileUpdateExternalResource": "New version of external resource detected",
    "gui.updateModel.tileUpdateApplication": "New version of this application adetected",
    "gui.updateModal.updateLater": "Update later",
    "gui.updateModal.updateAndRestart": "Update and restart",
    "gui.updateModel.tileAlreadyLatest": "No new version detected",
    "gui.updateModel.alreadyLatestTips": "Openblock is already the latest version.",
    "gui.updateModel.tileError": "Operation failed",
    "gui.updateModel.upgradingExternalResource": "Upgrading external resource",
    "gui.updateModal.deletingCompressedFile": "Deleting compressed file",
    "gui.updateModal.deletingCacheFile": "Deleting cache file",
    "gui.updateModal.extractingCompressedFile": "Extracting compressed file",
    "gui.updateModal.verifyingCompressedFile": "Verifying compressed file",
    "gui.updateModal.verifyingCacheFile": "Verifying cache file",
    "gui.updateModel.tileResourceUpdateFinish": "External resource update complete",
    "gui.updateModal.resourceUpdateFinishTips": "External resource update complete, the application will automatically restart after 3 seconds.",
    "gui.updateModel.downloadingApplication": "Downloading application",
    "gui.updateModel.tileApplicationDownloadFinish": "Application download complete",
    "gui.updateModal.applicationDownloadeFinishTips": "Application download complete, it will automatically quit and start installer after 3 seconds.",
    "gui.uploadProgress.uploading": "Uploading",
    "gui.uploadProgress.uploadSuccess": "Upload success",
    "gui.uploadProgress.uploadError": "Upload error",
    "gui.uploadProgress.uploadTimeout": "Upload timeout",
    "gui.uploadProgress.uploadAborted": "Upload aborted",
    "gui.uploadProgress.abort": "Abort",
    "gui.uploadProgress.close": "Close",
    "gui.webglModal.label": "Your Browser Does Not Support WebGL",
    "gui.webglModal.description": "Unfortunately it looks like your browser or computer {webGlLink}. This technology is needed for Scratch to run.",
    "gui.webglModal.webgllink": "does not support WebGL",
    "gui.webglModal.back": "Back",
    "gui.webglModal.previewfaq": "To learn more, go to the {previewFaqLink}.",
    "gui.webglModal.previewfaqlinktext": "FAQ",
    "gui.costumeLibrary.chooseABackdrop": "Choose a Backdrop",
    "gui.costumeLibrary.chooseACostume": "Choose a Costume",
    "gui.costumeTab.addBackdropFromLibrary": "Choose a Backdrop",
    "gui.costumeTab.addCostumeFromLibrary": "Choose a Costume",
    "gui.costumeTab.addBlankCostume": "Paint",
    "gui.costumeTab.addSurpriseCostume": "Surprise",
    "gui.costumeTab.addFileBackdrop": "Upload Backdrop",
    "gui.costumeTab.addFileCostume": "Upload Costume",
    "gui.deviceLibrary.chooseADevice": "Choose an Device",
    "gui.deviceLibrary.deviceUrl": "Enter the URL of the device",
    "gui.deviceLibrary.arduinoTag": "Arduino",
    "gui.deviceLibrary.microPythonTag": "MicroPython",
    "gui.deviceLibrary.kitTag": "Kit",
    "gui.deviceLibrary.sensorTag": "Sensor",
    "gui.extensionLibrary.chooseAnExtension": "Choose an Extension",
    "gui.extensionLibrary.extensionUrl": "Enter the URL of the extension",
    "gui.library.shieldTag": "Shield",
    "gui.library.actuatorTag": "Actuator",
    "gui.library.sensorTag": "Sensor",
    "gui.library.displayTag": "Display",
    "gui.library.communicationTag": "Communication",
    "gui.library.otherTag": "Other",
    "gui.hardwareConsole.noLineTerminators": "No line terminators",
    "gui.hardwareConsole.lineFeed": "Line feed",
    "gui.hardwareConsole.carriageReturn": "Carriage return",
    "gui.hardwareConsole.lfAndCr": "LF & CR",
    "gui.monitors.importListColumnPrompt": "Which column should be used (1-{numberOfColumns})?",
    "gui.recordingStep.alertMsg": "Could not start recording",
    "gui.soundLibrary.chooseASound": "Choose a Sound",
    "gui.soundTab.fileUploadSound": "Upload Sound",
    "gui.soundTab.surpriseSound": "Surprise",
    "gui.soundTab.recordSound": "Record",
    "gui.soundTab.addSoundFromLibrary": "Choose a Sound",
    "gui.spriteLibrary.chooseASprite": "Choose a Sprite",
    "gui.tipsLibrary.tutorials": "Choose a Tutorial",
    "gui.updateModal.updateWarning": "Currently unsaved projects will be lost, continue update and restart?",
    "gui.uploadProgress.uploadErrorMessage": "Upload error",
    "gui.uploadProgress.uploadTimeoutMessage": "Upload timeout",
    "gui.alerts.createsuccess": "New project created.",
    "gui.alerts.createcopysuccess": "Project saved as a copy.",
    "gui.alerts.createremixsuccess": "Project saved as a remix.",
    "gui.alerts.creating": "Creating new…",
    "gui.alerts.creatingCopy": "Copying project…",
    "gui.alerts.creatingRemix": "Remixing project…",
    "gui.alerts.creatingError": "Could not create the project. Please try again!",
    "gui.alerts.savingError": "Project could not save.",
    "gui.alerts.savesuccess": "Project saved.",
    "gui.alerts.saving": "Saving project…",
    "gui.alerts.cloudInfo": "Please note, cloud variables only support numbers, not letters or symbols. {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "Learn more.",
    "gui.alerts.importing": "Importing…",
    "gui.alerts.workspaceIsEmpty": "Workspace is empty",
    "gui.alerts.workspaceIsNotEmpty": "Workspace is not empty, plese clean you workspace first",
    "gui.alerts.uploadError": "Upload error",
    "gui.alerts.uploadSuccess": "Upload success",
    "gui.alerts.selectADeviceFirst": "Plese select a device first",
    "gui.alerts.connectAPeripheralFirst": "Plese connect a peripheral first",
    "gui.alerts.codeEditorIsLocked": "Code editor is in lock state, if you want to edit the code, please click the unlock button first",
    "gui.alerts.codeEditorIsUnlocked": "Code editor is in unlock state, if you want to generate code from block, please click the lock button first",
    "gui.defaultProject.chirp": "Chirp",
    "gui.defaultProject.variable": "my variable",
    "gui.howtos.intro-move-sayhello-hat.name": "Getting Started",
    "gui.howtos.intro-move.step_stepMove": "Add a move block",
    "gui.howtos.add-a-move-block.step_stepSay": "Add a say block",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Click the green flag to start",
    "gui.howtos.intro-getting-started-ASL.name": "Getting Started - ASL",
    "gui.howtos.animate-a-name.name": "Animate a Name",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "Pick a Letter Sprite",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "Play a Sound When Clicked",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "Pick Another Letter Sprite",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "Change color",
    "gui.howtos.animate-a-name.step_AnimateSpin": "Pick Another Letter Sprite & Make It Spin",
    "gui.howtos.animate-a-name.step_AnimateGrow": "Pick Another Letter Sprite & Make It Grow",
    "gui.howtos.imagine": "Imagine a World",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Type What You Want to Say",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Click the Green Flag to Start",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Choose Any Backdrop",
    "gui.howtos.imagine.step_imagineChooseSprite": "Choose Any Sprite",
    "gui.howtos.imagine.step_imagineFlyAround": "Press the Space Key to Glide",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Choose Another Sprite",
    "gui.howtos.imagine.step_imagineLeftRight": "Move Left-Right",
    "gui.howtos.imagine.step_imagineUpDown": "Move Up-Down",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Change Costumes",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Glide to a Point",
    "gui.howtos.imagine.step_imagineGrowShrink": "Grow and Shrink",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Choose Another Backdrop",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "Switch Backdrops",
    "gui.howtos.imagine.step_imagineRecordASound": "Add a Sound",
    "gui.howtos.imagine.step_imagineChooseSound": "Choose Your Sound",
    "gui.howtos.make-music.name": "Make Music",
    "gui.howtos.Make-Music.step_PickInstrument": "Pick an Instrument Sprite",
    "gui.howtos.Make-Music.step_PlaySoundClick": "Play Sound When Clicked",
    "gui.howtos.Make-Music.step_MakeSong": "Create a Song",
    "gui.howtos.make-music.step_MakeBeat": "Choose a Drum & Make a Beat",
    "gui.howtos.make-music.step_MakeBeatBox": "Choose the Microphone Sprite & Surprise Beatbox",
    "gui.howtos.story.name": "Create A Story",
    "gui.howtos.story.step_addbg": "Add a Backdrop",
    "gui.howtos.story.step_addsprite": "Add a Character",
    "gui.howtos.story.step_saysomething": "Say Something",
    "gui.howtos.story.step_addanothersprite": "Add Another Character",
    "gui.howtos.story.step_flip": "Flip Direction",
    "gui.howtos.story.step_conversation": "Have A Conversation",
    "gui.howtos.story.addanotherbg": "Add Another Backdrop",
    "gui.howtos.story.step_swithbg": "Switch Backdrops",
    "gui.howtos.story.step_hidewizard": "Hide a Character",
    "gui.howtos.story.step_showwizard": "Show a Character",
    "gui.howtos.make-a-chase-game.name": "Make a Chase Game",
    "gui.howtos.Chase-Game.step_BG": "Add a Backdrop",
    "gui.howtos.chase-game.step_AddOcto": "Add a Sprite",
    "gui.howtos.make-music.step_LeftRight": "Move Right & Left With Arrow Keys",
    "gui.howtos.Chase-Game.step_UpDown": "Move Up & Down With Arrow Keys",
    "gui.howtos.Chase-Game.step_AddStar": "Add Another Sprite",
    "gui.howtos.Chase-Game.step_MoveRandom": "Move Randomly",
    "gui.howtos.Chase-Game.step_WhenTouch": "In Octopus Sprite, When Touching Play Sound",
    "gui.howtos.Chase-Game.step_ScoreVariable": "Create Score Variable",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "In Octopus Sprite, When Touching Add Score",
    "gui.howtos.animate-char.name": "Animate A Character",
    "gui.howtos.animate-char.step_addbg": "Add a Backdrop",
    "gui.howtos.animate-char.step_addsprite": "Add a Sprite",
    "gui.howtos.animate-char.step_saysomething": "Say Something",
    "gui.howtos.animate-char.step_addsound": "Add Sound",
    "gui.howtos.animate-char.step_animatetalking": "Animate Talking",
    "gui.howtos.animate-char.step_arrowkeys": "Move Using Arrow Keys",
    "gui.howtos.animate-char.step_jump": "Jump",
    "gui.howtos.animate-char.step_changecolor": "Change Color",
    "gui.howtos.make-a-game.name": "Make a Clicker Game",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "Pick A Sprite",
    "gui.howtos.make-a-game.step_GamePlaySound": "Play Sound When Clicked",
    "gui.howtos.make-a-game.step_GameAddScore": "Create Score Variable",
    "gui.howtos.make-a-game.step_GameChangeScore": "When Clicked Increase Score",
    "gui.howtos.make-a-game.step_Random": "Go to a random position",
    "gui.howtos.make-music.step_GameChangeColor": "Change Color",
    "gui.howtos.make-music.step_ResetScore": "Reset Score",
    "gui.howtos.make-it-fly.name": "Make it Fly",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Choose a Sky Background",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Choose a Character",
    "gui.howtos.fly.step_stepflySaySomething": "Say Something",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Move With Arrow Keys",
    "gui.howtos.fly.step_stepflyChooseObject": "Choose an Object to Collect",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Make the Object Move",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Select Your Character",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Add a Score",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Keep Score",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Add Scenery",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Move the Scenery",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Next Costume",
    "gui.howtos.pong": "Pong Game",
    "gui.howtos.pong.step_pongAddBackdrop": "Add a Backdrop",
    "gui.howtos.pong.step_pongAddBallSprite": "Add a Ball Sprite",
    "gui.howtos.pong.step_pongBounceAround": "Bounce Around",
    "gui.howtos.pong.step_pongAddPaddle": "Add a Paddle",
    "gui.howtos.pong.step_pongMoveThePaddle": "Move the Paddle",
    "gui.howtos.pong.step_pongSelectBallSprite": "Select the Ball Sprite",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Add Code to Bounce the Ball Off the Paddle",
    "gui.howtos.pong.step_pongAddAScore": "Add a Score",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Choose 'Score' from the Menu",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Insert the 'Change Score' Block",
    "gui.howtos.pong.step_pongResetScore": "Reset Score",
    "gui.howtos.pong.step_pongAddLineSprite": "Add the Line Sprite",
    "gui.howtos.pong.step_pongGameOver": "Game Over",
    "gui.howtos.code-cartoon": "Code a Cartoon",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Say Something When You Click the Green Flag",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Animate a Character When You Click It",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Select a Different Character",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Use a Minus Sign to Get Smaller",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Make a Character Grow and Shrink",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Select a Different Character",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Jump Up and Down",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Click a Character to Change Scenes",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Glide Around",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Change Costumes",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Choose More Characters to Add to Your Cartoon",
    "gui.howtos.cartoon-network": "Animate an Adventure Game",
    "gui.howtos.cartoon-network.step_CNcharacter": "Choose a Character to Show",
    "gui.howtos.cartoon-network.step_CNsay": "Say Something",
    "gui.howtos.cartoon-network.step_CNglide": "Glide Around",
    "gui.howtos.cartoon-network.step_CNpicksprite": "Choose an Object to Chase",
    "gui.howtos.cartoon-network.step_CNcollect": "Collect Objects",
    "gui.howtos.cartoon-network.step_CNvariable": "Make a Score Variable",
    "gui.howtos.cartoon-network.step_CNscore": "Keep Score",
    "gui.howtos.cartoon-network.step_CNbackdrop": "Level Up: Change Backdrop",
    "gui.howtos.videosens.name": "Video Sensing",
    "gui.howtos.videosens.step_addextension": "Add Extension",
    "gui.howtos.videosens.step_pet": "Pet the Cat",
    "gui.howtos.videosens.step_animate": "Animate",
    "gui.howtos.videosens.step_pop": "Pop a Balloon",
    "gui.howtos.say-it-out-loud": "Create Animations That Talk",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "Add the Text to Speech blocks",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "Say Something",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "Set a Voice",
    "gui.howtos.say-it-out-loud.step_TXTMove": "Move Around",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "Add a Backdrop",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "Add Another Character",
    "gui.howtos.say-it-out-loud.step_TXTSong": "Perform a Song",
    "gui.howtos.say-it-out-loud.step_TXTColor": "Change Color",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "Spin Around",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "Grow and Shrink",
    "gui.howtos.talking": "Talking Tales",
    "gui.howtos.talking.step_talesAddExtension": "Click to Add the Text-to-Speech Blocks",
    "gui.howtos.talking.step_talesChooseSprite": "Choose a Sprite",
    "gui.howtos.talking.step_talesSaySomething": "Make a Character Speak",
    "gui.howtos.talking.step_talesChooseBackdrop": "Choose a Backdrop",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Click a Character to Go to the Next Backdrop",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Choose Another Sprite",
    "gui.howtos.talking.step_talesMoveAround": "Move Around",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Choose Another Backdrop",
    "gui.howtos.talking.step_talesAnimateTalking": "Animate Talking",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Choose Another Backdrop",
    "gui.howtos.talking.step_talesChooseSound": "Choose a Song to Dance To",
    "gui.howtos.talking.step_talesDanceMoves": "Dance Moves",
    "gui.howtos.talking.step_talesAskAnswer": "Get the Ask and Answer Blocks from the Sensing Category",
    "gui.howtos.add-sprite.name": "Add a Sprite",
    "gui.howtos.add-sprite.step_addSprite": "Add a Sprite",
    "gui.howtos.add-a-backdrop.name": "Add a Backdrop",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "Add a Backdrop",
    "gui.howtos.change-size.name": "Change Size",
    "gui.howtos.change-size.step_changeSize": "Change Size",
    "gui.howtos.glide-around.name": "Glide Around",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "Glide Around",
    "gui.howtos.change-size.step_glideAroundPoint": "Glide to a Point",
    "gui.howtos.record-a-sound.name": "Record a Sound",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "Click on the 'Sounds' Tab",
    "gui.howtos.change-size.step_recordASoundClickRecord": "Click 'Record'",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Press the Record Button",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Choose Your Sound",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "Play Your Sound",
    "gui.howtos.spin-video.name": "Make It Spin",
    "gui.howtos.change-size.step_spinTurn": "Turn",
    "gui.howtos.change-size.step_spinPointInDirection": "Set Direction",
    "gui.howtos.hide-and-show.name": "Hide and Show",
    "gui.howtos.change-size.step_hideAndShow": "Hide and Show",
    "gui.howtos.switch-costume.name": "Animate a Sprite",
    "gui.howtos.change-size.step_switchCostumes": "Animate a Sprite",
    "gui.howtos.move-around-with-arrow-keys.name": "Use Arrow Keys",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "Move Left and Right",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Move Up and Down",
    "gui.howtos.add-effects.name": "Add Effects",
    "gui.howtos.videosens.step_addEffects": "Add Effects",
    "gui.device.esp32.description": "Wi-Fi & Bluetooth control board with rich functions.",
    "gui.device.esp32.connectingMessage": "Connecting",
    "gui.device.esp8266NodeMCU.description": "Low-cost Wi-Fi SOC control board.",
    "gui.device.esp8266NodeMCU.connectingMessage": "Connecting",
    "gui.device.unselectDevice.name": "Unselect device",
    "gui.device.unselectDevice.description": "Unselect the device, return to pure realtime programming mode.",
    "gui.device.arduinoUno.description": "A great board to get started with electronics and coding.",
    "gui.device.arduinoUno.connectingMessage": "Connecting",
    "gui.device.arduinoNano.description": "The Arduino Nano is a classic small board to build your projects with.",
    "gui.device.arduinoNano.connectingMessage": "Connecting",
    "gui.device.arduinoLeonardo.description": "The classic Arduino board that can act as a mouse or keyboard.",
    "gui.device.arduinoLeonardo.connectingMessage": "Connecting",
    "gui.device.arduinoMega2560.description": "The 8-bit board with 54 digital pins, 16 analog inputs, and 4 serial ports.",
    "gui.device.arduinoMega2560.connectingMessage": "Connecting",
    "gui.device.microbit.description": "The pocket-sized computer transforming digital skills learning.",
    "gui.device.microbit.connectingMessage": "Connecting",
    "gui.device.microbitV2.description": "Upgraded processor, built-In speaker and microphone, touch sensitive logo.",
    "gui.device.microbitV2.connectingMessage": "Connecting",
    "gui.device.makeymakey.description": "Make anything into a key.",
    "gui.device.makeyMakey.connectingMessage": "Connecting",
    "gui.device.k210MaixDock.description": "A control board based on the K210 RISC-V chip that only has basic functions and leads out all IO pins.",
    "gui.device.k210MaixDock.connectingMessage": "Connecting",
    "gui.device.k210Maixduino.description": "The K210 RISC-V board with ESP32 inside.",
    "gui.device.k210Maixduino.connectingMessage": "Connecting",
    "gui.device.raspberryPiPicoIconURL.description": "The powerful, flexible microcontroller board.",
    "gui.device.raspberryPiPicoIconURL.connectingMessage": "Connecting",
    "gui.extension.music.name": "Music",
    "gui.extension.music.description": "Play instruments and drums.",
    "gui.extension.pen.name": "Pen",
    "gui.extension.pen.description": "Draw with your sprites.",
    "gui.extension.videosensing.name": "Video Sensing",
    "gui.extension.videosensing.description": "Sense motion with the camera.",
    "gui.extension.text2speech.name": "Text to Speech",
    "gui.extension.text2speech.description": "Make your projects talk.",
    "gui.extension.translate.name": "Translate",
    "gui.extension.translate.description": "Translate text into many languages.",
    "gui.extension.makeymakey.name": "Makey Makey",
    "gui.extension.makeymakey.description": "Make anything into a key.",
    "gui.libraryTags.all": "All",
    "gui.libraryTags.animals": "Animals",
    "gui.libraryTags.dance": "Dance",
    "gui.libraryTags.effects": "Effects",
    "gui.libraryTags.fantasy": "Fantasy",
    "gui.libraryTags.fashion": "Fashion",
    "gui.libraryTags.food": "Food",
    "gui.libraryTags.indoors": "Indoors",
    "gui.libraryTags.loops": "Loops",
    "gui.libraryTags.music": "Music",
    "gui.libraryTags.notes": "Notes",
    "gui.libraryTags.outdoors": "Outdoors",
    "gui.libraryTags.patterns": "Patterns",
    "gui.libraryTags.people": "People",
    "gui.libraryTags.percussion": "Percussion",
    "gui.libraryTags.space": "Space",
    "gui.libraryTags.sports": "Sports",
    "gui.libraryTags.underwater": "Underwater",
    "gui.libraryTags.voice": "Voice",
    "gui.libraryTags.wacky": "Wacky",
    "gui.libraryTags.animation": "Animation",
    "gui.libraryTags.art": "Art",
    "gui.libraryTags.games": "Games",
    "gui.libraryTags.stories": "Stories",
    "gui.libraryTags.letters": "Letters",
    "gui.opcodeLabels.direction": "direction",
    "gui.opcodeLabels.xposition": "x position",
    "gui.opcodeLabels.yposition": "y position",
    "gui.opcodeLabels.size": "size",
    "gui.opcodeLabels.costumename": "costume name",
    "gui.opcodeLabels.costumenumber": "costume number",
    "gui.opcodeLabels.backdropname": "backdrop name",
    "gui.opcodeLabels.backdropnumber": "backdrop number",
    "gui.opcodeLabels.volume": "volume",
    "gui.opcodeLabels.tempo": "tempo",
    "gui.opcodeLabels.answer": "answer",
    "gui.opcodeLabels.loudness": "loudness",
    "gui.opcodeLabels.username": "username",
    "gui.opcodeLabels.year": "year",
    "gui.opcodeLabels.month": "month",
    "gui.opcodeLabels.date": "date",
    "gui.opcodeLabels.dayofweek": "day of week",
    "gui.opcodeLabels.hour": "hour",
    "gui.opcodeLabels.minute": "minute",
    "gui.opcodeLabels.second": "second",
    "gui.opcodeLabels.timer": "timer",
    "gui.projectLoader.loadError": "The project file that was selected failed to load.",
    "gui.sharedMessages.backdrop": "backdrop{index}",
    "gui.sharedMessages.costume": "costume{index}",
    "gui.sharedMessages.sprite": "Sprite{index}",
    "gui.sharedMessages.pop": "pop",
    "gui.sharedMessages.replaceProjectWarning": "Replace contents of the current project?",
    "gui.sharedMessages.clearCacheWarning": "Make sure you want to clear cache and restart?",
    "gui.sharedMessages.loadFromComputerTitle": "Load from your computer",
    "gui.gui.defaultProjectTitle": "Scratch Project",
    "gui.desktopMenuBar.about": "About",
    "gui.desktopMenuBar.license": "License",
    "gui.menuBar.privacyPolicy": "Privacy policy",
    "gui.menuBar.dataSettings": "Data settings",
    "arduinoEsp32.InterrupModeMenu.changeEdge": "change edge",
    "arduinoEsp32.InterrupModeMenu.fallingEdge": "falling edge",
    "arduinoEsp32.InterrupModeMenu.high": "high level",
    "arduinoEsp32.InterrupModeMenu.low": "low level",
    "arduinoEsp32.InterrupModeMenu.risingEdge": "rising edge",
    "arduinoEsp32.category.data": "Data",
    "arduinoEsp32.category.pins": "Pins",
    "arduinoEsp32.category.serial": "Serial",
    "arduinoEsp32.data.dataConstrain": "constrain [DATA] between ([ARG0], [ARG1])",
    "arduinoEsp32.data.dataConvert": "convert [DATA] to [TYPE]",
    "arduinoEsp32.data.dataConvertASCIICharacter": "convert [DATA] to ASCII character",
    "arduinoEsp32.data.dataConvertASCIINumber": "convert [DATA] to ASCII nubmer",
    "arduinoEsp32.data.dataMap": "map [DATA] from ([ARG0], [ARG1]) to ([ARG2], [ARG3])",
    "arduinoEsp32.dataTypeMenu.decimal": "decimal",
    "arduinoEsp32.dataTypeMenu.integer": "integer",
    "arduinoEsp32.dataTypeMenu.string": "string",
    "arduinoEsp32.eolMenu.noWarp": "no-warp",
    "arduinoEsp32.eolMenu.warp": "warp",
    "arduinoEsp32.levelMenu.high": "high",
    "arduinoEsp32.levelMenu.low": "low",
    "arduinoEsp32.modeMenu.input": "input",
    "arduinoEsp32.modeMenu.inputPulldown": "input-pulldown",
    "arduinoEsp32.modeMenu.inputPullup": "input-pullup",
    "arduinoEsp32.modeMenu.output": "output",
    "arduinoEsp32.pins.esp32AttachInterrupt": "attach interrupt pin [PIN] mode [MODE] executes",
    "arduinoEsp32.pins.esp32DetachInterrupt": "detach interrupt pin [PIN]",
    "arduinoEsp32.pins.esp32ReadTouchPin": "read touch pin [PIN]",
    "arduinoEsp32.pins.esp32SetDACOutput": "set dac pin [PIN] out [OUT]",
    "arduinoEsp32.pins.esp32SetPwmOutput": "set pwm pin [PIN] use channel [CH] out [OUT]",
    "arduinoEsp32.pins.readAnalogPin": "read analog pin [PIN]",
    "arduinoEsp32.pins.readDigitalPin": "read digital pin [PIN]",
    "arduinoEsp32.pins.setDigitalOutput": "set digital pin [PIN] out [LEVEL]",
    "arduinoEsp32.pins.setPinMode": "set pin [PIN] mode [MODE]",
    "arduinoEsp32.pins.setServoOutput": "set servo pin [PIN] use channel [CH] out [OUT]",
    "arduinoEsp32.serial.multiSerialAvailable": "serial [NO] available data length",
    "arduinoEsp32.serial.multiSerialBegin": "serial [NO] begin baudrate [VALUE]",
    "arduinoEsp32.serial.multiSerialPrint": "serial [NO] print [VALUE] [EOL]",
    "arduinoEsp32.serial.multiSerialReadAByte": "serial [NO] read a byte",
    "arduinoEsp8266.InterrupModeMenu.changeEdge": "change edge",
    "arduinoEsp8266.InterrupModeMenu.fallingEdge": "falling edge",
    "arduinoEsp8266.InterrupModeMenu.risingEdge": "rising edge",
    "arduinoEsp8266.category.data": "Data",
    "arduinoEsp8266.category.pins": "Pins",
    "arduinoEsp8266.category.serial": "Serial",
    "arduinoEsp8266.data.dataConstrain": "constrain [DATA] between ([ARG0], [ARG1])",
    "arduinoEsp8266.data.dataConvert": "convert [DATA] to [TYPE]",
    "arduinoEsp8266.data.dataConvertASCIICharacter": "convert [DATA] to ASCII character",
    "arduinoEsp8266.data.dataConvertASCIINumber": "convert [DATA] to ASCII nubmer",
    "arduinoEsp8266.data.dataMap": "map [DATA] from ([ARG0], [ARG1]) to ([ARG2], [ARG3])",
    "arduinoEsp8266.dataTypeMenu.decimal": "decimal",
    "arduinoEsp8266.dataTypeMenu.integer": "integer",
    "arduinoEsp8266.dataTypeMenu.string": "string",
    "arduinoEsp8266.eolMenu.noWarp": "no-warp",
    "arduinoEsp8266.eolMenu.warp": "warp",
    "arduinoEsp8266.levelMenu.high": "high",
    "arduinoEsp8266.levelMenu.low": "low",
    "arduinoEsp8266.modeMenu.input": "input",
    "arduinoEsp8266.modeMenu.inputPullup": "input-pullup",
    "arduinoEsp8266.modeMenu.output": "output",
    "arduinoEsp8266.pins.detachInterrupt": "detach interrupt pin [PIN]",
    "arduinoEsp8266.pins.esp8266AttachInterrupt": "attach interrupt pin [PIN] mode [MODE] executes",
    "arduinoEsp8266.pins.readAnalogPin": "read analog pin [PIN]",
    "arduinoEsp8266.pins.readDigitalPin": "read digital pin [PIN]",
    "arduinoEsp8266.pins.setDigitalOutput": "set digital pin [PIN] out [LEVEL]",
    "arduinoEsp8266.pins.setPinMode": "set pin [PIN] mode [MODE]",
    "arduinoEsp8266.pins.setPwmOutput": "set pwm pin [PIN] out [OUT]",
    "arduinoEsp8266.pins.setServoOutput": "set servo pin [PIN] out [OUT]",
    "arduinoEsp8266.serial.serialAvailable": "serial available data length",
    "arduinoEsp8266.serial.serialBegin": "serial begin baudrate [VALUE]",
    "arduinoEsp8266.serial.serialPrint": "serial print [VALUE] [EOL]",
    "arduinoEsp8266.serial.serialReadAByte": "serial read a byte",
    "arduinoK210.InterrupModeMenu.changeEdge": "change edge",
    "arduinoK210.InterrupModeMenu.fallingEdge": "falling edge",
    "arduinoK210.InterrupModeMenu.high": "high level",
    "arduinoK210.InterrupModeMenu.low": "low level",
    "arduinoK210.InterrupModeMenu.risingEdge": "rising edge",
    "arduinoK210.category.data": "Data",
    "arduinoK210.category.pins": "Pins",
    "arduinoK210.category.serial": "Serial",
    "arduinoK210.data.dataConstrain": "constrain [DATA] between ([ARG0], [ARG1])",
    "arduinoK210.data.dataConvert": "convert [DATA] to [TYPE]",
    "arduinoK210.data.dataConvertASCIICharacter": "convert [DATA] to ASCII character",
    "arduinoK210.data.dataConvertASCIINumber": "convert [DATA] to ASCII nubmer",
    "arduinoK210.data.dataMap": "map [DATA] from ([ARG0], [ARG1]) to ([ARG2], [ARG3])",
    "arduinoK210.dataTypeMenu.decimal": "decimal",
    "arduinoK210.dataTypeMenu.integer": "integer",
    "arduinoK210.dataTypeMenu.string": "string",
    "arduinoK210.eolMenu.noWarp": "no-warp",
    "arduinoK210.eolMenu.warp": "warp",
    "arduinoK210.levelMenu.high": "high",
    "arduinoK210.levelMenu.low": "low",
    "arduinoK210.modeMenu.input": "input",
    "arduinoK210.modeMenu.inputPulldown": "input-pulldown",
    "arduinoK210.modeMenu.inputPullup": "input-pullup",
    "arduinoK210.modeMenu.output": "output",
    "arduinoK210.pins.attachInterrupt": "attach interrupt pin [PIN] mode [MODE] executes",
    "arduinoK210.pins.detachInterrupt": "detach interrupt pin [PIN]",
    "arduinoK210.pins.readDigitalPin": "read digital pin [PIN]",
    "arduinoK210.pins.setDigitalOutput": "set digital pin [PIN] out [LEVEL]",
    "arduinoK210.pins.setPinMode": "set pin [PIN] mode [MODE]",
    "arduinoK210.pins.setPwmOutput": "set pwm pin [PIN] out [OUT]",
    "arduinoK210.pins.setServoOutput": "set servo pin [PIN] out [OUT]",
    "arduinoK210.serial.multiSerialAvailable": "serial [NO] available data length",
    "arduinoK210.serial.multiSerialBegin": "serial [NO] begin baudrate [BAUD] pin RX [RX_PIN] TX [TX_PIN]",
    "arduinoK210.serial.multiSerialPrint": "serial [NO] print [VALUE] [EOL]",
    "arduinoK210.serial.multiSerialReadAByte": "serial [NO] read a byte",
    "arduinoLeonardo.InterrupModeMenu.changeEdge": "change edge",
    "arduinoLeonardo.InterrupModeMenu.fallingEdge": "falling edge",
    "arduinoLeonardo.InterrupModeMenu.low": "low",
    "arduinoLeonardo.InterrupModeMenu.risingEdge": "rising edge",
    "arduinoLeonardo.category.data": "Data",
    "arduinoLeonardo.category.pins": "Pins",
    "arduinoLeonardo.category.serial": "Serial",
    "arduinoLeonardo.data.dataConstrain": "constrain [DATA] between ([ARG0], [ARG1])",
    "arduinoLeonardo.data.dataConvert": "convert [DATA] to [TYPE]",
    "arduinoLeonardo.data.dataConvertASCIICharacter": "convert [DATA] to ASCII character",
    "arduinoLeonardo.data.dataConvertASCIINumber": "convert [DATA] to ASCII nubmer",
    "arduinoLeonardo.data.dataMap": "map [DATA] from ([ARG0], [ARG1]) to ([ARG2], [ARG3])",
    "arduinoLeonardo.dataTypeMenu.decimal": "decimal",
    "arduinoLeonardo.dataTypeMenu.integer": "integer",
    "arduinoLeonardo.dataTypeMenu.string": "string",
    "arduinoLeonardo.eolMenu.noWarp": "no-warp",
    "arduinoLeonardo.eolMenu.warp": "warp",
    "arduinoLeonardo.levelMenu.high": "high",
    "arduinoLeonardo.levelMenu.low": "low",
    "arduinoLeonardo.modeMenu.input": "input",
    "arduinoLeonardo.modeMenu.inputPullup": "input-pullup",
    "arduinoLeonardo.modeMenu.output": "output",
    "arduinoLeonardo.pins.attachInterrupt": "attach interrupt pin [PIN] mode [MODE] executes",
    "arduinoLeonardo.pins.detachInterrupt": "detach interrupt pin [PIN]",
    "arduinoLeonardo.pins.readAnalogPin": "read analog pin [PIN]",
    "arduinoLeonardo.pins.readDigitalPin": "read digital pin [PIN]",
    "arduinoLeonardo.pins.setDigitalOutput": "set digital pin [PIN] out [LEVEL]",
    "arduinoLeonardo.pins.setPinMode": "set pin [PIN] mode [MODE]",
    "arduinoLeonardo.pins.setPwmOutput": "set pwm pin [PIN] out [OUT]",
    "arduinoLeonardo.pins.setServoOutput": "set servo pin [PIN] out [OUT]",
    "arduinoLeonardo.serial.serialAvailable": "serial available data length",
    "arduinoLeonardo.serial.serialBegin": "serial begin baudrate [VALUE]",
    "arduinoLeonardo.serial.serialPrint": "serial print [VALUE] [EOL]",
    "arduinoLeonardo.serial.serialReadAByte": "serial read a byte",
    "arduinoMega2560.InterrupModeMenu.changeEdge": "change edge",
    "arduinoMega2560.InterrupModeMenu.fallingEdge": "falling edge",
    "arduinoMega2560.InterrupModeMenu.low": "low",
    "arduinoMega2560.InterrupModeMenu.risingEdge": "rising edge",
    "arduinoMega2560.category.data": "Data",
    "arduinoMega2560.category.pins": "Pins",
    "arduinoMega2560.category.serial": "Serial",
    "arduinoMega2560.data.dataConstrain": "constrain [DATA] between ([ARG0], [ARG1])",
    "arduinoMega2560.data.dataConvert": "convert [DATA] to [TYPE]",
    "arduinoMega2560.data.dataConvertASCIICharacter": "convert [DATA] to ASCII character",
    "arduinoMega2560.data.dataConvertASCIINumber": "convert [DATA] to ASCII nubmer",
    "arduinoMega2560.data.dataMap": "map [DATA] from ([ARG0], [ARG1]) to ([ARG2], [ARG3])",
    "arduinoMega2560.dataTypeMenu.decimal": "decimal",
    "arduinoMega2560.dataTypeMenu.integer": "integer",
    "arduinoMega2560.dataTypeMenu.string": "string",
    "arduinoMega2560.eolMenu.noWarp": "no-warp",
    "arduinoMega2560.eolMenu.warp": "warp",
    "arduinoMega2560.levelMenu.high": "high",
    "arduinoMega2560.levelMenu.low": "low",
    "arduinoMega2560.modeMenu.input": "input",
    "arduinoMega2560.modeMenu.inputPullup": "input-pullup",
    "arduinoMega2560.modeMenu.output": "output",
    "arduinoMega2560.pins.attachInterrupt": "attach interrupt pin [PIN] mode [MODE] executes",
    "arduinoMega2560.pins.detachInterrupt": "detach interrupt pin [PIN]",
    "arduinoMega2560.pins.readAnalogPin": "read analog pin [PIN]",
    "arduinoMega2560.pins.readDigitalPin": "read digital pin [PIN]",
    "arduinoMega2560.pins.setDigitalOutput": "set digital pin [PIN] out [LEVEL]",
    "arduinoMega2560.pins.setPinMode": "set pin [PIN] mode [MODE]",
    "arduinoMega2560.pins.setPwmOutput": "set pwm pin [PIN] out [OUT]",
    "arduinoMega2560.pins.setServoOutput": "set servo pin [PIN] out [OUT]",
    "arduinoMega2560.serial.multiSerialAvailable": "serial [NO] available data length",
    "arduinoMega2560.serial.multiSerialBegin": "serial [NO] begin baudrate [VALUE]",
    "arduinoMega2560.serial.multiSerialPrint": "serial [NO] print [VALUE] [EOL]",
    "arduinoMega2560.serial.multiSerialReadAByte": "serial [NO] read a byte",
    "arduinoPeripheral.connection.connectFirmataTimeout": "Timeout when try to connect firmata, please download the firmware first",
    "arduinoRaspberryPiPico.InterrupModeMenu.changeEdge": "change edge",
    "arduinoRaspberryPiPico.InterrupModeMenu.fallingEdge": "falling edge",
    "arduinoRaspberryPiPico.InterrupModeMenu.high": "high level",
    "arduinoRaspberryPiPico.InterrupModeMenu.low": "low level",
    "arduinoRaspberryPiPico.InterrupModeMenu.risingEdge": "rising edge",
    "arduinoRaspberryPiPico.category.data": "Data",
    "arduinoRaspberryPiPico.category.pins": "Pins",
    "arduinoRaspberryPiPico.category.serial": "Serial",
    "arduinoRaspberryPiPico.data.dataConstrain": "constrain [DATA] between ([ARG0], [ARG1])",
    "arduinoRaspberryPiPico.data.dataConvert": "convert [DATA] to [TYPE]",
    "arduinoRaspberryPiPico.data.dataConvertASCIICharacter": "convert [DATA] to ASCII character",
    "arduinoRaspberryPiPico.data.dataConvertASCIINumber": "convert [DATA] to ASCII nubmer",
    "arduinoRaspberryPiPico.data.dataMap": "map [DATA] from ([ARG0], [ARG1]) to ([ARG2], [ARG3])",
    "arduinoRaspberryPiPico.dataTypeMenu.decimal": "decimal",
    "arduinoRaspberryPiPico.dataTypeMenu.integer": "integer",
    "arduinoRaspberryPiPico.dataTypeMenu.string": "string",
    "arduinoRaspberryPiPico.eolMenu.noWarp": "no-warp",
    "arduinoRaspberryPiPico.eolMenu.warp": "warp",
    "arduinoRaspberryPiPico.levelMenu.high": "high",
    "arduinoRaspberryPiPico.levelMenu.low": "low",
    "arduinoRaspberryPiPico.modeMenu.input": "input",
    "arduinoRaspberryPiPico.modeMenu.inputPulldown": "input-pulldown",
    "arduinoRaspberryPiPico.modeMenu.inputPullup": "input-pullup",
    "arduinoRaspberryPiPico.modeMenu.output": "output",
    "arduinoRaspberryPiPico.pins.attachInterrupt": "attach interrupt pin [PIN] mode [MODE] executes",
    "arduinoRaspberryPiPico.pins.detachInterrupt": "detach interrupt pin [PIN]",
    "arduinoRaspberryPiPico.pins.readAnalogPin": "read analog pin [PIN]",
    "arduinoRaspberryPiPico.pins.readDigitalPin": "read digital pin [PIN]",
    "arduinoRaspberryPiPico.pins.setDigitalOutput": "set digital pin [PIN] out [LEVEL]",
    "arduinoRaspberryPiPico.pins.setPinMode": "set pin [PIN] mode [MODE]",
    "arduinoRaspberryPiPico.pins.setPwmOutput": "set pwm pin [PIN] out [OUT]",
    "arduinoRaspberryPiPico.pins.setServoOutput": "set servo pin [PIN] out [OUT]",
    "arduinoRaspberryPiPico.serial.multiSerialAvailable": "serial [NO] available data length",
    "arduinoRaspberryPiPico.serial.multiSerialPrint": "serial [NO] print [VALUE] [EOL]",
    "arduinoRaspberryPiPico.serial.multiSerialReadAByte": "serial [NO] read a byte",
    "arduinoRaspberryPiPico.serial.raspberryPiPicoMultiSerialBegin": "serial [NO] begin baudrate [VALUE]",
    "arduinoUno.InterrupModeMenu.changeEdge": "change edge",
    "arduinoUno.InterrupModeMenu.fallingEdge": "falling edge",
    "arduinoUno.InterrupModeMenu.low": "low",
    "arduinoUno.InterrupModeMenu.risingEdge": "rising edge",
    "arduinoUno.category.data": "Data",
    "arduinoUno.category.pins": "Pins",
    "arduinoUno.category.serial": "Serial",
    "arduinoUno.data.dataConstrain": "constrain [DATA] between ([ARG0], [ARG1])",
    "arduinoUno.data.dataConvert": "convert [DATA] to [TYPE]",
    "arduinoUno.data.dataConvertASCIICharacter": "convert [DATA] to ASCII character",
    "arduinoUno.data.dataConvertASCIINumber": "convert [DATA] to ASCII nubmer",
    "arduinoUno.data.dataMap": "map [DATA] from ([ARG0], [ARG1]) to ([ARG2], [ARG3])",
    "arduinoUno.dataTypeMenu.decimal": "decimal",
    "arduinoUno.dataTypeMenu.integer": "integer",
    "arduinoUno.dataTypeMenu.string": "string",
    "arduinoUno.eolMenu.noWarp": "no-warp",
    "arduinoUno.eolMenu.warp": "warp",
    "arduinoUno.levelMenu.high": "high",
    "arduinoUno.levelMenu.low": "low",
    "arduinoUno.modeMenu.input": "input",
    "arduinoUno.modeMenu.inputPullup": "input-pullup",
    "arduinoUno.modeMenu.output": "output",
    "arduinoUno.pins.attachInterrupt": "attach interrupt pin [PIN] mode [MODE] executes",
    "arduinoUno.pins.detachInterrupt": "detach interrupt pin [PIN]",
    "arduinoUno.pins.readAnalogPin": "read analog pin [PIN]",
    "arduinoUno.pins.readDigitalPin": "read digital pin [PIN]",
    "arduinoUno.pins.setDigitalOutput": "set digital pin [PIN] out [LEVEL]",
    "arduinoUno.pins.setPinMode": "set pin [PIN] mode [MODE]",
    "arduinoUno.pins.setPwmOutput": "set pwm pin [PIN] out [OUT]",
    "arduinoUno.pins.setServoOutput": "set servo pin [PIN] out [OUT]",
    "arduinoUno.serial.serialAvailable": "serial available data length",
    "arduinoUno.serial.serialBegin": "serial begin baudrate [VALUE]",
    "arduinoUno.serial.serialPrint": "serial print [VALUE] [EOL]",
    "arduinoUno.serial.serialReadAByte": "serial read a byte",
    "boost.color.any": "any color",
    "boost.color.black": "black",
    "boost.color.blue": "blue",
    "boost.color.green": "green",
    "boost.color.red": "red",
    "boost.color.white": "white",
    "boost.color.yellow": "yellow",
    "boost.getMotorPosition": "motor [MOTOR_REPORTER_ID] position",
    "boost.getTiltAngle": "tilt angle [TILT_DIRECTION]",
    "boost.motorDirection.backward": "that way",
    "boost.motorDirection.forward": "this way",
    "boost.motorDirection.reverse": "reverse",
    "boost.motorOff": "turn motor [MOTOR_ID] off",
    "boost.motorOn": "turn motor [MOTOR_ID] on",
    "boost.motorOnFor": "turn motor [MOTOR_ID] for [DURATION] seconds",
    "boost.motorOnForRotation": "turn motor [MOTOR_ID] for [ROTATION] rotations",
    "boost.seeingColor": "seeing [COLOR] brick?",
    "boost.setLightHue": "set light color to [HUE]",
    "boost.setMotorDirection": "set motor [MOTOR_ID] direction [MOTOR_DIRECTION]",
    "boost.setMotorPower": "set motor [MOTOR_ID] speed to [POWER] %",
    "boost.tiltDirection.any": "any",
    "boost.tiltDirection.down": "down",
    "boost.tiltDirection.left": "left",
    "boost.tiltDirection.right": "right",
    "boost.tiltDirection.up": "up",
    "boost.whenColor": "when [COLOR] brick seen",
    "boost.whenTilted": "when tilted [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "beep note [NOTE] for [TIME] secs",
    "ev3.buttonPressed": "button [PORT] pressed?",
    "ev3.getBrightness": "brightness",
    "ev3.getDistance": "distance",
    "ev3.getMotorPosition": "motor [PORT] position",
    "ev3.motorSetPower": "motor [PORT] set power [POWER] %",
    "ev3.motorTurnClockwise": "motor [PORT] turn this way for [TIME] seconds",
    "ev3.motorTurnCounterClockwise": "motor [PORT] turn that way for [TIME] seconds",
    "ev3.whenBrightnessLessThan": "when brightness < [DISTANCE]",
    "ev3.whenButtonPressed": "when button [PORT] pressed",
    "ev3.whenDistanceLessThan": "when distance < [DISTANCE]",
    "gdxfor.getAcceleration": "acceleration [DIRECTION]",
    "gdxfor.getForce": "force",
    "gdxfor.getSpin": "spin speed [DIRECTION]",
    "gdxfor.getTilt": "tilt angle [TILT]",
    "gdxfor.isFreeFalling": "falling?",
    "gdxfor.isTilted": "tilted [TILT]?",
    "gdxfor.pulled": "pulled",
    "gdxfor.pushed": "pushed",
    "gdxfor.shaken": "shaken",
    "gdxfor.startedFalling": "started falling",
    "gdxfor.tiltDirectionMenu.any": "any",
    "gdxfor.tiltDirectionMenu.back": "back",
    "gdxfor.tiltDirectionMenu.front": "front",
    "gdxfor.tiltDirectionMenu.left": "left",
    "gdxfor.tiltDirectionMenu.right": "right",
    "gdxfor.turnedFaceDown": "turned face down",
    "gdxfor.turnedFaceUp": "turned face up",
    "gdxfor.whenForcePushedOrPulled": "when force sensor [PUSH_PULL]",
    "gdxfor.whenGesture": "when [GESTURE]",
    "gdxfor.whenTilted": "when tilted [TILT]",
    "makeymakey.downArrow": "down arrow",
    "makeymakey.downArrowShort": "down",
    "makeymakey.leftArrow": "left arrow",
    "makeymakey.leftArrowShort": "left",
    "makeymakey.rightArrow": "right arrow",
    "makeymakey.rightArrowShort": "right",
    "makeymakey.spaceKey": "space",
    "makeymakey.upArrow": "up arrow",
    "makeymakey.upArrowShort": "up",
    "makeymakey.whenKeyPressed": "when [KEY] key pressed",
    "makeymakey.whenKeysPressedInOrder": "when [SEQUENCE] pressed in order",
    "microPythonEsp32.InterrupModeMenu.changeEdge": "change edge",
    "microPythonEsp32.InterrupModeMenu.fallingEdge": "falling edge",
    "microPythonEsp32.InterrupModeMenu.high": "high level",
    "microPythonEsp32.InterrupModeMenu.low": "low level",
    "microPythonEsp32.InterrupModeMenu.risingEdge": "rising edge",
    "microPythonEsp32.category.console": "Console",
    "microPythonEsp32.category.pins": "Pins",
    "microPythonEsp32.console.consoleInput": "prompt [TEXT] and read input",
    "microPythonEsp32.console.consolePrint": "print [TEXT] [EOL]",
    "microPythonEsp32.eolMenu.noWarp": "no-warp",
    "microPythonEsp32.eolMenu.warp": "warp",
    "microPythonEsp32.levelMenu.high": "high",
    "microPythonEsp32.levelMenu.low": "low",
    "microPythonEsp32.modeMenu.input": "input",
    "microPythonEsp32.modeMenu.inputPulldown": "input-pulldown",
    "microPythonEsp32.modeMenu.inputPullup": "input-pullup",
    "microPythonEsp32.modeMenu.output": "output",
    "microPythonEsp32.pins.esp32AttachInterrupt": "attach interrupt pin [PIN] mode [MODE] executes",
    "microPythonEsp32.pins.esp32ReadAnalogPin": "read analog pin [PIN]",
    "microPythonEsp32.pins.esp32ReadDigitalPin": "read digital pin [PIN]",
    "microPythonEsp32.pins.esp32ReadTouchPin": "read touch pin [PIN]",
    "microPythonEsp32.pins.esp32SetDACOutput": "set dac pin [PIN] out [OUT]",
    "microPythonEsp32.pins.esp32SetDigitalOutput": "set digital pin [PIN] out [LEVEL]",
    "microPythonEsp32.pins.esp32SetPinMode": "set pin [PIN] mode [MODE]",
    "microPythonEsp32.pins.esp32SetPwmOutput": "set pwm pin [PIN] out [OUT]",
    "microPythonEsp32.pins.setServoOutput": "set servo pin [PIN] out [OUT]",
    "microPythonEsp8266.category.console": "Console",
    "microPythonEsp8266.category.pins": "Pins",
    "microPythonEsp8266.console.consoleInput": "prompt [TEXT] and read input",
    "microPythonEsp8266.console.consolePrint": "print [TEXT] [EOL]",
    "microPythonEsp8266.eolMenu.noWarp": "no-warp",
    "microPythonEsp8266.eolMenu.warp": "warp",
    "microPythonEsp8266.levelMenu.high": "high",
    "microPythonEsp8266.levelMenu.low": "low",
    "microPythonEsp8266.modeMenu.input": "input",
    "microPythonEsp8266.modeMenu.inputPullup": "input-pullup",
    "microPythonEsp8266.modeMenu.output": "output",
    "microPythonEsp8266.pins.esp8266AttachInterrupt": "attach interrupt pin [PIN] mode [MODE] executes",
    "microPythonEsp8266.pins.readAnalogPin": "read analog pin [PIN]",
    "microPythonEsp8266.pins.readDigitalPin": "read digital pin [PIN]",
    "microPythonEsp8266.pins.setDigitalOutput": "set digital pin [PIN] out [LEVEL]",
    "microPythonEsp8266.pins.setPinMode": "set pin [PIN] mode [MODE]",
    "microPythonEsp8266.pins.setPwmOutput": "set pwm pin [PIN] out [OUT]",
    "microPythonEsp8266.pins.setServoOutput": "set servo pin [PIN] out [OUT]",
    "microPythonK210.InterrupModeMenu.changeEdge": "change edge",
    "microPythonK210.InterrupModeMenu.fallingEdge": "falling edge",
    "microPythonK210.InterrupModeMenu.risingEdge": "rising edge",
    "microPythonK210.category.console": "Console",
    "microPythonK210.category.pins": "Pins",
    "microPythonK210.category.serial": "Serial",
    "microPythonK210.console.consoleInput": "prompt [TEXT] and read input",
    "microPythonK210.console.consolePrint": "print [TEXT] [EOL]",
    "microPythonK210.eolMenu.noWarp": "no-warp",
    "microPythonK210.eolMenu.warp": "warp",
    "microPythonK210.levelMenu.high": "high",
    "microPythonK210.levelMenu.low": "low",
    "microPythonK210.modeMenu.input": "input",
    "microPythonK210.modeMenu.inputPulldown": "input-pulldown",
    "microPythonK210.modeMenu.inputPullup": "input-pullup",
    "microPythonK210.modeMenu.output": "output",
    "microPythonK210.pins.k210AttachInterrupt": "attach interrupt pin [PIN] mode [MODE] executes",
    "microPythonK210.pins.k210SetPinMode": "set pin [PIN] mode [MODE]",
    "microPythonK210.pins.k210SetPwmOutput": "set pwm pin [PIN] use channel [CH] out [OUT]",
    "microPythonK210.pins.k210SetServoOutput": "set servo pin [PIN] use channel [CH] out [OUT]",
    "microPythonK210.pins.readDigitalPin": "read digital pin [PIN]",
    "microPythonK210.pins.setDigitalOutput": "set digital pin [PIN] out [LEVEL]",
    "microPythonK210.serial.k210SerialBegin": "serial [NO] begin baudrate [BAUD] pin RX [RX_PIN] TX [TX_PIN]",
    "microPythonK210.serial.serialPrint": "serial [NO] print [VALUE] [EOL]",
    "microPythonK210.serial.serialReadALine": "serial [NO] read a line",
    "microPythonRaspberryPiPico.InterrupModeMenu.changeEdge": "change edge",
    "microPythonRaspberryPiPico.InterrupModeMenu.fallingEdge": "falling edge",
    "microPythonRaspberryPiPico.InterrupModeMenu.risingEdge": "rising edge",
    "microPythonRaspberryPiPico.category.console": "Console",
    "microPythonRaspberryPiPico.category.pins": "Pins",
    "microPythonRaspberryPiPico.category.serial": "Serial",
    "microPythonRaspberryPiPico.console.consoleInput": "prompt [TEXT] and read input",
    "microPythonRaspberryPiPico.console.consolePrint": "print [TEXT] [EOL]",
    "microPythonRaspberryPiPico.eolMenu.noWarp": "no-warp",
    "microPythonRaspberryPiPico.eolMenu.warp": "warp",
    "microPythonRaspberryPiPico.levelMenu.high": "high",
    "microPythonRaspberryPiPico.levelMenu.low": "low",
    "microPythonRaspberryPiPico.modeMenu.input": "input",
    "microPythonRaspberryPiPico.modeMenu.inputPulldown": "input-pulldown",
    "microPythonRaspberryPiPico.modeMenu.inputPullup": "input-pullup",
    "microPythonRaspberryPiPico.modeMenu.output": "output",
    "microPythonRaspberryPiPico.pins.attachInterrupt": "attach interrupt pin [PIN] mode [MODE] executes",
    "microPythonRaspberryPiPico.pins.readAnalogPin": "read analog pin [PIN]",
    "microPythonRaspberryPiPico.pins.readDigitalPin": "read digital pin [PIN]",
    "microPythonRaspberryPiPico.pins.setDigitalOutput": "set digital pin [PIN] out [LEVEL]",
    "microPythonRaspberryPiPico.pins.setPinMode": "set pin [PIN] mode [MODE]",
    "microPythonRaspberryPiPico.pins.setPwmOutputU16": "set pwm pin [PIN] out [OUT]",
    "microPythonRaspberryPiPico.pins.setServoOutputU16": "set servo pin [PIN] out [OUT]",
    "microPythonRaspberryPiPico.serial.multiSerialPrint": "serial [NO] print [VALUE] [EOL]",
    "microPythonRaspberryPiPico.serial.multiSerialReadALine": "serial [NO] read a line",
    "microPythonRaspberryPiPico.serial.raspberryPiPicoSerialBegin": "serial [NO] begin baudrate [BAUD] pin RX [RX_PIN] TX [TX_PIN]",
    "microbit.axisMenu.xAxis": "x-axis",
    "microbit.axisMenu.yAxis": "y-axis",
    "microbit.axisMenu.zAxis": "z-axis",
    "microbit.buttonsMenu.any": "any",
    "microbit.category.console": "Console",
    "microbit.category.display": "Display",
    "microbit.category.pins": "Pins",
    "microbit.category.sensor": "Sensor",
    "microbit.category.wireless": "Wireless",
    "microbit.clearDisplay": "clear display",
    "microbit.console.consolePrint": "print [TEXT]",
    "microbit.defaultTextToDisplay": "Hello!",
    "microbit.display.clearDisplay": "clear screen",
    "microbit.display.lightPixelAt": "light [STATE] at the x: [X] axis, y: [Y] axis",
    "microbit.display.show": "show [TEXT]",
    "microbit.display.showImage": "show image [VALUE]",
    "microbit.display.showImageUntil": "show image [VALUE] for [TIME] secs",
    "microbit.display.showOnPiexlbrightness": "show on the x: [X] axis, y: [Y] axis with brightness [BRT]",
    "microbit.display.showUntilScrollDone": "show [TEXT] until scroll done",
    "microbit.displaySymbol": "display [MATRIX]",
    "microbit.displayText": "display text [TEXT]",
    "microbit.gestruesMenu.faceDown": "face down",
    "microbit.gestruesMenu.faceUp": "face up",
    "microbit.gestruesMenu.freefall": "freefall",
    "microbit.gestruesMenu.shaken": "shaken",
    "microbit.gestruesMenu.tiltedDownward": "tilted downward",
    "microbit.gestruesMenu.tiltedLeftward": "tilted leftward",
    "microbit.gestruesMenu.tiltedRightward": "tilted rightward",
    "microbit.gestruesMenu.tiltedUpward": "tilted upward",
    "microbit.gesturesMenu.jumped": "jumped",
    "microbit.gesturesMenu.moved": "moved",
    "microbit.gesturesMenu.shaken": "shaken",
    "microbit.isButtonPressed": "[BTN] button pressed?",
    "microbit.isTilted": "tilted [DIRECTION]?",
    "microbit.ledState.off": "off",
    "microbit.ledState.on": "on",
    "microbit.levelMenu.high": "high",
    "microbit.levelMenu.low": "low",
    "microbit.pinStateMenu.off": "off",
    "microbit.pinStateMenu.on": "on",
    "microbit.pins.pinIsTouched": "pin [PIN] is touched",
    "microbit.pins.readAnalogPin": "read analog pin [PIN]",
    "microbit.pins.readDigitalPin": "read digital pin [PIN]",
    "microbit.pins.setDigitalOutput": "set digital pin [PIN] out [LEVEL]",
    "microbit.pins.setPwmOutput": "set pwm pin [PIN] out [OUT]",
    "microbit.sensor.axisAcceleration": "[AXIS] axis acceleration",
    "microbit.sensor.buttonIsPressed": "[KEY] button is pressed?",
    "microbit.sensor.calibrateCompass": "calibrate compass",
    "microbit.sensor.compassAngle": "compass angle",
    "microbit.sensor.compassMagneticDensity": "compass magnetic density",
    "microbit.sensor.gestureIsX": "gestrue is [STA]?",
    "microbit.sensor.lightLevel": "light level",
    "microbit.sensor.runningTime": "running time",
    "microbit.sensor.temperature": "temperature",
    "microbit.tiltAngle": "tilt angle [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "any",
    "microbit.tiltDirectionMenu.back": "back",
    "microbit.tiltDirectionMenu.front": "front",
    "microbit.tiltDirectionMenu.left": "left",
    "microbit.tiltDirectionMenu.right": "right",
    "microbit.whenButtonPressed": "when [BTN] button pressed",
    "microbit.whenGesture": "when [GESTURE]",
    "microbit.whenPinConnected": "when pin [PIN] connected",
    "microbit.whenTilted": "when tilted [DIRECTION]",
    "microbit.wireless.closeWirelessCommunication": "close wireless communication",
    "microbit.wireless.openWirelessCommunication": "open wireless communication",
    "microbit.wireless.receiveWirelessMessage": "receive wireless message",
    "microbit.wireless.resetWirelessCommunication": "reset wireless communication",
    "microbit.wireless.sendWirelessMessage": "send wireless message [TEXT]",
    "microbit.wireless.setWirelessCommunicationChannel": "set wireless communication channel as [CH]",
    "music.categoryName": "Music",
    "music.changeTempo": "change tempo by [TEMPO]",
    "music.drumBass": "(2) Bass Drum",
    "music.drumBongo": "(13) Bongo",
    "music.drumCabasa": "(15) Cabasa",
    "music.drumClaves": "(9) Claves",
    "music.drumClosedHiHat": "(6) Closed Hi-Hat",
    "music.drumConga": "(14) Conga",
    "music.drumCowbell": "(11) Cowbell",
    "music.drumCrashCymbal": "(4) Crash Cymbal",
    "music.drumCuica": "(18) Cuica",
    "music.drumGuiro": "(16) Guiro",
    "music.drumHandClap": "(8) Hand Clap",
    "music.drumOpenHiHat": "(5) Open Hi-Hat",
    "music.drumSideStick": "(3) Side Stick",
    "music.drumSnare": "(1) Snare Drum",
    "music.drumTambourine": "(7) Tambourine",
    "music.drumTriangle": "(12) Triangle",
    "music.drumVibraslap": "(17) Vibraslap",
    "music.drumWoodBlock": "(10) Wood Block",
    "music.getTempo": "tempo",
    "music.instrumentBass": "(6) Bass",
    "music.instrumentBassoon": "(14) Bassoon",
    "music.instrumentCello": "(8) Cello",
    "music.instrumentChoir": "(15) Choir",
    "music.instrumentClarinet": "(10) Clarinet",
    "music.instrumentElectricGuitar": "(5) Electric Guitar",
    "music.instrumentElectricPiano": "(2) Electric Piano",
    "music.instrumentFlute": "(12) Flute",
    "music.instrumentGuitar": "(4) Guitar",
    "music.instrumentMarimba": "(19) Marimba",
    "music.instrumentMusicBox": "(17) Music Box",
    "music.instrumentOrgan": "(3) Organ",
    "music.instrumentPiano": "(1) Piano",
    "music.instrumentPizzicato": "(7) Pizzicato",
    "music.instrumentSaxophone": "(11) Saxophone",
    "music.instrumentSteelDrum": "(18) Steel Drum",
    "music.instrumentSynthLead": "(20) Synth Lead",
    "music.instrumentSynthPad": "(21) Synth Pad",
    "music.instrumentTrombone": "(9) Trombone",
    "music.instrumentVibraphone": "(16) Vibraphone",
    "music.instrumentWoodenFlute": "(13) Wooden Flute",
    "music.midiPlayDrumForBeats": "play drum [DRUM] for [BEATS] beats",
    "music.midiSetInstrument": "set instrument to [INSTRUMENT]",
    "music.playDrumForBeats": "play drum [DRUM] for [BEATS] beats",
    "music.playNoteForBeats": "play note [NOTE] for [BEATS] beats",
    "music.restForBeats": "rest for [BEATS] beats",
    "music.setInstrument": "set instrument to [INSTRUMENT]",
    "music.setTempo": "set tempo to [TEMPO]",
    "pen.categoryName": "Pen",
    "pen.changeColorParam": "change pen [COLOR_PARAM] by [VALUE]",
    "pen.changeHue": "change pen color by [HUE]",
    "pen.changeShade": "change pen shade by [SHADE]",
    "pen.changeSize": "change pen size by [SIZE]",
    "pen.clear": "erase all",
    "pen.colorMenu.brightness": "brightness",
    "pen.colorMenu.color": "color",
    "pen.colorMenu.saturation": "saturation",
    "pen.colorMenu.transparency": "transparency",
    "pen.penDown": "pen down",
    "pen.penUp": "pen up",
    "pen.setColor": "set pen color to [COLOR]",
    "pen.setColorParam": "set pen [COLOR_PARAM] to [VALUE]",
    "pen.setHue": "set pen color to [HUE]",
    "pen.setShade": "set pen shade to [SHADE]",
    "pen.setSize": "set pen size to [SIZE]",
    "pen.stamp": "stamp",
    "speech.defaultWhenIHearValue": "let''s go",
    "speech.extensionName": "Speech to Text",
    "speech.listenAndWait": "listen and wait",
    "speech.speechReporter": "speech",
    "speech.whenIHear": "when I hear [PHRASE]",
    "text2speech.alto": "alto",
    "text2speech.categoryName": "Text to Speech",
    "text2speech.defaultTextToSpeak": "hello",
    "text2speech.giant": "giant",
    "text2speech.kitten": "kitten",
    "text2speech.setLanguageBlock": "set language to [LANGUAGE]",
    "text2speech.setVoiceBlock": "set voice to [VOICE]",
    "text2speech.speakAndWaitBlock": "speak [WORDS]",
    "text2speech.squeak": "squeak",
    "text2speech.tenor": "tenor",
    "translate.categoryName": "Translate",
    "translate.defaultTextToTranslate": "hello",
    "translate.translateBlock": "translate [WORDS] to [LANGUAGE]",
    "translate.viewerLanguage": "language",
    "videoSensing.categoryName": "Video Sensing",
    "videoSensing.direction": "direction",
    "videoSensing.motion": "motion",
    "videoSensing.off": "off",
    "videoSensing.on": "on",
    "videoSensing.onFlipped": "on flipped",
    "videoSensing.setVideoTransparency": "set video transparency to [TRANSPARENCY]",
    "videoSensing.sprite": "sprite",
    "videoSensing.stage": "stage",
    "videoSensing.videoOn": "video [ATTRIBUTE] on [SUBJECT]",
    "videoSensing.videoToggle": "turn video [VIDEO_STATE]",
    "videoSensing.whenMotionGreaterThan": "when video motion > [REFERENCE]",
    "wedo2.getDistance": "distance",
    "wedo2.getTiltAngle": "tilt angle [TILT_DIRECTION]",
    "wedo2.isTilted": "tilted [TILT_DIRECTION_ANY]?",
    "wedo2.motorDirection.backward": "that way",
    "wedo2.motorDirection.forward": "this way",
    "wedo2.motorDirection.reverse": "reverse",
    "wedo2.motorId.a": "motor A",
    "wedo2.motorId.all": "all motors",
    "wedo2.motorId.b": "motor B",
    "wedo2.motorId.default": "motor",
    "wedo2.motorOff": "turn [MOTOR_ID] off",
    "wedo2.motorOn": "turn [MOTOR_ID] on",
    "wedo2.motorOnFor": "turn [MOTOR_ID] on for [DURATION] seconds",
    "wedo2.playNoteFor": "play note [NOTE] for [DURATION] seconds",
    "wedo2.setLightHue": "set light color to [HUE]",
    "wedo2.setMotorDirection": "set [MOTOR_ID] direction to [MOTOR_DIRECTION]",
    "wedo2.startMotorPower": "set [MOTOR_ID] power to [POWER]",
    "wedo2.tiltDirection.any": "any",
    "wedo2.tiltDirection.down": "down",
    "wedo2.tiltDirection.left": "left",
    "wedo2.tiltDirection.right": "right",
    "wedo2.tiltDirection.up": "up",
    "wedo2.whenDistance": "when distance [OP] [REFERENCE]",
    "wedo2.whenTilted": "when tilted [TILT_DIRECTION_ANY]",
    "yiFlash.categoryName": "Yi Flash",
    "yiFlash.setLightMode": "set light mode [MODE]",
    "yiFlash.setLightMode.1": "Steady On",
    "yiFlash.setLightMode.2": "Flashing",
    "yiFlash.setLightMode.3": "Breating Light",
    "yiFlash.setLightSwitch": "turn light [SWITCH]",
    "yiFlash.setLightSwitch.1": "On",
    "yiFlash.setLightSwitch.0": "Off",
    "yiFlash.setBrightness": "set brightness [BRIGHTNESS]",
    "yiFlash.setFlashFrequency": "set flash frequency [FREQUENCY]",
    "yiFlash.setFlashFrequency.0": "Slow",
    "yiFlash.setFlashFrequency.1": "Fast",
    "yiFlash.setFlashMode": "turn flash mode [MODE]",
    "yiFlash.setFlashMode.0": "Off",
    "yiFlash.setFlashMode.1": "On",
    "yiFlash.ble": "ble",
    "yiFlash.ble.connect": "connect to YLM Flash [DEVICE_NAME]",
    "yiFlash.ble.disconnect": "disconnect from YML Flash",
    "yi.ble": "ble",
    "yi.ble.connect": "connect to [DEVICE_NAME]",
    "yi.ble.disconnect": "disconnect from device",
    "yiIrmotion.ble.connect": "connect to [DEVICE_NAME]",
    "yiIrmotion.ble.disconnect": "disconnect from device",
    "yiIrmotion.categoryName": "Yi Irmotion",
    "yiIrmotion.getStatus": "detect current status",
    "yiLight.ble.connect": "connect to [DEVICE_NAME]",
    "yiLight.ble.disconnect": "disconnect from device",
    "yiLight.categoryName": "Yi Light",
    "yiLight.getBrightness": "get current brightness",
    "yiPlug.ble.connect": "connect to [DEVICE_NAME]",
    "yiPlug.ble.disconnect": "disconnect from device",
    "yiPlug.categoryName": "Smart Plugin",
    "yiPlug.setPluginSwitch": "turn plugin [SWITCH]",
    "yiPlug.setPluginSwitch.0": "Off",
    "yiPlug.setPluginSwitch.1": "On",
    "yiThermeter.ble.connect": "connect to [DEVICE_NAME]",
    "yiThermeter.ble.disconnect": "disconnect from device",
    "yiThermeter.categoryName": "Yi Thermometer",
    "yiThermeter.getTemperature": "get current temperature",
    "yiThermeter.getHumidity": "get current humidity",
    "yiNightLamp.ble.connect": "connect to [DEVICE_NAME]",
    "yiNightLamp.ble.disconnect": "disconnect from device",
    "yiNightLamp.categoryName": "Yi NightLamp",
    "yiNightLamp.setLightSwitch": "turn light [SWITCH]",
    "yiNightLamp.setBrightness": "set brightness [BRIGHTNESS]",
    "yiNightLamp.setFlashMode": "turn flash mode [MODE]",
    "yiNightLamp.getBrightness": "get current brightness",
    "yiNightLamp.setLightSwitch.1": "On",
    "yiNightLamp.setLightSwitch.0": "Off",
    "yiNightLamp.setFlashMode.1": "On",
    "yiNightLamp.setFlashMode.0": "Off",
    "yiThermeterA.ble.connect": "connect to [DEVICE_NAME]",
    "yiThermeterA.ble.disconnect": "disconnect from device",
    "yiThermeterA.categoryName": "Yi Thermometer A",
    "yiThermeterA.getTemperature": "get current temperature",
    "yiAudio.ble.connect": "connect to [DEVICE_NAME]",
    "yiAudio.ble.disconnect": "disconnect from device",
    "yiAudio.categoryName": "Yi Audio",
    "yiAudio.setPromptTone": "play [PROMPT_TONE]",
    "yiAudio.setPromptTone.1": "audio 1",
    "yiAudio.setPromptTone.2": "audio 2",
    "yiAudio.setPromptTone.3": "audio 3",
    "yiAudio.setPromptTone.4": "audio 4",
    "yiAudio.setPromptTone.5": "audio 5",
    "yiImu06.ble.connect": "connect to [DEVICE_NAME]",
    "yiImu06.ble.disconnect": "disconnect from device",
    "yiImu06.categoryName": "Yi IMU06",
    "yiImu06.getRollAngle": "get current rollAngle",
    "yiImu06.getPitchAngle": "get current pitchAngle",
    "yiImu06.getYawAngle": "get current yawAngle",
    "yiImu06x.categoryName": "Yi IMU06X",
    "yiImu06x.getRollAngle": "get current rollAngle",
    "yiImu06x.getPitchAngle": "get current pitchAngle",
    "yiImu06x.getYawAngle": "get current yawAngle",
    "paint.colorPicker.swap": "Swap",
    "paint.paintEditor.hue": "Color",
    "paint.paintEditor.saturation": "Saturation",
    "paint.paintEditor.brightness": "Brightness",
    "paint.paintEditor.costume": "Costume",
    "paint.paintEditor.group": "Group",
    "paint.paintEditor.ungroup": "Ungroup",
    "paint.paintEditor.undo": "Undo",
    "paint.paintEditor.redo": "Redo",
    "paint.paintEditor.forward": "Forward",
    "paint.paintEditor.backward": "Backward",
    "paint.paintEditor.front": "Front",
    "paint.paintEditor.back": "Back",
    "paint.paintEditor.more": "More",
    "paint.modeTools.brushSize": "Size",
    "paint.modeTools.eraserSize": "Eraser size",
    "paint.modeTools.copy": "Copy",
    "paint.modeTools.paste": "Paste",
    "paint.modeTools.delete": "Delete",
    "paint.modeTools.curved": "Curved",
    "paint.modeTools.pointed": "Pointed",
    "paint.modeTools.thickness": "Thickness",
    "paint.modeTools.flipHorizontal": "Flip Horizontal",
    "paint.modeTools.flipVertical": "Flip Vertical",
    "paint.modeTools.filled": "Filled",
    "paint.modeTools.outlined": "Outlined",
    "paint.paintEditor.bitmap": "Convert to Bitmap",
    "paint.paintEditor.vector": "Convert to Vector",
    "paint.paintEditor.fill": "Fill",
    "paint.paintEditor.stroke": "Outline",
    "paint.brushMode.brush": "Brush",
    "paint.eraserMode.eraser": "Eraser",
    "paint.fillMode.fill": "Fill",
    "paint.lineMode.line": "Line",
    "paint.ovalMode.oval": "Circle",
    "paint.rectMode.rect": "Rectangle",
    "paint.reshapeMode.reshape": "Reshape",
    "paint.roundedRectMode.roundedRect": "Rounded Rectangle",
    "paint.selectMode.select": "Select",
    "paint.textMode.text": "Text"
  },
  "ru": {
    "gui.alerts.lostPeripheralConnection": "Scratch потерял соединение с {extensionName}.",
    "gui.alerts.tryAgain": "Попробуй еще раз",
    "gui.alerts.download": "Скачать",
    "gui.connection.reconnect": "Переподключиться",
    "gui.alerts.uploadFirmware": "Загрузить прошивку",
    "gui.backpack.costumeLabel": "костюм",
    "gui.backpack.soundLabel": "звук",
    "gui.backpack.scriptLabel": "скрипт",
    "gui.backpack.spriteLabel": "спрайт",
    "gui.backpack.header": "Рюкзак",
    "gui.backpack.errorBackpack": "Ошибка при загрузке рюкзака",
    "gui.backpack.loadingBackpack": "Загрузка…",
    "gui.backpack.more": "Ещё",
    "gui.backpack.emptyBackpack": "Рюкзак пуст",
    "gui.unsupportedBrowser.label": "Браузер не поддерживается",
    "gui.unsupportedBrowser.errorLabel": "Произошла ошибка",
    "gui.unsupportedBrowser.notRecommended": "Нам очень жаль, но вы используете версию браузера, которую не поддерживает Scratch. Мы советует воспользоваться последними версиями таких браузеров как Google Chrome, Mozilla Firefox, Microsoft Edge или Apple Safari.",
    "gui.unsupportedBrowser.description": "Нам очень жаль, но Scratch не поддерживает этот браузер.  Мы советует воспользоваться последними версиями таких браузеров как Google Chrome, Mozilla Firefox, Microsoft Edge или Apple Safari.",
    "gui.unsupportedBrowser.back": "Назад",
    "gui.unsupportedBrowser.previewfaq": "Чтобы узнать больше, перейдите к {previewFaqLink}.",
    "gui.unsupportedBrowser.previewfaqlinktext": "ЧаВО",
    "gui.cards.all-tutorials": "Учебники",
    "gui.cards.shrink": "Свернуть",
    "gui.cards.expand": "Развернуть",
    "gui.cards.close": "Закрыть",
    "gui.cards.more-things-to-try": "Дополнительные возможности!",
    "gui.cards.see-more": "Узнать больше",
    "gui.comingSoon.message1": "Не волнуйтесь, мы работаем над этим {emoji}",
    "gui.comingSoon.message2": "Скоро…",
    "gui.comingSoon.message3": "Мы работаем над этим {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "Устройства не обнаружены",
    "gui.connection.auto-scanning.prescan": "Поставьте ваше устройство поблизости и начните поиск",
    "gui.connection.auto-scanning.pressbutton": "Нажмите кнопку на вашем устройстве.",
    "gui.connection.auto-scanning.start-search": "Начать поиск",
    "gui.connection.connecting-searchbutton": "Поиск...",
    "gui.connection.auto-scanning.try-again": "Попробуйте еще",
    "gui.connection.connected": "Подключено",
    "gui.connection.disconnect": "Отсоединить",
    "gui.connection.go-to-editor": "Перейти к редактору",
    "gui.connection.connecting-cancelbutton": "Соединяю...",
    "gui.connection.accessDeniedError.errorMessage": "К сожалению, доступ к последовательному порту запрещен, проверьте, не занят ли последовательный порт.",
    "gui.connection.unknownErrorCode31.errorMessage": "Ошибка 31: Неизвестный код ошибки, рекомендуется переподключить устройство.",
    "gui.connection.error.errorMessage": "Ой, кажется что-то пошло не так.",
    "gui.connection.error.tryagainbutton": "Попробуйте еще",
    "gui.connection.error.helpbutton": "Помощь",
    "gui.connection.peripheral-name-label": "Название устройства",
    "gui.connection.connect": "Соединить",
    "gui.connection.scanning.listAll": "Показать все подключаемые устройства",
    "gui.connection.scanning.lookingforperipherals": "Идет поиск устройств",
    "gui.connection.scanning.noPeripheralsFound": "Устройства не обнаружены",
    "gui.connection.scanning.instructions": "Выберите свое устройство из списка",
    "gui.connection.search": "Обновить",
    "gui.connection.unavailable.installscratchlink": "Убедитесь в том, что вы установили и запустили Scratch Link",
    "gui.connection.unavailable.connectUsbEnableBluetooth": "Убедитесь, что USB-кабель подключен или Bluetooth включен.",
    "gui.connection.unavailable.tryagainbutton": "Попробовать еще",
    "gui.connection.unavailable.helpbutton": "Помощь",
    "gui.controls.go": "Вперед",
    "gui.controls.stop": "Остановить",
    "gui.crashMessage.label": "Упс! Что-то пошло не так.",
    "gui.crashMessage.description": "Нам очень жаль, но похоже что Scratch дал сбой. Сообщение об ошибке было автоматически отправлено команде Scratch. Пожалуйста, обновите страницу чтобы попробовать еще раз.",
    "gui.crashMessage.errorNumber": "Ваша ошибка зарегистрирована как {errorId}",
    "gui.crashMessage.reload": "Перезагрузить",
    "gui.customProcedures.myblockModalTitle": "Создать блок",
    "gui.customProcedures.addAnInputNumber": "Добавить значение",
    "gui.customProcedures.numberType": "номер",
    "gui.customProcedures.addAnInputText": "Добавить значение",
    "gui.customProcedures.TextType": "текст",
    "gui.customProcedures.addAnInputBoolean": "Добавить значение",
    "gui.customProcedures.booleanType": "логическое",
    "gui.customProcedures.addALabel": "Добавить подпись",
    "gui.customProcedures.runWithoutScreenRefresh": "Запустить без обновления экрана",
    "gui.customProcedures.cancel": "Отменить",
    "gui.customProcedures.ok": "OK",
    "gui.deviceTypeModal.deviceTypeTitle": "Выберите тип программирования",
    "gui.deviceTypeModal.arduino": "Arduino",
    "gui.deviceTypeModal.python": "Python",
    "gui.deviceTypeModal.microPython": "MicroPython",
    "gui.deviceTypeModal.cancel": "Отменить",
    "gui.SpriteInfo.direction": "Направление",
    "gui.directionPicker.rotationStyles.allAround": "Кругом",
    "gui.directionPicker.rotationStyles.leftRight": "Влево/направо",
    "gui.directionPicker.rotationStyles.dontRotate": "Не вращать",
    "gui.gui.addExtension": "Добавить расширение",
    "gui.gui.codeTab": "Код",
    "gui.gui.backdropsTab": "Фоны",
    "gui.gui.costumesTab": "Костюмы",
    "gui.gui.soundsTab": "Звуки",
    "gui.hardwareConsole.send": "Отправить",
    "gui.hardwareConsole.buadrate": "Скорость передачи данных",
    "gui.hardwareConsole.endOfLine": "Конец строки",
    "gui.hardwareConsole.hexform": "Шестнадцатеричная форма",
    "gui.hardwareConsole.autoScroll": "Автопрокрутка",
    "gui.hardwareHeader.upload": "Загрузка",
    "gui.stageHeader.codeStageSizeLarge": "Большая сцена",
    "gui.stageHeader.codeStageSizeSmall": "Маленькая сцена",
    "gui.stageHeader.hideStage": "Скрыть сцену",
    "gui.extensionLibrary.comingSoon": "Скоро…",
    "gui.extensionLibrary.requires": "Требуются",
    "gui.extensionLibrary.collaboration": "В сотрудничестве",
    "gui.extensionLibrary.manufactor": "Производитель",
    "gui.extensionLibrary.version": "Версия",
    "gui.extensionLibrary.author": "Автор",
    "gui.extensionLibrary.programMode": "Режим программы",
    "gui.extensionLibrary.programLanguage": "Язык программы",
    "gui.extensionLibrary.deviceLearnMore": "Узнать еще",
    "gui.extensionLibrary.extensionHelp": "Помощь",
    "gui.extensionLibrary.Processing": "Обработка...",
    "gui.extensionLibrary.loaded": "Загружено",
    "gui.extensionLibrary.notLoaded": "Не загружено",
    "gui.library.filterPlaceholder": "Поиск",
    "gui.library.allTag": "Все",
    "gui.loader.message1": "Создание блоков…",
    "gui.loader.message2": "Загрузка спрайтов…",
    "gui.loader.message3": "Загрузка звуков…",
    "gui.loader.message4": "Загрузка расширений…",
    "gui.loader.message5": "Пасём котов…",
    "gui.loader.message6": "Передача наночастиц…",
    "gui.loader.message7": "Надувание гобо…",
    "gui.loader.message8": "Подготовка смайликов…",
    "gui.loader.headline": "Загрузка проекта",
    "gui.loader.creating": "Создать проект",
    "gui.accountMenu.profile": "Профиль",
    "gui.accountMenu.myStuff": "Мои работы",
    "gui.accountMenu.myClasses": "Мои классы",
    "gui.accountMenu.myClass": "Мой класс",
    "gui.accountMenu.accountSettings": "Настройки аккаунта",
    "gui.accountMenu.signOut": "Выйти",
    "gui.authorInfo.byUser": "от{username}",
    "gui.menuBar.seeProjectPage": "Посмотреть страницу проекта",
    "general.username": "Имя пользователя",
    "general.password": "Пароль",
    "general.signIn": "Войти",
    "login.needHelp": "Нужна помощь?",
    "form.validationRequired": "Это поле обязательно для заполнения",
    "gui.menuBar.LanguageSelector": "выбор языка",
    "gui.menuBar.tutorialsLibrary": "Руководства",
    "gui.menuBar.community": "Открытое сообщество",
    "gui.menuBar.wiki": "Wiki",
    "gui.menuBar.restoreSprite": "Восстановить Спрайт",
    "gui.menuBar.restoreSound": "Восстановить Звук",
    "gui.menuBar.restoreCostume": "Восстановить Костюм",
    "gui.menuBar.restore": "Восстановить",
    "gui.menuBar.saveNow": "Сохранить сейчас",
    "gui.menuBar.saveAsCopy": "Сохранить как копию",
    "gui.menuBar.remix": "Ремикс",
    "gui.menuBar.new": "Новый",
    "gui.menuBar.checkUpdate": "Проверить обновления",
    "gui.menuBar.installDriver": "Установить драйвер",
    "gui.menuBar.clearCacheAndRestart": "Очистка кеша и перезагрузка",
    "gui.menuBar.file": "Файл",
    "gui.menuBar.downloadToComputer": "Сохранить на свой компьютер",
    "gui.menuBar.edit": "Редактировать",
    "gui.menuBar.turboModeOff": "Выключить Турбо режим",
    "gui.menuBar.turboModeOn": "Включить Турбо режим",
    "gui.menuBar.noDeviceSelected": "Ни одно устройство не выбрано",
    "gui.menuBar.noConnection": "Отсоединено",
    "gui.menuBar.uploadFirmware": "Загрузить прошивку",
    "gui.menu-bar.programMode": "Режим программы",
    "gui.gui.projectTitlePlaceholder": "Название проекта",
    "gui.menuBar.saveNowLink": "Сохранить сейчас",
    "gui.menuBar.isShared": "Доступен всем",
    "gui.menuBar.share": "Поделиться",
    "gui.modal.help": "Помощь",
    "gui.modal.back": "Назад",
    "gui.monitor.listMonitor.empty": "(пусто)",
    "gui.monitor.listMonitor.listLength": "длина {length}",
    "gui.monitor.contextMenu.default": "стандартный вид",
    "gui.monitor.contextMenu.large": "крупный вид",
    "gui.monitor.contextMenu.slider": "рычажок",
    "gui.monitor.contextMenu.sliderRange": "изменить диапазон рычажка",
    "gui.monitor.contextMenu.import": "импорт",
    "gui.monitor.contextMenu.export": "экспорт",
    "gui.playButton.play": "Играть",
    "gui.playButton.stop": "Остановить",
    "gui.gui.variableScopeOptionAllSprites": "Для всех спрайтов",
    "gui.gui.variableScopeOptionSpriteOnly": "Только для этого спрайта",
    "gui.gui.cloudVariableOption": "Облачная переменная (хранится на сервере)",
    "gui.gui.variablePromptAllSpritesMessage": "Эта переменная будет доступна для всех спрайтов.",
    "gui.gui.listPromptAllSpritesMessage": "Этот список будет доступен всем спрайтам.",
    "gui.prompt.cancel": "Отменить",
    "gui.prompt.ok": "OK",
    "gui.playbackStep.stopMsg": "Остановить",
    "gui.playbackStep.playMsg": "Проиграть",
    "gui.playbackStep.loadingMsg": "Загрузка…",
    "gui.playbackStep.saveMsg": "Сохранить",
    "gui.playbackStep.reRecordMsg": "Перезаписать",
    "gui.recordModal.title": "Записать звук",
    "gui.recordingStep.beginRecord": "Начните записывать, кликнув кнопку ниже",
    "gui.recordingStep.permission": "{arrow}Нам требуется ваше разрешение для использования вашего микрофона",
    "gui.recordingStep.stop": "Остановить запись",
    "gui.recordingStep.record": "Записать",
    "gui.sliderModal.min": "Минимальное значение",
    "gui.sliderModal.max": "Максимальное значение",
    "gui.sliderModal.title": "Изменить диапазон рычажка",
    "gui.sliderPrompt.cancel": "Отмена",
    "gui.sliderPrompt.ok": "OK",
    "gui.soundEditor.sound": "Звук",
    "gui.soundEditor.play": "Играть",
    "gui.soundEditor.stop": "Остановить",
    "gui.soundEditor.copy": "Копировать",
    "gui.soundEditor.paste": "Вставить",
    "gui.soundEditor.copyToNew": "Копировать в Новый Звук",
    "gui.soundEditor.delete": "Удалить",
    "gui.soundEditor.save": "Сохранить",
    "gui.soundEditor.undo": "Отменить",
    "gui.soundEditor.redo": "Вернуть",
    "gui.soundEditor.faster": "Быстрее",
    "gui.soundEditor.slower": "Медленнее",
    "gui.soundEditor.echo": "Эхо",
    "gui.soundEditor.robot": "Робот",
    "gui.soundEditor.louder": "Громче",
    "gui.soundEditor.softer": "Тише",
    "gui.soundEditor.reverse": "Развернуть",
    "gui.soundEditor.fadeOut": "Затухание",
    "gui.soundEditor.fadeIn": "Усиление",
    "gui.soundEditor.mute": "Заглушить",
    "gui.SpriteInfo.spritePlaceholder": "Название",
    "gui.SpriteInfo.sprite": "Спрайт",
    "gui.SpriteInfo.show": "Показать",
    "gui.SpriteInfo.size": "Размер",
    "gui.spriteSelectorItem.contextMenuDuplicate": "дублировать",
    "gui.spriteSelectorItem.contextMenuExport": "экспорт",
    "gui.spriteSelectorItem.contextMenuDelete": "удалить",
    "gui.spriteSelector.addSpriteFromLibrary": "Выбрать спрайт",
    "gui.spriteSelector.addSpriteFromPaint": "Нарисовать",
    "gui.spriteSelector.addSpriteFromSurprise": "Сюрприз",
    "gui.spriteSelector.addSpriteFromFile": "Загрузить спрайт",
    "gui.stageHeader.stageSizeLarge": "Большая сцена",
    "gui.stageHeader.stageSizeSmall": "Маленькая сцена",
    "gui.stageHeader.stageSizeFull": "Перейти в полноэкранный режим",
    "gui.stageHeader.stageSizeUnFull": "Выйти из полноэкранного режима",
    "gui.stageHeader.fullscreenControl": "Полноэкранный режим",
    "gui.spriteSelector.addBackdropFromLibrary": "Выбрать фон",
    "gui.stageSelector.addBackdropFromPaint": "Нарисовать",
    "gui.stageSelector.addBackdropFromSurprise": "Сюрприз",
    "gui.stageSelector.addBackdropFromFile": "Загрузить фон",
    "gui.stageSelector.stage": "Сцена",
    "gui.stageSelector.backdrops": "Фоны",
    "gui.telemetryOptIn.label": "Отправь статистику, чтобы улучшить Scratch",
    "gui.telemetryOptIn.body1": "Команда Scratch всегда хочет понять как Scratch используется во всем мире. Чтобы помочь в поддержке, вы можете разрешить Scratch автоматически отправлять информацию об использовании команде Scratch!",
    "gui.telemetryOptIn.body2": "Мы собираем информацию о языке, использовании блоков и некоторые других событий, как сохранение, загрузка и загрузка проекта. Мы НЕ собираем личную информацию. Пожалуйста, посмотрите {privacyPolicyLink} для большего ознакомления. ",
    "gui.telemetryOptIn.privacyPolicyLink": "Политика конфиденциальности",
    "gui.telemetryOptIn.optInText": "Сообщать мои данные об использовании команде Scratch Team",
    "gui.telemetryOptIn.optInTooltip": "Включить телеметрию",
    "gui.telemetryOptIn.optOutText": "Не сообщать мои данные об использовании Scratch Team",
    "gui.telemetryOptIn.optOutTooltip": "Отключить телеметрию",
    "gui.telemetryOptIn.settingWasUpdated": "Ваша настройка была обновлена.",
    "gui.telemetryOptIn.buttonClose": "Закрыть",
    "gui.turboMode.active": "Турбо режим",
    "gui.updateModal.close": "Закрыть",
    "gui.updateModal.downloading": "Загрузка",
    "gui.updateModal.abort": "Прервать",
    "gui.updateModel.tileCheckingForUpdate": "Проверка обновления",
    "gui.updateModel.checkingTips": "В зависимости от вашей сети этот шаг может занять от нескольких секунд до десятков секунд, пожалуйста, подождите.",
    "gui.updateModel.tileUpdateExternalResource": "Обнаружена новая версия внешнего ресурса",
    "gui.updateModel.tileUpdateApplication": "Обнаружена новая версия этого приложения",
    "gui.updateModal.updateLater": "Обновить позже",
    "gui.updateModal.updateAndRestart": "Обновить и перезагрузить",
    "gui.updateModel.tileAlreadyLatest": "Обнаружена новая версия",
    "gui.updateModel.alreadyLatestTips": "Установлена самая последняя версия Openblock",
    "gui.updateModel.tileError": "Операция не выполнена",
    "gui.updateModel.upgradingExternalResource": "Обновление внешнего ресурса",
    "gui.updateModal.deletingCompressedFile": "Удаление сжатого файла",
    "gui.updateModal.deletingCacheFile": "Удаление файла кеша",
    "gui.updateModal.extractingCompressedFile": "Извлечение сжатого файла",
    "gui.updateModal.verifyingCompressedFile": "Проверка сжатого файла",
    "gui.updateModal.verifyingCacheFile": "Проверка файла кеша",
    "gui.updateModel.tileResourceUpdateFinish": "Обновление внешнего ресурса завершено",
    "gui.updateModal.resourceUpdateFinishTips": "Обновление внешнего ресурса завершено, приложение автоматически перезапустится через 3 секунды.",
    "gui.updateModel.downloadingApplication": "Загрузка приложения",
    "gui.updateModel.tileApplicationDownloadFinish": "Загрузка приложения завершена",
    "gui.updateModal.applicationDownloadeFinishTips": "Загрузка приложения завершена, оно автоматически закроется и запустит программу установки через 3 секунды.",
    "gui.uploadProgress.uploading": "Загрузка",
    "gui.uploadProgress.uploadSuccess": "Успешная загрузка",
    "gui.uploadProgress.uploadError": "Ошибка загрузки",
    "gui.uploadProgress.uploadTimeout": "Тайм-аут загрузки",
    "gui.uploadProgress.uploadAborted": "Загрузка прервана",
    "gui.uploadProgress.abort": "Прервать",
    "gui.uploadProgress.close": "Закрыть",
    "gui.webglModal.label": "Ваш браузер не поддерживает WebGL",
    "gui.webglModal.description": "К сожалению, похоже ваш браузер или компьютер {webGlLink}. Эта технология необходима для запуска Scratch 3.0.",
    "gui.webglModal.webgllink": "не поддерживает WebGL",
    "gui.webglModal.back": "Назад",
    "gui.webglModal.previewfaq": "Чтобы узнать больше, перейдите к {previewFaqLink}.",
    "gui.webglModal.previewfaqlinktext": "ЧаВО",
    "gui.costumeLibrary.chooseABackdrop": "Выбрать фон",
    "gui.costumeLibrary.chooseACostume": "Выбрать костюм",
    "gui.costumeTab.addBackdropFromLibrary": "Выбрать фон",
    "gui.costumeTab.addCostumeFromLibrary": "Выбрать костюм",
    "gui.costumeTab.addBlankCostume": "Рисовать",
    "gui.costumeTab.addSurpriseCostume": "Сюрприз",
    "gui.costumeTab.addFileBackdrop": "Загрузить фон",
    "gui.costumeTab.addFileCostume": "Загрузить костюм",
    "gui.deviceLibrary.chooseADevice": "Выбор устройства",
    "gui.deviceLibrary.deviceUrl": "Введите URL устройства",
    "gui.deviceLibrary.arduinoTag": "Ардуино",
    "gui.deviceLibrary.microPythonTag": "MicroPython",
    "gui.deviceLibrary.kitTag": "Набор",
    "gui.extensionLibrary.chooseAnExtension": "Выбрать дополнение",
    "gui.extensionLibrary.extensionUrl": "Введи URL расширения",
    "gui.library.shieldTag": "Плата",
    "gui.library.actuatorTag": "Актуатор",
    "gui.library.sensorTag": "Сенсор",
    "gui.library.displayTag": "Дисплей",
    "gui.library.communicationTag": "Коммуникация",
    "gui.library.otherTag": "Другой",
    "gui.hardwareConsole.noLineTerminators": "Нет символа завершения строки",
    "gui.hardwareConsole.lineFeed": "Перевод строки",
    "gui.hardwareConsole.carriageReturn": "Возврат каретки",
    "gui.hardwareConsole.lfAndCr": "LF & CR\n ",
    "gui.monitors.importListColumnPrompt": "Какая колонка должна быть использована (1- {numberOfColumns})? ",
    "gui.recordingStep.alertMsg": "Не удалось начать запись",
    "gui.soundLibrary.chooseASound": "Выбрать звук",
    "gui.soundTab.fileUploadSound": "Загрузить звук",
    "gui.soundTab.surpriseSound": "Сюрприз",
    "gui.soundTab.recordSound": "Записать",
    "gui.soundTab.addSoundFromLibrary": "Выбрать звук",
    "gui.spriteLibrary.chooseASprite": "Выбрать спрайт",
    "gui.tipsLibrary.tutorials": "Выбрать руководство",
    "gui.updateModal.updateWarning": "Текущие несохраненные проекты будут потеряны, продолжить обновление и перезапустить?",
    "gui.uploadProgress.uploadErrorMessage": "Ошибка загрузки",
    "gui.uploadProgress.uploadTimeoutMessage": "Тайм-аут загрузки",
    "gui.alerts.createsuccess": "Создан новый проект.",
    "gui.alerts.createcopysuccess": "Проект сохранён как копия.",
    "gui.alerts.createremixsuccess": "Проект сохранён как ремикс.",
    "gui.alerts.creating": "Создание нового ...",
    "gui.alerts.creatingCopy": "Копирование проекта ...",
    "gui.alerts.creatingRemix": "Создание ремикса проекта ...",
    "gui.alerts.creatingError": "Не удалось создать проект. Попробуйте еще раз!",
    "gui.alerts.savingError": "Проект не может быть сохранён",
    "gui.alerts.savesuccess": "Проект сохранён.",
    "gui.alerts.saving": "Сохранение проекта...",
    "gui.alerts.cloudInfo": "Не забудьте, что облачные переменные могут быть только цифрами, а не буквами или символами. {learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "Узнать больше.",
    "gui.alerts.importing": "Импортируется...",
    "gui.alerts.workspaceIsEmpty": "Рабочая область пуста",
    "gui.alerts.workspaceIsNotEmpty": "Рабочая область не пуста. Сначала очистите рабочую область.",
    "gui.alerts.uploadError": "Ошибка загрузки",
    "gui.alerts.uploadSuccess": "Успешная загрузка",
    "gui.alerts.selectADeviceFirst": "Сначала выберите устройство",
    "gui.alerts.connectAPeripheralFirst": "Сначала подключите периферийное устройство",
    "gui.alerts.codeEditorIsLocked": "Редактор кода заблокирован, если вы хотите отредактировать код, сначала нажмите кнопку разблокировки.",
    "gui.alerts.codeEditorIsUnlocked": "Редактор кода находится в разблокированном состоянии, если вы хотите сгенерировать код из блока, сначала нажмите кнопку блокировки.",
    "gui.defaultProject.chirp": "Щебетать",
    "gui.defaultProject.variable": "моя переменная",
    "gui.howtos.intro-move-sayhello-hat.name": "С чего начать",
    "gui.howtos.intro-move.step_stepMove": "Добавить подвижный блок",
    "gui.howtos.add-a-move-block.step_stepSay": "Добавь блок \"сказать\"",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "Нажми на зелёный флаг чтобы начать",
    "gui.howtos.intro-getting-started-ASL.name": "С чего начать",
    "gui.howtos.animate-a-name.name": "Анимировать имя",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "Выберите спрайт буквы",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "Проигрывать звук при нажатии",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "Выберите другой спрайт буквы",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "Изменить цвет",
    "gui.howtos.animate-a-name.step_AnimateSpin": "Выберите другой спрайт и заставьте его крутиться",
    "gui.howtos.animate-a-name.step_AnimateGrow": "Выберите другой спрайт буквы и увеличьте его.",
    "gui.howtos.imagine": "Представь себе мир",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Введи то что ты хочешь сказать",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Нажми на зеленый флаг чтобы начать",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Выбери любой фон",
    "gui.howtos.imagine.step_imagineChooseSprite": "Выбери любой спрайт",
    "gui.howtos.imagine.step_imagineFlyAround": "Нажми на клавишу пробела чтобы плыть",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Выбери другой спрайт",
    "gui.howtos.imagine.step_imagineLeftRight": "Перемещайся влево-вправо",
    "gui.howtos.imagine.step_imagineUpDown": "Перемещайся вверх-вниз",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Меняй костюмы",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Плыви к точке",
    "gui.howtos.imagine.step_imagineGrowShrink": "Расти и уменьшайся",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Выбери другой фон",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "Переключай фоны",
    "gui.howtos.imagine.step_imagineRecordASound": "Добавь звук",
    "gui.howtos.imagine.step_imagineChooseSound": "Выбери звук",
    "gui.howtos.make-music.name": "Создайте музыку",
    "gui.howtos.Make-Music.step_PickInstrument": "Выберите спрайт инструмента",
    "gui.howtos.Make-Music.step_PlaySoundClick": "Играть звук при нажатии",
    "gui.howtos.Make-Music.step_MakeSong": "Создайте песню",
    "gui.howtos.make-music.step_MakeBeat": "Выберите барабаны и создайте ритм",
    "gui.howtos.make-music.step_MakeBeatBox": "Выберите спрайт микрофона и битбокс с сюрпризом",
    "gui.howtos.story.name": "Создать историю",
    "gui.howtos.story.step_addbg": "Добавьте фон",
    "gui.howtos.story.step_addsprite": "Добавить персонаж",
    "gui.howtos.story.step_saysomething": "Скажите что-нибудь",
    "gui.howtos.story.step_addanothersprite": "Добавить другого персонажа",
    "gui.howtos.story.step_flip": "Противоподлжное направление",
    "gui.howtos.story.step_conversation": "Завести разговор",
    "gui.howtos.story.addanotherbg": "Добавить другой фон",
    "gui.howtos.story.step_swithbg": "Переключить фоны",
    "gui.howtos.story.step_hidewizard": "Спрятать персонаж",
    "gui.howtos.story.step_showwizard": "Показать персонаж",
    "gui.howtos.make-a-chase-game.name": "Создать игру с погоней",
    "gui.howtos.Chase-Game.step_BG": "Добавьте фон",
    "gui.howtos.chase-game.step_AddOcto": "Добавь спрайт",
    "gui.howtos.make-music.step_LeftRight": "Перемещение вправо и влево при помощи клавиш со стрелками",
    "gui.howtos.Chase-Game.step_UpDown": "Перемещение вверх и вниз при помощи клавиш со стрелками ",
    "gui.howtos.Chase-Game.step_AddStar": "Добавить другой спрайт",
    "gui.howtos.Chase-Game.step_MoveRandom": "Двигаться в случайном направлении",
    "gui.howtos.Chase-Game.step_WhenTouch": "В спрайте осьминога при нажатии проигрывать звук",
    "gui.howtos.Chase-Game.step_ScoreVariable": "Создать переменную счёта",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "В спрайте осьминога при касании добавлять счет",
    "gui.howtos.animate-char.name": "Анимировать персонаж",
    "gui.howtos.animate-char.step_addbg": "Добавьте фон",
    "gui.howtos.animate-char.step_addsprite": "Добавь спрайт",
    "gui.howtos.animate-char.step_saysomething": "Скажите что-нибудь",
    "gui.howtos.animate-char.step_addsound": "Добавьте звук",
    "gui.howtos.animate-char.step_animatetalking": "Анимировать разговор",
    "gui.howtos.animate-char.step_arrowkeys": "Двигаться при помощи стрелок",
    "gui.howtos.animate-char.step_jump": "Прыгать",
    "gui.howtos.animate-char.step_changecolor": "Изменить цвет",
    "gui.howtos.make-a-game.name": "Создать игру кликер",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "Выбрать спрайт",
    "gui.howtos.make-a-game.step_GamePlaySound": "Играть звук при нажатии",
    "gui.howtos.make-a-game.step_GameAddScore": "Создать переменную счёта",
    "gui.howtos.make-a-game.step_GameChangeScore": "Увеличить счёт при нажатии",
    "gui.howtos.make-a-game.step_Random": "Перейти к случайной позиции",
    "gui.howtos.make-music.step_GameChangeColor": "Изменить цвет",
    "gui.howtos.make-music.step_ResetScore": "Сбросить счёт",
    "gui.howtos.make-it-fly.name": "Полетаем?",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "Выбери фон с небом",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "Выбери персонаж",
    "gui.howtos.fly.step_stepflySaySomething": "Скажи что-нибудь",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "Перемещайся кнопками стрелок",
    "gui.howtos.fly.step_stepflyChooseObject": "Выбери объект для собирания",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "Заставь объект перемещаться",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "Выбери персонаж",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "Добавь счет",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "Веди счет",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "Добавь пейзаж",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "Перемещай пейзаж",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "Следующий костюм",
    "gui.howtos.pong": "Игра в пинг-понг",
    "gui.howtos.pong.step_pongAddBackdrop": "Добавь фон",
    "gui.howtos.pong.step_pongAddBallSprite": "Добавь спрайт Ball (мяч)",
    "gui.howtos.pong.step_pongBounceAround": "Прыгай туда-сюда",
    "gui.howtos.pong.step_pongAddPaddle": "Добавь ракетку",
    "gui.howtos.pong.step_pongMoveThePaddle": "Перемещай ракетку",
    "gui.howtos.pong.step_pongSelectBallSprite": "Выбери спрайт Ball (мяч).",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "Добавь команды чтобы отражать мяч ракеткой ",
    "gui.howtos.pong.step_pongAddAScore": "Добавь счет",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "Выбери ‘Счет’ из меню.",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "Добавь блок ‘Изменить Счет’",
    "gui.howtos.pong.step_pongResetScore": "Сбросить счёт",
    "gui.howtos.pong.step_pongAddLineSprite": "Добавь спрайт Line (линия)",
    "gui.howtos.pong.step_pongGameOver": "Конец игры",
    "gui.howtos.code-cartoon": "Запрограммируй мультфильм",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Скажи что-нибудь, когда нажмешь на зеленый флаг",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Оживи персонаж нажатием",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Выбери другой персонаж",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Используй знак минус для уменьшения объекта",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Заставь персонаж расти и уменьшаться",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Выбери другой персонаж",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Попрыгай вверх-вниз",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Нажимай на персонаж для смены сцен",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Поплавай вокруг",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Меняй костюмы",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Выбери больше персонажей для добавления в мультфильм",
    "gui.howtos.cartoon-network": "Анимируй игру-приключение",
    "gui.howtos.cartoon-network.step_CNcharacter": "Выбери персонажа для шоу",
    "gui.howtos.cartoon-network.step_CNsay": "Скажите что-нибудь",
    "gui.howtos.cartoon-network.step_CNglide": "Плавное движение",
    "gui.howtos.cartoon-network.step_CNpicksprite": "Выберите объект для преследования",
    "gui.howtos.cartoon-network.step_CNcollect": "Собирай объекты",
    "gui.howtos.cartoon-network.step_CNvariable": "Сделай переменную счёта",
    "gui.howtos.cartoon-network.step_CNscore": "Продолжай подсчитывать",
    "gui.howtos.cartoon-network.step_CNbackdrop": "Новый уровень: Измени фон ",
    "gui.howtos.videosens.name": "Видео распознавание",
    "gui.howtos.videosens.step_addextension": "Добавить расширение",
    "gui.howtos.videosens.step_pet": "Приручи кота",
    "gui.howtos.videosens.step_animate": "Анимировать",
    "gui.howtos.videosens.step_pop": "Хлопнуть шарик",
    "gui.howtos.say-it-out-loud": "Создать говорящую анимацию",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "Добавить блоки \"Текста в Речь\"",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "Скажи что-нибудь",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "Установить голос",
    "gui.howtos.say-it-out-loud.step_TXTMove": "Кружить",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "Добавьте фон",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "Добавить другого персонажа",
    "gui.howtos.say-it-out-loud.step_TXTSong": "Исполнить песню",
    "gui.howtos.say-it-out-loud.step_TXTColor": "Изменить цвет",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "Покрутить",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "Расти и уменьшаться",
    "gui.howtos.talking": "Говорящие сказки",
    "gui.howtos.talking.step_talesAddExtension": "Нажми для добавления блоков Текст-в-Речь",
    "gui.howtos.talking.step_talesChooseSprite": "Выбери спрайт",
    "gui.howtos.talking.step_talesSaySomething": "Заставь персонаж говорить",
    "gui.howtos.talking.step_talesChooseBackdrop": "Выбери фон",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Нажми на персонаж для перехода к следующему фону",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Выбери другой спрайт",
    "gui.howtos.talking.step_talesMoveAround": "Перемещайся поблизости",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Выбери другой фон",
    "gui.howtos.talking.step_talesAnimateTalking": "Оживи разговор",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Выбери другой фон",
    "gui.howtos.talking.step_talesChooseSound": "Выбери песню чтобы потанцевать под нее",
    "gui.howtos.talking.step_talesDanceMoves": "Танцевальные движения",
    "gui.howtos.talking.step_talesAskAnswer": "Используй блоки \"спросить\" и \"ответ\" из категории Сенсоры",
    "gui.howtos.add-sprite.name": "Добавь спрайт",
    "gui.howtos.add-sprite.step_addSprite": "Добавь спрайт",
    "gui.howtos.add-a-backdrop.name": "Добавьте фон",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "Добавь фон",
    "gui.howtos.change-size.name": "Изменить размер",
    "gui.howtos.change-size.step_changeSize": "Меняй размер",
    "gui.howtos.glide-around.name": "Плыть кругом",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "Поплавай вокруг",
    "gui.howtos.change-size.step_glideAroundPoint": "Плыви к точке",
    "gui.howtos.record-a-sound.name": "Записать звук",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "Щелкни на вкладке ‘Звуки’.",
    "gui.howtos.change-size.step_recordASoundClickRecord": "Нажми ‘Записать’.",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "Нажми на кнопку Записать",
    "gui.howtos.change-size.step_recordASoundChooseSound": "Выбери звук",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "Играй звук",
    "gui.howtos.spin-video.name": "Сделать вращение",
    "gui.howtos.change-size.step_spinTurn": "Повернись",
    "gui.howtos.change-size.step_spinPointInDirection": "Установи направление",
    "gui.howtos.hide-and-show.name": "Скрыть и показать",
    "gui.howtos.change-size.step_hideAndShow": "Скрыть и показать",
    "gui.howtos.switch-costume.name": "Анимировать спрайт",
    "gui.howtos.change-size.step_switchCostumes": "Оживи спрайт",
    "gui.howtos.move-around-with-arrow-keys.name": "Используй клавиши со стрелками",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "Перемещайся влево и вправо",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "Перемещайся вверх и вниз",
    "gui.howtos.add-effects.name": "Добавь эффекты",
    "gui.howtos.videosens.step_addEffects": "Добавь эффекты",
    "gui.device.esp32.description": "Плата управления Wi-Fi и Bluetooth с богатыми функциями.",
    "gui.device.esp32.connectingMessage": "Подключение",
    "gui.device.esp8266NodeMCU.description": "Недорогая плата Wi-Fi  для управления",
    "gui.device.esp8266NodeMCU.connectingMessage": "Подключение",
    "gui.device.unselectDevice.name": "Отменить выбор устройства",
    "gui.device.unselectDevice.description": "Отмените выбор устройства, вернитесь в режим программирования в реальном времени.",
    "gui.device.arduinoUno.description": "Отличная плата для начала работы с электроникой и программированием.",
    "gui.device.arduinoUno.connectingMessage": "Подключение",
    "gui.device.arduinoNano.description": "Arduino Nano — это классическая небольшая плата для создания ваших проектов.",
    "gui.device.arduinoNano.connectingMessage": "Подключение",
    "gui.device.arduinoLeonardo.description": "Классическая плата Arduino, которая может передавать данные в компьютер как мышь или клавиатура.",
    "gui.device.arduinoLeonardo.connectingMessage": "Подключение",
    "gui.device.arduinoMega2560.description": "8-битная плата с 54 цифровыми пинами, 16 аналоговыми входам и и 4 последовательными портами.",
    "gui.device.arduinoMega2560.connectingMessage": "Подключение",
    "gui.device.microbit.description": "Карманный компьютер меняющий процесс обучения цифровым навыкам.",
    "gui.device.microbit.connectingMessage": "Подключение",
    "gui.device.microbitV2.description": "Улучшенный процессор, встроенный динамик и микрофон, сенсорный логотип.",
    "gui.device.microbitV2.connectingMessage": "Подключение",
    "gui.device.makeymakey.description": "Превратить что угодно в ключ.",
    "gui.device.makeyMakey.connectingMessage": "Подключение",
    "gui.device.k210MaixDock.description": "Плата на базе микросхемы K210 RISC-V, которая выполняет только основные функции и имеет контакты ввода-вывода.",
    "gui.device.k210MaixDock.connectingMessage": "Подключение",
    "gui.device.k210Maixduino.description": "Плата K210 RISC-V с ESP32 внутри.",
    "gui.device.k210Maixduino.connectingMessage": "Подключение",
    "gui.device.raspberryPiPicoIconURL.description": "Мощная, гибкая плата микроконтроллера.",
    "gui.device.raspberryPiPicoIconURL.connectingMessage": "Подключение",
    "gui.extension.music.name": "Музыка",
    "gui.extension.music.description": "Играть на инструментах и барабанах.",
    "gui.extension.pen.name": "Перо",
    "gui.extension.pen.description": "Рисуй своими спрайтами.",
    "gui.extension.videosensing.name": "Видео распознавание",
    "gui.extension.videosensing.description": "Распознай движение с видео камеры",
    "gui.extension.text2speech.name": "Текст в речь",
    "gui.extension.text2speech.description": "Оживи свои проекты речью!",
    "gui.extension.translate.name": "Перевести",
    "gui.extension.translate.description": "Переводи текст на другие языки.",
    "gui.extension.makeymakey.name": "Makey Makey\n ",
    "gui.extension.makeymakey.description": "Превратить что угодно в ключ.",
    "gui.libraryTags.all": "Все",
    "gui.libraryTags.animals": "Животные",
    "gui.libraryTags.dance": "Танец",
    "gui.libraryTags.effects": "Эффекты",
    "gui.libraryTags.fantasy": "Фантастика",
    "gui.libraryTags.fashion": "Мода",
    "gui.libraryTags.food": "Еда",
    "gui.libraryTags.indoors": "В помещении",
    "gui.libraryTags.loops": "Циклы",
    "gui.libraryTags.music": "Музыка",
    "gui.libraryTags.notes": "Заметки",
    "gui.libraryTags.outdoors": "На открытом воздухе",
    "gui.libraryTags.patterns": "Узоры",
    "gui.libraryTags.people": "Люди",
    "gui.libraryTags.percussion": "Перкуссия",
    "gui.libraryTags.space": "Космос",
    "gui.libraryTags.sports": "Спорт",
    "gui.libraryTags.underwater": "Подводный мир",
    "gui.libraryTags.voice": "Голос",
    "gui.libraryTags.wacky": "Безумцы",
    "gui.libraryTags.animation": "Анимация",
    "gui.libraryTags.art": "Искусство",
    "gui.libraryTags.games": "Игры",
    "gui.libraryTags.stories": "Истории",
    "gui.libraryTags.letters": "Буквы",
    "gui.opcodeLabels.direction": "направление",
    "gui.opcodeLabels.xposition": "положение x",
    "gui.opcodeLabels.yposition": "положение y",
    "gui.opcodeLabels.size": "размер",
    "gui.opcodeLabels.costumename": "имя костюма",
    "gui.opcodeLabels.costumenumber": "номер костюма",
    "gui.opcodeLabels.backdropname": "имя фона",
    "gui.opcodeLabels.backdropnumber": "номер фона",
    "gui.opcodeLabels.volume": "громкость",
    "gui.opcodeLabels.tempo": "темп",
    "gui.opcodeLabels.answer": "ответ",
    "gui.opcodeLabels.loudness": "громкость",
    "gui.opcodeLabels.username": "имя пользователя",
    "gui.opcodeLabels.year": "год",
    "gui.opcodeLabels.month": "месяц",
    "gui.opcodeLabels.date": "дата",
    "gui.opcodeLabels.dayofweek": "день недели",
    "gui.opcodeLabels.hour": "час",
    "gui.opcodeLabels.minute": "минута",
    "gui.opcodeLabels.second": "секунда",
    "gui.opcodeLabels.timer": "таймер",
    "gui.projectLoader.loadError": "Не удалось загрузить файл проекта, который был выбран.",
    "gui.sharedMessages.backdrop": "фон {index}",
    "gui.sharedMessages.costume": "костюм {index}",
    "gui.sharedMessages.sprite": "Спрайт {index}",
    "gui.sharedMessages.pop": "поп",
    "gui.sharedMessages.replaceProjectWarning": "Заменить содержимое текущего проекта?",
    "gui.sharedMessages.clearCacheWarning": "Убедитесь, что вы хотите очистить кеш и перезапустить?",
    "gui.sharedMessages.loadFromComputerTitle": "Загрузить с компьютера",
    "gui.gui.defaultProjectTitle": "Проект Scratch",
    "gui.desktopMenuBar.about": "О программе",
    "gui.desktopMenuBar.license": "Лицензия",
    "gui.menuBar.privacyPolicy": "Политика конфиденциальности",
    "gui.menuBar.dataSettings": "Настройки данных",
    "arduinoEsp32.InterrupModeMenu.changeEdge": "Изменить край",
    "arduinoEsp32.InterrupModeMenu.fallingEdge": "падающий край",
    "arduinoEsp32.InterrupModeMenu.high": "Высокий уровень",
    "arduinoEsp32.InterrupModeMenu.low": "Низкий уровень",
    "arduinoEsp32.InterrupModeMenu.risingEdge": "поднимающийся край",
    "arduinoEsp32.category.data": "Данные",
    "arduinoEsp32.category.pins": "Пины",
    "arduinoEsp32.category.serial": "Последовательный порт",
    "arduinoEsp32.data.dataConstrain": "ограничить [DATA] между ([ARG0], [ARG1])",
    "arduinoEsp32.data.dataConvert": "преобразовать [DATA] в [TYPE]",
    "arduinoEsp32.data.dataConvertASCIICharacter": "преобразовать [DATA] в символ ASCII",
    "arduinoEsp32.data.dataConvertASCIINumber": "преобразовать [DATA] в число ASCII",
    "arduinoEsp32.data.dataMap": "сопоставить [DATA] с ([ARG0], [ARG1]) на ([ARG2], [ARG3])",
    "arduinoEsp32.dataTypeMenu.decimal": "десятичное",
    "arduinoEsp32.dataTypeMenu.integer": "целое",
    "arduinoEsp32.dataTypeMenu.string": "строка",
    "arduinoEsp32.eolMenu.noWarp": "не переносить",
    "arduinoEsp32.eolMenu.warp": "перенос",
    "arduinoEsp32.levelMenu.high": "высокий",
    "arduinoEsp32.levelMenu.low": "низкий",
    "arduinoEsp32.modeMenu.input": "ввод",
    "arduinoEsp32.modeMenu.inputPulldown": "ввод подтягивается к нулю",
    "arduinoEsp32.modeMenu.inputPullup": "ввод подтягивается к питанию",
    "arduinoEsp32.modeMenu.output": "вывод",
    "arduinoEsp32.pins.esp32AttachInterrupt": "подключить прерывания на [PIN] в режиме [MODE] и выполнить",
    "arduinoEsp32.pins.esp32DetachInterrupt": "отсоединить контакт прерывания [PIN]",
    "arduinoEsp32.pins.esp32ReadTouchPin": "читать сенсорный пин [PIN]",
    "arduinoEsp32.pins.esp32SetDACOutput": "установить ЦАП пин [PIN] в [OUT]",
    "arduinoEsp32.pins.esp32SetPwmOutput": "установить ШИМ пин [PIN] на канале [CH] на выходе [OUT]",
    "arduinoEsp32.pins.readAnalogPin": "читать аналоговый вывод [PIN]",
    "arduinoEsp32.pins.readDigitalPin": "читать цифровой пин [PIN]",
    "arduinoEsp32.pins.setDigitalOutput": "установить цифровой пин [PIN] на [LEVEL]",
    "arduinoEsp32.pins.setPinMode": "установить пин [PIN] в режим [MODE]",
    "arduinoEsp32.pins.setServoOutput": "установить серво пин [PIN] на канале [CH] на выход [OUT]",
    "arduinoEsp32.serial.multiSerialAvailable": "Последовательного порта [NO] доступная длина данных",
    "arduinoEsp32.serial.multiSerialBegin": "Последовательного порта [NO] начальная скорость [VALUE]",
    "arduinoEsp32.serial.multiSerialPrint": "В последовательный порт  [NO] печатать [VALUE] [EOL]",
    "arduinoEsp32.serial.multiSerialReadAByte": "Из последовательного порта [NO] прочитать байт",
    "arduinoEsp8266.InterrupModeMenu.changeEdge": "Изменить край",
    "arduinoEsp8266.InterrupModeMenu.fallingEdge": "падающий край",
    "arduinoEsp8266.InterrupModeMenu.risingEdge": "поднимающийся край",
    "arduinoEsp8266.category.data": "Данные",
    "arduinoEsp8266.category.pins": "Пины",
    "arduinoEsp8266.category.serial": "Последовательный порт",
    "arduinoEsp8266.data.dataConstrain": "ограничить [DATA] между ([ARG0], [ARG1])",
    "arduinoEsp8266.data.dataConvert": "преобразовать [DATA] в [TYPE]",
    "arduinoEsp8266.data.dataConvertASCIICharacter": "преобразовать [DATA] в символ ASCII",
    "arduinoEsp8266.data.dataConvertASCIINumber": "преобразовать [DATA] в число ASCII",
    "arduinoEsp8266.data.dataMap": "сопоставить [DATA] с ([ARG0], [ARG1]) на ([ARG2], [ARG3])",
    "arduinoEsp8266.dataTypeMenu.decimal": "десятичное",
    "arduinoEsp8266.dataTypeMenu.integer": "целое",
    "arduinoEsp8266.dataTypeMenu.string": "строка",
    "arduinoEsp8266.eolMenu.noWarp": "не переносить",
    "arduinoEsp8266.eolMenu.warp": "перенос",
    "arduinoEsp8266.levelMenu.high": "высокий",
    "arduinoEsp8266.levelMenu.low": "низкий",
    "arduinoEsp8266.modeMenu.input": "ввод",
    "arduinoEsp8266.modeMenu.inputPullup": "ввод подтягивается к питанию",
    "arduinoEsp8266.modeMenu.output": "вывод",
    "arduinoEsp8266.pins.detachInterrupt": "отсоединить контакт прерывания [PIN]",
    "arduinoEsp8266.pins.esp8266AttachInterrupt": "подключить прерывания на [PIN] в режиме [MODE] и выполнить",
    "arduinoEsp8266.pins.readAnalogPin": "читать аналоговый вывод [PIN]",
    "arduinoEsp8266.pins.readDigitalPin": "читать цифровой пин [PIN]",
    "arduinoEsp8266.pins.setDigitalOutput": "установить цифровой пин [PIN] на [LEVEL]",
    "arduinoEsp8266.pins.setPinMode": "установить пин [PIN] режим [MODE]",
    "arduinoEsp8266.pins.setPwmOutput": "установить ШИМ пин [PIN] в [OUT]",
    "arduinoEsp8266.pins.setServoOutput": "установить серво пин [PIN] в [OUT]",
    "arduinoEsp8266.serial.serialAvailable": "доступная длина данных последовательного порта",
    "arduinoEsp8266.serial.serialBegin": "скорость последовательного порта [VALUE]",
    "arduinoEsp8266.serial.serialPrint": "В последовательный порт печатать [VALUE] [EOL]\n ",
    "arduinoEsp8266.serial.serialReadAByte": "Из последовательного порта прочитать байт",
    "arduinoK210.InterrupModeMenu.changeEdge": "Изменить край",
    "arduinoK210.InterrupModeMenu.fallingEdge": "падающий край",
    "arduinoK210.InterrupModeMenu.high": "Высокий уровень",
    "arduinoK210.InterrupModeMenu.low": "Низкий уровень",
    "arduinoK210.InterrupModeMenu.risingEdge": "поднимающийся край",
    "arduinoK210.category.data": "Данные",
    "arduinoK210.category.pins": "Пины",
    "arduinoK210.category.serial": "Серийный",
    "arduinoK210.data.dataConstrain": "ограничить [DATA] между ([ARG0], [ARG1])",
    "arduinoK210.data.dataConvert": "преобразовать [DATA] в [TYPE]",
    "arduinoK210.data.dataConvertASCIICharacter": "преобразовать [DATA] в символ ASCII",
    "arduinoK210.data.dataConvertASCIINumber": "преобразовать [DATA] в число ASCII",
    "arduinoK210.data.dataMap": "сопоставить [DATA] с ([ARG0], [ARG1]) на ([ARG2], [ARG3])",
    "arduinoK210.dataTypeMenu.decimal": "десятичное",
    "arduinoK210.dataTypeMenu.integer": "целое",
    "arduinoK210.dataTypeMenu.string": "строка",
    "arduinoK210.eolMenu.noWarp": "не переносить",
    "arduinoK210.eolMenu.warp": "перенос",
    "arduinoK210.levelMenu.high": "высокий",
    "arduinoK210.levelMenu.low": "низкий",
    "arduinoK210.modeMenu.input": "ввод",
    "arduinoK210.modeMenu.inputPulldown": "ввод подтягивается к нулю",
    "arduinoK210.modeMenu.inputPullup": "ввод подтягивается к питанию",
    "arduinoK210.modeMenu.output": "вывод",
    "arduinoK210.pins.attachInterrupt": "подключить прерывания на [PIN] в режиме [MODE] и выполнить",
    "arduinoK210.pins.detachInterrupt": "отсоединить контакт прерывания [PIN]",
    "arduinoK210.pins.readDigitalPin": "читать цифровой пин [PIN]",
    "arduinoK210.pins.setDigitalOutput": "установить цифровой пин [PIN] на [LEVEL]",
    "arduinoK210.pins.setPinMode": "установить пин [PIN] режим [MODE]",
    "arduinoK210.pins.setPwmOutput": "установить ШИМ пин [PIN] в [OUT]",
    "arduinoK210.pins.setServoOutput": "установить серво пин [PIN] в [OUT]",
    "arduinoK210.serial.multiSerialAvailable": "серийный [NO] доступная длина данных",
    "arduinoK210.serial.multiSerialBegin": "Последовательного порта [NO] начать со скоростью передачи данных  [BAUD] пины RX [RX_PIN] TX [TX_PIN]\n ",
    "arduinoK210.serial.multiSerialPrint": "серийный номер [NO] печать [VALUE] [EOL]",
    "arduinoK210.serial.multiSerialReadAByte": "серийный номер [NO] прочитать байт",
    "arduinoLeonardo.InterrupModeMenu.changeEdge": "Изменить край",
    "arduinoLeonardo.InterrupModeMenu.fallingEdge": "падающий край",
    "arduinoLeonardo.InterrupModeMenu.low": "низкий",
    "arduinoLeonardo.InterrupModeMenu.risingEdge": "поднимающийся край",
    "arduinoLeonardo.category.data": "Данные",
    "arduinoLeonardo.category.pins": "Пины",
    "arduinoLeonardo.category.serial": "Серийный",
    "arduinoLeonardo.data.dataConstrain": "ограничить [DATA] между ([ARG0], [ARG1])",
    "arduinoLeonardo.data.dataConvert": "преобразовать [DATA] в [TYPE]",
    "arduinoLeonardo.data.dataConvertASCIICharacter": "преобразовать [DATA] в символ ASCII",
    "arduinoLeonardo.data.dataConvertASCIINumber": "преобразовать [DATA] в число ASCII",
    "arduinoLeonardo.data.dataMap": "сопоставить [DATA] с ([ARG0], [ARG1]) на ([ARG2], [ARG3])",
    "arduinoLeonardo.dataTypeMenu.decimal": "десятичное",
    "arduinoLeonardo.dataTypeMenu.integer": "целое",
    "arduinoLeonardo.dataTypeMenu.string": "строка",
    "arduinoLeonardo.eolMenu.noWarp": "не переносить",
    "arduinoLeonardo.eolMenu.warp": "перенос",
    "arduinoLeonardo.levelMenu.high": "высокий",
    "arduinoLeonardo.levelMenu.low": "низкий",
    "arduinoLeonardo.modeMenu.input": "ввод",
    "arduinoLeonardo.modeMenu.inputPullup": "ввод подтягивается к питанию",
    "arduinoLeonardo.modeMenu.output": "вывод",
    "arduinoLeonardo.pins.attachInterrupt": "подключить прерывания на [PIN] в режиме [MODE] и выполнить",
    "arduinoLeonardo.pins.detachInterrupt": "отсоединить контакт прерывания [PIN]",
    "arduinoLeonardo.pins.readAnalogPin": "читать аналоговый вывод [PIN]",
    "arduinoLeonardo.pins.readDigitalPin": "читать цифровой пин [PIN]",
    "arduinoLeonardo.pins.setDigitalOutput": "установить цифровой пин [PIN] на [LEVEL]",
    "arduinoLeonardo.pins.setPinMode": "установить пин [PIN] режим [MODE]",
    "arduinoLeonardo.pins.setPwmOutput": "установить ШИМ пин [PIN] в [OUT]",
    "arduinoLeonardo.pins.setServoOutput": "установить серво пин [PIN] в [OUT]",
    "arduinoLeonardo.serial.serialAvailable": "доступная длина данных серийного порта",
    "arduinoLeonardo.serial.serialBegin": "скорость последовательного порта [VALUE]",
    "arduinoLeonardo.serial.serialPrint": "В последовательный порт печатать [VALUE] [EOL]\n ",
    "arduinoLeonardo.serial.serialReadAByte": "Из последовательного порта прочитать байт",
    "arduinoMega2560.InterrupModeMenu.changeEdge": "Изменить край",
    "arduinoMega2560.InterrupModeMenu.fallingEdge": "падающий край",
    "arduinoMega2560.InterrupModeMenu.low": "низкий",
    "arduinoMega2560.InterrupModeMenu.risingEdge": "поднимающийся край",
    "arduinoMega2560.category.data": "Данные",
    "arduinoMega2560.category.pins": "Пины",
    "arduinoMega2560.category.serial": "Серийный",
    "arduinoMega2560.data.dataConstrain": "ограничить [DATA] между ([ARG0], [ARG1])",
    "arduinoMega2560.data.dataConvert": "преобразовать [DATA] в [TYPE]",
    "arduinoMega2560.data.dataConvertASCIICharacter": "преобразовать [DATA] в символ ASCII",
    "arduinoMega2560.data.dataConvertASCIINumber": "преобразовать [DATA] в число ASCII",
    "arduinoMega2560.data.dataMap": "сопоставить [DATA] с ([ARG0], [ARG1]) на ([ARG2], [ARG3])",
    "arduinoMega2560.dataTypeMenu.decimal": "десятичное",
    "arduinoMega2560.dataTypeMenu.integer": "целое",
    "arduinoMega2560.dataTypeMenu.string": "строка",
    "arduinoMega2560.eolMenu.noWarp": "не переносить",
    "arduinoMega2560.eolMenu.warp": "перенос",
    "arduinoMega2560.levelMenu.high": "высокий",
    "arduinoMega2560.levelMenu.low": "низкий",
    "arduinoMega2560.modeMenu.input": "ввод",
    "arduinoMega2560.modeMenu.inputPullup": "ввод подтягивается к питанию",
    "arduinoMega2560.modeMenu.output": "вывод",
    "arduinoMega2560.pins.attachInterrupt": "подключить прерывания на [PIN] в режиме [MODE] и выполнить",
    "arduinoMega2560.pins.detachInterrupt": "отсоединить контакт прерывания [PIN]",
    "arduinoMega2560.pins.readAnalogPin": "читать аналоговый вывод [PIN]",
    "arduinoMega2560.pins.readDigitalPin": "читать цифровой пин [PIN]",
    "arduinoMega2560.pins.setDigitalOutput": "установить цифровой пин [PIN] на [LEVEL]",
    "arduinoMega2560.pins.setPinMode": "установить пин [PIN] режим [MODE]",
    "arduinoMega2560.pins.setPwmOutput": "установить ШИМ пин [PIN] в [OUT]",
    "arduinoMega2560.pins.setServoOutput": "установить серво пин [PIN] в [OUT]",
    "arduinoMega2560.serial.multiSerialAvailable": "серийный [NO] доступная длина данных",
    "arduinoMega2560.serial.multiSerialBegin": "серийный номер [NO] начальная скорость [VALUE]",
    "arduinoMega2560.serial.multiSerialPrint": "серийный номер [NO] печать [VALUE] [EOL]",
    "arduinoMega2560.serial.multiSerialReadAByte": "серийный номер [NO] прочитать байт",
    "arduinoPeripheral.connection.connectFirmataTimeout": "Тайм-аут при попытке подключения Firmata, сначала загрузите прошивку",
    "arduinoRaspberryPiPico.InterrupModeMenu.changeEdge": "Изменить край",
    "arduinoRaspberryPiPico.InterrupModeMenu.fallingEdge": "падающий край",
    "arduinoRaspberryPiPico.InterrupModeMenu.high": "Высокий уровень",
    "arduinoRaspberryPiPico.InterrupModeMenu.low": "Низкий уровень",
    "arduinoRaspberryPiPico.InterrupModeMenu.risingEdge": "поднимающийся край",
    "arduinoRaspberryPiPico.category.data": "Данные",
    "arduinoRaspberryPiPico.category.pins": "Пины",
    "arduinoRaspberryPiPico.category.serial": "Серийный",
    "arduinoRaspberryPiPico.data.dataConstrain": "ограничить [DATA] между ([ARG0], [ARG1])",
    "arduinoRaspberryPiPico.data.dataConvert": "преобразовать [DATA] в [TYPE]",
    "arduinoRaspberryPiPico.data.dataConvertASCIICharacter": "преобразовать [DATA] в символ ASCII",
    "arduinoRaspberryPiPico.data.dataConvertASCIINumber": "преобразовать [DATA] в число ASCII",
    "arduinoRaspberryPiPico.data.dataMap": "сопоставить [DATA] с ([ARG0], [ARG1]) на ([ARG2], [ARG3])",
    "arduinoRaspberryPiPico.dataTypeMenu.decimal": "десятичное",
    "arduinoRaspberryPiPico.dataTypeMenu.integer": "целое",
    "arduinoRaspberryPiPico.dataTypeMenu.string": "строка",
    "arduinoRaspberryPiPico.eolMenu.noWarp": "не переносить",
    "arduinoRaspberryPiPico.eolMenu.warp": "перенос",
    "arduinoRaspberryPiPico.levelMenu.high": "высокий",
    "arduinoRaspberryPiPico.levelMenu.low": "низкий",
    "arduinoRaspberryPiPico.modeMenu.input": "ввод",
    "arduinoRaspberryPiPico.modeMenu.inputPulldown": "ввод подтягивается к нулю",
    "arduinoRaspberryPiPico.modeMenu.inputPullup": "ввод подтягивается к питанию",
    "arduinoRaspberryPiPico.modeMenu.output": "вывод",
    "arduinoRaspberryPiPico.pins.attachInterrupt": "подключить прерывания на [PIN] в режиме [MODE] и выполнить",
    "arduinoRaspberryPiPico.pins.detachInterrupt": "отсоединить контакт прерывания [PIN]",
    "arduinoRaspberryPiPico.pins.readAnalogPin": "читать аналоговый вывод [PIN]",
    "arduinoRaspberryPiPico.pins.readDigitalPin": "читать цифровой пин [PIN]",
    "arduinoRaspberryPiPico.pins.setDigitalOutput": "установить цифровой пин [PIN] на [LEVEL]",
    "arduinoRaspberryPiPico.pins.setPinMode": "установить пин [PIN] режим [MODE]",
    "arduinoRaspberryPiPico.pins.setPwmOutput": "установить ШИМ пин [PIN] в [OUT]",
    "arduinoRaspberryPiPico.pins.setServoOutput": "установить серво пин [PIN] в [OUT]",
    "arduinoRaspberryPiPico.serial.multiSerialAvailable": "серийный [NO] доступная длина данных",
    "arduinoRaspberryPiPico.serial.multiSerialPrint": "серийный номер [NO] печать [VALUE] [EOL]",
    "arduinoRaspberryPiPico.serial.multiSerialReadAByte": "серийный номер [NO] прочитать байт",
    "arduinoRaspberryPiPico.serial.raspberryPiPicoMultiSerialBegin": "серийный номер [NO] начальная скорость [VALUE]",
    "arduinoUno.InterrupModeMenu.changeEdge": "Изменить край",
    "arduinoUno.InterrupModeMenu.fallingEdge": "падающий край",
    "arduinoUno.InterrupModeMenu.low": "низкий",
    "arduinoUno.InterrupModeMenu.risingEdge": "поднимающийся край",
    "arduinoUno.category.data": "Данные",
    "arduinoUno.category.pins": "Пины",
    "arduinoUno.category.serial": "Серийный",
    "arduinoUno.data.dataConstrain": "ограничить [DATA] между ([ARG0], [ARG1])",
    "arduinoUno.data.dataConvert": "преобразовать [DATA] в [TYPE]",
    "arduinoUno.data.dataConvertASCIICharacter": "преобразовать [DATA] в символ ASCII",
    "arduinoUno.data.dataConvertASCIINumber": "преобразовать [DATA] в число ASCII",
    "arduinoUno.data.dataMap": "сопоставить [DATA] с ([ARG0], [ARG1]) на ([ARG2], [ARG3])",
    "arduinoUno.dataTypeMenu.decimal": "десятичное",
    "arduinoUno.dataTypeMenu.integer": "целое",
    "arduinoUno.dataTypeMenu.string": "строка",
    "arduinoUno.eolMenu.noWarp": "не переносить",
    "arduinoUno.eolMenu.warp": "перенос",
    "arduinoUno.levelMenu.high": "высокий",
    "arduinoUno.levelMenu.low": "низкий",
    "arduinoUno.modeMenu.input": "ввод",
    "arduinoUno.modeMenu.inputPullup": "ввод подтягивается к питанию",
    "arduinoUno.modeMenu.output": "вывод",
    "arduinoUno.pins.attachInterrupt": "подключить прерывания на [PIN] в режиме [MODE] и выполнить",
    "arduinoUno.pins.detachInterrupt": "отсоединить контакт прерывания [PIN]",
    "arduinoUno.pins.readAnalogPin": "читать аналоговый вывод [PIN]",
    "arduinoUno.pins.readDigitalPin": "читать цифровой пин [PIN]",
    "arduinoUno.pins.setDigitalOutput": "установить цифровой пин [PIN] на [LEVEL]",
    "arduinoUno.pins.setPinMode": "установить пин [PIN] режим [MODE]",
    "arduinoUno.pins.setPwmOutput": "установить ШИМ пин [PIN] в [OUT]",
    "arduinoUno.pins.setServoOutput": "установить серво пин [PIN] в [OUT]",
    "arduinoUno.serial.serialAvailable": "доступная длина данных серийного порта",
    "arduinoUno.serial.serialBegin": "скорость последовательного порта [VALUE]",
    "arduinoUno.serial.serialPrint": "В последовательный порт печатать [VALUE] [EOL]\n ",
    "arduinoUno.serial.serialReadAByte": "Из последовательного порта прочитать байт",
    "boost.color.any": "любой цвет",
    "boost.color.black": "черный",
    "boost.color.blue": "синий",
    "boost.color.green": "зеленый",
    "boost.color.red": "красный",
    "boost.color.white": "белый",
    "boost.color.yellow": "желтый",
    "boost.getMotorPosition": "позиция мотора [MOTOR_REPORTER_ID]",
    "boost.getTiltAngle": "угол наклона [TILT_DIRECTION]",
    "boost.motorDirection.backward": "туда",
    "boost.motorDirection.forward": "сюда",
    "boost.motorDirection.reverse": "изменить направление",
    "boost.motorOff": "выключить мотор [MOTOR_ID]",
    "boost.motorOn": "включить мотор [MOTOR_ID]",
    "boost.motorOnFor": "включить мотор [MOTOR_ID] на [DURATION] секунд",
    "boost.motorOnForRotation": "включить мотор [MOTOR_ID] на [ROTATION] оборотов",
    "boost.seeingColor": "виден [COLOR] кирпич?",
    "boost.setLightHue": "установить цвет лампочки [HUE]",
    "boost.setMotorDirection": "установить направление мотора [MOTOR_ID] в [MOTOR_DIRECTION]",
    "boost.setMotorPower": "установить скорость [MOTOR_ID] в [POWER] %",
    "boost.tiltDirection.any": "любая",
    "boost.tiltDirection.down": "вниз",
    "boost.tiltDirection.left": "налево",
    "boost.tiltDirection.right": "направо",
    "boost.tiltDirection.up": "вверх",
    "boost.whenColor": "когда виден [COLOR] кирпич",
    "boost.whenTilted": "когда наклонён [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "играть ноту [NOTE] [TIME] секунд",
    "ev3.buttonPressed": "кнопка [PORT] нажата?",
    "ev3.getBrightness": "яркость",
    "ev3.getDistance": "расстояние",
    "ev3.getMotorPosition": "позиция мотора [PORT]",
    "ev3.motorSetPower": "мотор [PORT] установить мощность [POWER] %",
    "ev3.motorTurnClockwise": "мотор [PORT] повернуть сюда на [TIME] секунд",
    "ev3.motorTurnCounterClockwise": "мотор [PORT] повернуть туда на [TIME] секунд",
    "ev3.whenBrightnessLessThan": "когда яркость < [DISTANCE]",
    "ev3.whenButtonPressed": "когда кнопка [PORT] нажата",
    "ev3.whenDistanceLessThan": "когда расстояние < [DISTANCE]",
    "gdxfor.getAcceleration": "ускорение [DIRECTION]",
    "gdxfor.getForce": "сила",
    "gdxfor.getSpin": "скорость вращения [DIRECTION]",
    "gdxfor.getTilt": "угол наклона [TILT]",
    "gdxfor.isFreeFalling": "падение?",
    "gdxfor.isTilted": "наклонён [TILT]?",
    "gdxfor.pulled": "вытянут",
    "gdxfor.pushed": "нажат",
    "gdxfor.shaken": "встряхнут",
    "gdxfor.startedFalling": "начал падать",
    "gdxfor.tiltDirectionMenu.any": "любая",
    "gdxfor.tiltDirectionMenu.back": "задний",
    "gdxfor.tiltDirectionMenu.front": "передний",
    "gdxfor.tiltDirectionMenu.left": "левый ",
    "gdxfor.tiltDirectionMenu.right": "правый",
    "gdxfor.turnedFaceDown": "повернут лицом вниз",
    "gdxfor.turnedFaceUp": "повернут лицом вверх",
    "gdxfor.whenForcePushedOrPulled": "когда датчик приложения силы [PUSH_PULL]",
    "gdxfor.whenGesture": "когда [GESTURE]",
    "gdxfor.whenTilted": "когда наклонён [TILT]",
    "makeymakey.downArrow": "стрелка вниз",
    "makeymakey.downArrowShort": "вниз",
    "makeymakey.leftArrow": "стрелка влево",
    "makeymakey.leftArrowShort": "влево",
    "makeymakey.rightArrow": "стрелка вправо",
    "makeymakey.rightArrowShort": "направо",
    "makeymakey.spaceKey": "пробел",
    "makeymakey.upArrow": "стрелка вверх",
    "makeymakey.upArrowShort": "вверх",
    "makeymakey.whenKeyPressed": "когда [KEY] клавиша нажата",
    "makeymakey.whenKeysPressedInOrder": "при нажатии по порядку [SEQUENCE]",
    "microPythonEsp32.InterrupModeMenu.changeEdge": "Изменить край",
    "microPythonEsp32.InterrupModeMenu.fallingEdge": "падающий край",
    "microPythonEsp32.InterrupModeMenu.high": "Высокий уровень",
    "microPythonEsp32.InterrupModeMenu.low": "Низкий уровень",
    "microPythonEsp32.InterrupModeMenu.risingEdge": "поднимающийся край",
    "microPythonEsp32.category.console": "Консоль",
    "microPythonEsp32.category.pins": "Пины",
    "microPythonEsp32.console.consoleInput": "Вывести [TEXT] и прочитать введенные данные\n ",
    "microPythonEsp32.console.consolePrint": "Печатать [TEXT] [EOL]\n ",
    "microPythonEsp32.eolMenu.noWarp": "не переносить",
    "microPythonEsp32.eolMenu.warp": "перенос",
    "microPythonEsp32.levelMenu.high": "высокий",
    "microPythonEsp32.levelMenu.low": "низкий",
    "microPythonEsp32.modeMenu.input": "ввод",
    "microPythonEsp32.modeMenu.inputPulldown": "ввод подтягивается к нулю",
    "microPythonEsp32.modeMenu.inputPullup": "ввод подтягивается к питанию",
    "microPythonEsp32.modeMenu.output": "вывод",
    "microPythonEsp32.pins.esp32AttachInterrupt": "подключить прерывания на [PIN] в режиме [MODE] и выполнить",
    "microPythonEsp32.pins.esp32ReadAnalogPin": "читать аналоговый вывод [PIN]",
    "microPythonEsp32.pins.esp32ReadDigitalPin": "читать цифровой пин [PIN]",
    "microPythonEsp32.pins.esp32ReadTouchPin": "читать сенсорный пин [PIN]",
    "microPythonEsp32.pins.esp32SetDACOutput": "установить ШИМ пин [PIN] в [OUT]",
    "microPythonEsp32.pins.esp32SetDigitalOutput": "установить цифровой пин [PIN] на [LEVEL]",
    "microPythonEsp32.pins.esp32SetPinMode": "установить пин [PIN] режим [MODE]",
    "microPythonEsp32.pins.esp32SetPwmOutput": "установить ШИМ пин [PIN] в [OUT]",
    "microPythonEsp32.pins.setServoOutput": "установить серво пин [PIN] в [OUT]",
    "microPythonEsp8266.category.console": "Консоль",
    "microPythonEsp8266.category.pins": "Пины",
    "microPythonEsp8266.console.consoleInput": "Вывести [TEXT] и прочитать введенные данные\n ",
    "microPythonEsp8266.console.consolePrint": "Печатать [TEXT] [EOL]\n ",
    "microPythonEsp8266.eolMenu.noWarp": "не переносить",
    "microPythonEsp8266.eolMenu.warp": "перенос",
    "microPythonEsp8266.levelMenu.high": "высокий",
    "microPythonEsp8266.levelMenu.low": "низкий",
    "microPythonEsp8266.modeMenu.input": "ввод",
    "microPythonEsp8266.modeMenu.inputPullup": "ввод подтягивается к питанию",
    "microPythonEsp8266.modeMenu.output": "вывод",
    "microPythonEsp8266.pins.esp8266AttachInterrupt": "подключить прерывания на [PIN] в режиме [MODE] и выполнить",
    "microPythonEsp8266.pins.readAnalogPin": "читать аналоговый вывод [PIN]",
    "microPythonEsp8266.pins.readDigitalPin": "читать цифровой пин [PIN]",
    "microPythonEsp8266.pins.setDigitalOutput": "установить цифровой пин [PIN] на [LEVEL]",
    "microPythonEsp8266.pins.setPinMode": "установить пин [PIN] режим [MODE]",
    "microPythonEsp8266.pins.setPwmOutput": "установить ШИМ пин [PIN] в [OUT]",
    "microPythonEsp8266.pins.setServoOutput": "установить серво пин [PIN] в [OUT]",
    "microPythonK210.InterrupModeMenu.changeEdge": "Изменить край",
    "microPythonK210.InterrupModeMenu.fallingEdge": "падающий край",
    "microPythonK210.InterrupModeMenu.risingEdge": "поднимающийся край",
    "microPythonK210.category.console": "Консоль",
    "microPythonK210.category.pins": "Пины",
    "microPythonK210.category.serial": "Серийный",
    "microPythonK210.console.consoleInput": "Вывести [TEXT] и прочитать введенные данные\n ",
    "microPythonK210.console.consolePrint": "Печатать [TEXT] [EOL]\n ",
    "microPythonK210.eolMenu.noWarp": "не переносить",
    "microPythonK210.eolMenu.warp": "перенос",
    "microPythonK210.levelMenu.high": "высокий",
    "microPythonK210.levelMenu.low": "низкий",
    "microPythonK210.modeMenu.input": "ввод",
    "microPythonK210.modeMenu.inputPulldown": "ввод подтягивается к нулю",
    "microPythonK210.modeMenu.inputPullup": "ввод подтягивается к питанию",
    "microPythonK210.modeMenu.output": "вывод",
    "microPythonK210.pins.k210AttachInterrupt": "подключить прерывания на [PIN] в режиме [MODE] и выполнить",
    "microPythonK210.pins.k210SetPinMode": "установить пин [PIN] режим [MODE]",
    "microPythonK210.pins.k210SetPwmOutput": "установить ШИМ пин [PIN] на канале [CH] на выходе [OUT]",
    "microPythonK210.pins.k210SetServoOutput": "установить серво пин [PIN] на канале [CH] на выход [OUT]",
    "microPythonK210.pins.readDigitalPin": "читать цифровой пин [PIN]",
    "microPythonK210.pins.setDigitalOutput": "установить цифровой пин [PIN] на [LEVEL]",
    "microPythonK210.serial.k210SerialBegin": "Последовательного порта [NO] начать со скоростью передачи данных  [BAUD] пины RX [RX_PIN] TX [TX_PIN]\n ",
    "microPythonK210.serial.serialPrint": "серийный номер [NO] печать [VALUE] [EOL]",
    "microPythonK210.serial.serialReadALine": "В последовательном порту [NO] прочитать строку\n ",
    "microPythonRaspberryPiPico.InterrupModeMenu.changeEdge": "Изменить край",
    "microPythonRaspberryPiPico.InterrupModeMenu.fallingEdge": "падающий край",
    "microPythonRaspberryPiPico.InterrupModeMenu.risingEdge": "поднимающийся край",
    "microPythonRaspberryPiPico.category.console": "Консоль",
    "microPythonRaspberryPiPico.category.pins": "Пины",
    "microPythonRaspberryPiPico.category.serial": "Последовательный порт",
    "microPythonRaspberryPiPico.console.consoleInput": "Вывести [TEXT] и прочитать введенные данные\n ",
    "microPythonRaspberryPiPico.console.consolePrint": "Печатать [TEXT] [EOL]\n ",
    "microPythonRaspberryPiPico.eolMenu.noWarp": "не переносить",
    "microPythonRaspberryPiPico.eolMenu.warp": "перенос",
    "microPythonRaspberryPiPico.levelMenu.high": "высокий",
    "microPythonRaspberryPiPico.levelMenu.low": "низкий",
    "microPythonRaspberryPiPico.modeMenu.input": "ввод",
    "microPythonRaspberryPiPico.modeMenu.inputPulldown": "ввод подтягивается к нулю",
    "microPythonRaspberryPiPico.modeMenu.inputPullup": "ввод подтягивается к питанию",
    "microPythonRaspberryPiPico.modeMenu.output": "вывод",
    "microPythonRaspberryPiPico.pins.attachInterrupt": "подключить прерывания на [PIN] в режиме [MODE] и выполнить",
    "microPythonRaspberryPiPico.pins.readAnalogPin": "читать аналоговый вывод [PIN]",
    "microPythonRaspberryPiPico.pins.readDigitalPin": "читать цифровой пин [PIN]",
    "microPythonRaspberryPiPico.pins.setDigitalOutput": "установить цифровой пин [PIN] на [LEVEL]",
    "microPythonRaspberryPiPico.pins.setPinMode": "установить пин [PIN] в режим [MODE]",
    "microPythonRaspberryPiPico.pins.setPwmOutputU16": "установить ШИМ пин [PIN] в [OUT]",
    "microPythonRaspberryPiPico.pins.setServoOutputU16": "установить серво пин [PIN] в [OUT]",
    "microPythonRaspberryPiPico.serial.multiSerialPrint": "В последовательный порт  [NO] печатать [VALUE] [EOL]",
    "microPythonRaspberryPiPico.serial.multiSerialReadALine": "В последовательном порту [NO] прочитать строку\n ",
    "microPythonRaspberryPiPico.serial.raspberryPiPicoSerialBegin": "Последовательного порта [NO] начать со скоростью передачи данных  [BAUD] пины RX [RX_PIN] TX [TX_PIN]\n ",
    "microbit.axisMenu.xAxis": "ось X",
    "microbit.axisMenu.yAxis": "ось Y",
    "microbit.axisMenu.zAxis": "ось Z",
    "microbit.buttonsMenu.any": "любой из",
    "microbit.category.console": "Консоль",
    "microbit.category.display": "Дисплей",
    "microbit.category.pins": "Пины",
    "microbit.category.sensor": "Сенсор",
    "microbit.category.wireless": "Беспроводной",
    "microbit.clearDisplay": "очистить дисплей",
    "microbit.console.consolePrint": "Печатать [TEXT]\n ",
    "microbit.defaultTextToDisplay": "Привет!",
    "microbit.display.clearDisplay": "Очистить экран",
    "microbit.display.lightPixelAt": "свет [STATE] на x: ось [X], y: ось [Y]",
    "microbit.display.show": "Показать [TEXT]\n ",
    "microbit.display.showImage": "Показать изображение [VALUE]\n ",
    "microbit.display.showImageUntil": "Показать изображение [VALUE] на [TIME] сек\n ",
    "microbit.display.showOnPiexlbrightness": "Показать в точке x: [X] axis, y: [Y] axis с яркостью [BRT]\n ",
    "microbit.display.showUntilScrollDone": "показывать [TEXT] до завершения прокрутки",
    "microbit.displaySymbol": "отобразить [MATRIX]",
    "microbit.displayText": "показать текст [TEXT]",
    "microbit.gestruesMenu.faceDown": "лицо вниз",
    "microbit.gestruesMenu.faceUp": "лицо вверх",
    "microbit.gestruesMenu.freefall": "свободное падение",
    "microbit.gestruesMenu.shaken": "когда трясут",
    "microbit.gestruesMenu.tiltedDownward": "наклон вниз",
    "microbit.gestruesMenu.tiltedLeftward": "наклон налево",
    "microbit.gestruesMenu.tiltedRightward": "наклон направо",
    "microbit.gestruesMenu.tiltedUpward": "наклон вверх",
    "microbit.gesturesMenu.jumped": "подпрыгнули",
    "microbit.gesturesMenu.moved": "передвинулись",
    "microbit.gesturesMenu.shaken": "встряхнули",
    "microbit.isButtonPressed": "[BTN] кнопка нажата?",
    "microbit.isTilted": "наклонён [DIRECTION]?",
    "microbit.ledState.off": "выключить",
    "microbit.ledState.on": "включить",
    "microbit.levelMenu.high": "высокий",
    "microbit.levelMenu.low": "низкий",
    "microbit.pinStateMenu.off": "выключить",
    "microbit.pinStateMenu.on": "включить",
    "microbit.pins.pinIsTouched": "Коснулся пина [PIN]",
    "microbit.pins.readAnalogPin": "читать аналоговый вывод [PIN]",
    "microbit.pins.readDigitalPin": "читать цифровой пин [PIN]",
    "microbit.pins.setDigitalOutput": "установить цифровой пин [PIN] на [LEVEL]",
    "microbit.pins.setPwmOutput": "установить ШИМ пин [PIN] в [OUT]",
    "microbit.sensor.axisAcceleration": "Ускорение по оси [AXIS]",
    "microbit.sensor.buttonIsPressed": "Клавиша [KEY] нажата?",
    "microbit.sensor.calibrateCompass": "Калибровать компас",
    "microbit.sensor.compassAngle": "Компас показывает направление ",
    "microbit.sensor.compassMagneticDensity": "Плотность магнитного потока компаса",
    "microbit.sensor.gestureIsX": "Жест [STA]?",
    "microbit.sensor.lightLevel": "Уровень яркости",
    "microbit.sensor.runningTime": "Время работы",
    "microbit.sensor.temperature": "Температура",
    "microbit.tiltAngle": "угол наклона [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "любой из",
    "microbit.tiltDirectionMenu.back": "назад",
    "microbit.tiltDirectionMenu.front": "вперёд",
    "microbit.tiltDirectionMenu.left": "влево",
    "microbit.tiltDirectionMenu.right": "направо",
    "microbit.whenButtonPressed": "когда [BTN] кнопка нажата",
    "microbit.whenGesture": "когда [GESTURE]",
    "microbit.whenPinConnected": "когда подключён пин [PIN]",
    "microbit.whenTilted": "когда наклонён [DIRECTION]",
    "microbit.wireless.closeWirelessCommunication": "Отключить беспроводное соединение",
    "microbit.wireless.openWirelessCommunication": "Включить беспроводное соединение",
    "microbit.wireless.receiveWirelessMessage": "Получить беспроводное сообщение",
    "microbit.wireless.resetWirelessCommunication": "Перезагрузить беспроводное соединение",
    "microbit.wireless.sendWirelessMessage": "Отправить беспроводное сообщение  [TEXT]",
    "microbit.wireless.setWirelessCommunicationChannel": "Установить беспроводной канал на  [CH]",
    "music.categoryName": "Музыка",
    "music.changeTempo": "изменить темп на [TEMPO]",
    "music.drumBass": "(2) Большой барабан",
    "music.drumBongo": "(13) Бонго",
    "music.drumCabasa": "(15) Кабаса",
    "music.drumClaves": "(9) Клаве",
    "music.drumClosedHiHat": "(16) Закрытый Хай-Хэт",
    "music.drumConga": "(14) Конга",
    "music.drumCowbell": "(11) Ковбелл",
    "music.drumCrashCymbal": "(4) Крэш-тарелка",
    "music.drumCuica": "(18) Куика",
    "music.drumGuiro": "(16) Гуиро",
    "music.drumHandClap": "(8) Хлопок",
    "music.drumOpenHiHat": "(5) Открытый Хай-Хет",
    "music.drumSideStick": "(3) Римшот",
    "music.drumSnare": "(1) Малый барабан",
    "music.drumTambourine": "(7) Бубен",
    "music.drumTriangle": "(12) Треугольник",
    "music.drumVibraslap": "(17) Вибраслэп",
    "music.drumWoodBlock": "(10) Коробочка",
    "music.getTempo": "темп",
    "music.instrumentBass": "(6) Бас",
    "music.instrumentBassoon": "(14) Фагот",
    "music.instrumentCello": "(8) Виолончель",
    "music.instrumentChoir": "(15) Хор",
    "music.instrumentClarinet": "(10) Кларнет",
    "music.instrumentElectricGuitar": "(5) Электрогитара",
    "music.instrumentElectricPiano": "(2) Электрическое пианино",
    "music.instrumentFlute": "(12) Флейта",
    "music.instrumentGuitar": "(4) Гитара",
    "music.instrumentMarimba": "(19) Маримба",
    "music.instrumentMusicBox": "(17) Музыкальная шкатулка",
    "music.instrumentOrgan": "(3) Орган",
    "music.instrumentPiano": "(1) Фортепиано",
    "music.instrumentPizzicato": "(7) Пиццикато",
    "music.instrumentSaxophone": "(11) Саксофон",
    "music.instrumentSteelDrum": "(18) Стальной барабан",
    "music.instrumentSynthLead": "(20) Ведущий синтезатор",
    "music.instrumentSynthPad": "(21) Синтезатор с функциями драм-машины",
    "music.instrumentTrombone": "(9) Тромбон",
    "music.instrumentVibraphone": "(16) Вибрафон",
    "music.instrumentWoodenFlute": "(13) Деревянная флейта",
    "music.midiPlayDrumForBeats": "барабану играть [DRUM]  [BEATS] бита",
    "music.midiSetInstrument": "изменить инструмент на [INSTRUMENT]",
    "music.playDrumForBeats": "барабану играть [DRUM]  [BEATS] бита",
    "music.playNoteForBeats": "играй ноту [NOTE] [BEATS] бита",
    "music.restForBeats": "пауза в течение [BEATS] бит",
    "music.setInstrument": "изменить инструмент на [INSTRUMENT]",
    "music.setTempo": "установить темп [TEMPO]",
    "pen.categoryName": "Перо",
    "pen.changeColorParam": "изменить [COLOR_PARAM] пера на [VALUE]",
    "pen.changeHue": "изменить цвет пера на [HUE]",
    "pen.changeShade": "изменить оттенок пера на [SHADE]",
    "pen.changeSize": "изменить размер пера на [SIZE]",
    "pen.clear": "стереть всё",
    "pen.colorMenu.brightness": "яркость",
    "pen.colorMenu.color": "цвет",
    "pen.colorMenu.saturation": "насыщенность",
    "pen.colorMenu.transparency": "прозрачность",
    "pen.penDown": "опустить перо",
    "pen.penUp": "поднять перо",
    "pen.setColor": "установить для пера цвет [COLOR]",
    "pen.setColorParam": "установить [COLOR_PARAM] пера [VALUE]",
    "pen.setHue": "установить цвет пера [HUE]",
    "pen.setShade": "установить оттенок пера [SHADE]",
    "pen.setSize": "установить размер пера [SIZE]",
    "pen.stamp": "печать",
    "speech.defaultWhenIHearValue": "начать движение",
    "speech.extensionName": "Речь в Текст",
    "speech.listenAndWait": "слушать и ждать",
    "speech.speechReporter": "речь",
    "speech.whenIHear": "когда я слышу [PHRASE]",
    "text2speech.alto": "альт",
    "text2speech.categoryName": "Текст в речь",
    "text2speech.defaultTextToSpeak": "привет",
    "text2speech.giant": "гигант",
    "text2speech.kitten": "котенок",
    "text2speech.setLanguageBlock": "установить [LANGUAGE] язык",
    "text2speech.setVoiceBlock": "установить [VOICE] голос",
    "text2speech.speakAndWaitBlock": "сказать [WORDS] ",
    "text2speech.squeak": "писк",
    "text2speech.tenor": "тенор",
    "translate.categoryName": "Перевести",
    "translate.defaultTextToTranslate": "привет",
    "translate.translateBlock": "перевести [WORDS] на [LANGUAGE]",
    "translate.viewerLanguage": "язык",
    "videoSensing.categoryName": "Видео Распознавание",
    "videoSensing.direction": "направление",
    "videoSensing.motion": "движение",
    "videoSensing.off": "выключить",
    "videoSensing.on": "включить",
    "videoSensing.onFlipped": "включить в обратную",
    "videoSensing.setVideoTransparency": "установить прозрачность видео  [TRANSPARENCY]",
    "videoSensing.sprite": "спрайт",
    "videoSensing.stage": "сцена",
    "videoSensing.videoOn": "видео [ATTRIBUTE]  на [SUBJECT]",
    "videoSensing.videoToggle": "включить видео [VIDEO_STATE]",
    "videoSensing.whenMotionGreaterThan": "когда скорость видео > [REFERENCE]",
    "wedo2.getDistance": "расстояние",
    "wedo2.getTiltAngle": "угол наклона[TILT_DIRECTION]",
    "wedo2.isTilted": "наклонён [TILT_DIRECTION_ANY] ?",
    "wedo2.motorDirection.backward": "туда",
    "wedo2.motorDirection.forward": "сюда",
    "wedo2.motorDirection.reverse": "изменить направление",
    "wedo2.motorId.a": "мотор A",
    "wedo2.motorId.all": "все моторы",
    "wedo2.motorId.b": "мотор B",
    "wedo2.motorId.default": "мотор",
    "wedo2.motorOff": "выключить [MOTOR_ID]",
    "wedo2.motorOn": "включить [MOTOR_ID]",
    "wedo2.motorOnFor": "включить [MOTOR_ID] на [DURATION] секунд",
    "wedo2.playNoteFor": "играть ноту [NOTE] [DURATION] секунд",
    "wedo2.setLightHue": "установить цвет лампочки [HUE]",
    "wedo2.setMotorDirection": "установить направление [MOTOR_ID] в [MOTOR_DIRECTION]",
    "wedo2.startMotorPower": "установить мощность [MOTOR_ID] в [POWER]",
    "wedo2.tiltDirection.any": "любая",
    "wedo2.tiltDirection.down": "вниз",
    "wedo2.tiltDirection.left": "влево",
    "wedo2.tiltDirection.right": "направо",
    "wedo2.tiltDirection.up": "вверх",
    "wedo2.whenDistance": "когда расстояние [OP] [REFERENCE]",
    "wedo2.whenTilted": "когда наклонён [TILT_DIRECTION_ANY]",
    "paint.colorPicker.swap": "Заменить",
    "paint.paintEditor.hue": "Цвет",
    "paint.paintEditor.saturation": "Насыщенность",
    "paint.paintEditor.brightness": "Яркость",
    "paint.paintEditor.costume": "Костюм",
    "paint.paintEditor.group": "Группировать",
    "paint.paintEditor.ungroup": "Разгруппировать",
    "paint.paintEditor.undo": "Отменить",
    "paint.paintEditor.redo": "Переделать",
    "paint.paintEditor.forward": "Вперёд",
    "paint.paintEditor.backward": "Назад",
    "paint.paintEditor.front": "На передний план",
    "paint.paintEditor.back": "На задний план",
    "paint.paintEditor.more": "Ещё",
    "paint.modeTools.brushSize": "Размер",
    "paint.modeTools.eraserSize": "Ширина ластика",
    "paint.modeTools.copy": "Копировать",
    "paint.modeTools.paste": "Вставить",
    "paint.modeTools.delete": "Удалить",
    "paint.modeTools.curved": "Изогнуть",
    "paint.modeTools.pointed": "Заострить",
    "paint.modeTools.thickness": "Толщина",
    "paint.modeTools.flipHorizontal": "Отразить по горизонтали",
    "paint.modeTools.flipVertical": "Отразить по вертикали",
    "paint.modeTools.filled": "Залитый",
    "paint.modeTools.outlined": "Обведённый",
    "paint.paintEditor.bitmap": "Конвертировать в растровую графику",
    "paint.paintEditor.vector": "Конвертировать в векторную графику",
    "paint.paintEditor.fill": "Заливка",
    "paint.paintEditor.stroke": "Контур",
    "paint.brushMode.brush": "Кисть",
    "paint.eraserMode.eraser": "Ластик",
    "paint.fillMode.fill": "Заливка",
    "paint.lineMode.line": "Линия",
    "paint.ovalMode.oval": "Круг",
    "paint.rectMode.rect": "Прямоугольник",
    "paint.reshapeMode.reshape": "Изменение формы",
    "paint.roundedRectMode.roundedRect": "Скруглённый Прямоугольник",
    "paint.selectMode.select": "Выбрать",
    "paint.textMode.text": "Текст"
  },
  "zh-cn": {
    "gui.alerts.lostPeripheralConnection": "Scratch与{extensionName}的连接已断开。",
    "gui.alerts.tryAgain": "重试",
    "gui.alerts.download": "下载",
    "gui.connection.reconnect": "重新连接",
    "gui.alerts.uploadFirmware": "上传固件",
    "gui.backpack.costumeLabel": "造型",
    "gui.backpack.soundLabel": "声音",
    "gui.backpack.scriptLabel": "脚本",
    "gui.backpack.spriteLabel": "角色",
    "gui.backpack.header": "书包",
    "gui.backpack.errorBackpack": "载入书包时出错了",
    "gui.backpack.loadingBackpack": "载入中……",
    "gui.backpack.more": "更多",
    "gui.backpack.emptyBackpack": "书包是空的",
    "gui.unsupportedBrowser.label": "不支持当前浏览器",
    "gui.unsupportedBrowser.errorLabel": "出错了",
    "gui.unsupportedBrowser.notRecommended": "我们十分抱歉，Scratch不支持您正在使用的浏览器，我们建议您升级到我们所支持的浏览器的最新版本，例如Chrome、火狐、Edge或者Safari。",
    "gui.unsupportedBrowser.description": "我们十分抱歉，Scratch并不支持您当前使用的浏览器，我们建议您升级到我们所支持的浏览器的最新版，例如Chrome、火狐、Edge或者Safari。",
    "gui.unsupportedBrowser.back": "返回",
    "gui.unsupportedBrowser.previewfaq": "访问{previewFaqLink}，了解更多。",
    "gui.unsupportedBrowser.previewfaqlinktext": "常见问题",
    "gui.cards.all-tutorials": "教程",
    "gui.cards.shrink": "收起",
    "gui.cards.expand": "展开",
    "gui.cards.close": "关闭",
    "gui.cards.more-things-to-try": "再试试这些！",
    "gui.cards.see-more": "更多技巧",
    "gui.comingSoon.message1": "别急，我们还在做这个 {emoji}",
    "gui.comingSoon.message2": "即将启用...",
    "gui.comingSoon.message3": "还在开发 {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "没有发现任何设备",
    "gui.connection.auto-scanning.prescan": "把设备放在边上，然后开始搜索",
    "gui.connection.auto-scanning.pressbutton": "按下设备上的按钮",
    "gui.connection.auto-scanning.start-search": "开始搜索",
    "gui.connection.connecting-searchbutton": "正在搜索……",
    "gui.connection.auto-scanning.try-again": "重试",
    "gui.connection.connected": "已连接",
    "gui.connection.disconnect": "断开连接",
    "gui.connection.go-to-editor": "返回编辑器",
    "gui.connection.connecting-cancelbutton": "正在连接……",
    "gui.connection.accessDeniedError.errorMessage": "糟糕，串口访问被拒绝，请检查串口是否被占用。",
    "gui.connection.unknownErrorCode31.errorMessage": "糟糕，未知错误代码31，建议重新插入设备。",
    "gui.connection.error.errorMessage": "呀，好像出错了。",
    "gui.connection.error.tryagainbutton": "重试",
    "gui.connection.error.helpbutton": "帮助",
    "gui.connection.peripheral-name-label": "设备名称",
    "gui.connection.connect": "连接",
    "gui.connection.scanning.listAll": "显示全部可连接的设备",
    "gui.connection.scanning.lookingforperipherals": "正在查找设备",
    "gui.connection.scanning.noPeripheralsFound": "没有发现任何设备",
    "gui.connection.scanning.instructions": "选择上面列出的设备。",
    "gui.connection.search": "刷新",
    "gui.connection.unavailable.installscratchlink": "确保Scratch Link已安装并正在运行",
    "gui.connection.unavailable.connectUsbEnableBluetooth": "请确认USB线缆已连接或蓝牙已经开启",
    "gui.connection.unavailable.tryagainbutton": "重试",
    "gui.connection.unavailable.helpbutton": "帮助",
    "gui.controls.go": "运行",
    "gui.controls.stop": "停止",
    "gui.crashMessage.label": "呀，出错了。",
    "gui.crashMessage.description": "很抱歉，Scratch出故障了。这个问题已经自动报告给Scratch开发团队。请刷新页面再试试。",
    "gui.crashMessage.errorNumber": "该错误已记录，编号{errorId}",
    "gui.crashMessage.reload": "重新载入",
    "gui.customProcedures.myblockModalTitle": "制作新的积木",
    "gui.customProcedures.addAnInputNumber": "添加输入项",
    "gui.customProcedures.numberType": "数字",
    "gui.customProcedures.addAnInputText": "添加输入项",
    "gui.customProcedures.TextType": "文本",
    "gui.customProcedures.addAnInputBoolean": "添加输入项",
    "gui.customProcedures.booleanType": "布尔值",
    "gui.customProcedures.addALabel": "添加文本标签：",
    "gui.customProcedures.runWithoutScreenRefresh": "运行时不刷新屏幕",
    "gui.customProcedures.cancel": "取消",
    "gui.customProcedures.confirm": "确认",
    "gui.customProcedures.ok": "完成",
    "gui.deviceTypeModal.deviceTypeTitle": "选择编程类型",
    "gui.deviceTypeModal.arduino": "Arduino",
    "gui.deviceTypeModal.python": "Python",
    "gui.deviceTypeModal.microPython": "MicroPython",
    "gui.deviceTypeModal.cancel": "取消",
    "gui.SpriteInfo.direction": "方向",
    "gui.directionPicker.rotationStyles.allAround": "任意旋转",
    "gui.directionPicker.rotationStyles.leftRight": "左右翻转",
    "gui.directionPicker.rotationStyles.dontRotate": "不旋转",
    "gui.gui.addExtension": "添加扩展",
    "gui.gui.codeTab": "代码",
    "gui.gui.backdropsTab": "背景",
    "gui.gui.costumesTab": "造型",
    "gui.gui.soundsTab": "声音",
    "gui.hardwareConsole.send": "发送",
    "gui.hardwareConsole.buadrate": "波特率",
    "gui.hardwareConsole.endOfLine": "行结尾",
    "gui.hardwareConsole.hexform": "16进制格式",
    "gui.hardwareConsole.autoScroll": "自动滚屏",
    "gui.hardwareHeader.upload": "上传",
    "gui.stageHeader.codeStageSizeLarge": "放大舞台",
    "gui.stageHeader.codeStageSizeSmall": "缩小舞台",
    "gui.stageHeader.hideStage": "隐藏舞台",
    "gui.extensionLibrary.comingSoon": "即将启用",
    "gui.extensionLibrary.requires": "系统需求",
    "gui.extensionLibrary.collaboration": "合作者",
    "gui.extensionLibrary.manufactor": "制造商",
    "gui.extensionLibrary.version": "版本",
    "gui.extensionLibrary.author": "作者",
    "gui.extensionLibrary.programMode": "编程模式",
    "gui.extensionLibrary.programLanguage": "编程语言",
    "gui.extensionLibrary.deviceLearnMore": "了解更多",
    "gui.extensionLibrary.extensionHelp": "帮助",
    "gui.extensionLibrary.Processing": "处理中...",
    "gui.extensionLibrary.loaded": "已加载",
    "gui.extensionLibrary.notLoaded": "未加载",
    "gui.library.filterPlaceholder": "搜索",
    "gui.library.allTag": "所有",
    "gui.loader.message1": "正在创建积木……",
    "gui.loader.message2": "载入角色……",
    "gui.loader.message3": "载入声音……",
    "gui.loader.message4": "加载扩展……",
    "gui.loader.message5": "呼唤小猫……",
    "gui.loader.message6": "传送Nano……",
    "gui.loader.message7": "给Gobo充气 …",
    "gui.loader.message8": "准备表情……",
    "gui.loader.headline": "载入作品",
    "gui.loader.creating": "新建作品",
    "gui.accountMenu.profile": "个人资料",
    "gui.accountMenu.myStuff": "我的作品",
    "gui.accountMenu.myClasses": "我的所有班级",
    "gui.accountMenu.myClass": "我的班级",
    "gui.accountMenu.accountSettings": "账号设置",
    "gui.accountMenu.signOut": "登出",
    "gui.authorInfo.byUser": "作者{username}",
    "gui.menuBar.seeProjectPage": "查看作品页面",
    "general.username": "用户名",
    "general.password": "密码",
    "general.signIn": "登录",
    "login.needHelp": "需要帮助？",
    "form.validationRequired": "必填字段",
    "gui.menuBar.settings": "设置",
    "gui.menuBar.language": "语言",
    "gui.menuBar.LanguageSelector": "语言菜单",
    "gui.menuBar.tutorialsLibrary": "教程",
    "gui.menuBar.market": "市场",
    "gui.menuBar.community": "开放社区",
    "gui.menuBar.wiki": "维基",
    "gui.menuBar.colorMode": "色彩模式",
    "gui.menuBar.restoreSprite": "复原删除的角色",
    "gui.menuBar.restoreSound": "复原删除的声音",
    "gui.menuBar.restoreCostume": "复原删除的造型",
    "gui.menuBar.restore": "恢复",
    "gui.menuBar.saveNow": "立即保存",
    "gui.menuBar.saveAsCopy": "另存为副本",
    "gui.menuBar.remix": "改编",
    "gui.menuBar.new": "新作品",
    "gui.menuBar.checkUpdate": "检查更新",
    "gui.menuBar.installDriver": "安装驱动",
    "gui.menuBar.clearCacheAndRestart": "清除缓存并重启",
    "gui.menuBar.file": "文件",
    "gui.menuBar.downloadToComputer": "保存到电脑",
    "gui.menuBar.edit": "编辑",
    "gui.menuBar.publish": "发布",
    "gui.menuBar.turboModeOff": "关闭加速模式",
    "gui.menuBar.turboModeOn": "打开加速模式",
    "gui.menuBar.noDeviceSelected": "未选择设备",
    "gui.menuBar.noConnection": "没有连接",
    "gui.menuBar.uploadFirmware": "上传固件",
    "gui.menu-bar.programMode": "编程模式",
    "gui.gui.projectTitlePlaceholder": "在此填写作品标题",
    "gui.menuBar.saveNowLink": "立即保存",
    "gui.menuBar.isShared": "已分享",
    "gui.menuBar.share": "分享",
    "gui.modal.help": "帮助",
    "gui.modal.back": "返回",
    "gui.theme.default": "默认",
    "gui.theme.highContrast": "高对比",
    "gui.monitor.listMonitor.empty": "(空)",
    "gui.monitor.listMonitor.listLength": "长度{length}",
    "gui.monitor.contextMenu.default": "正常显示",
    "gui.monitor.contextMenu.large": "大字显示",
    "gui.monitor.contextMenu.slider": "滑杆",
    "gui.monitor.contextMenu.sliderRange": "改变滑块范围",
    "gui.monitor.contextMenu.import": "导入",
    "gui.monitor.contextMenu.export": "导出",
    "gui.playButton.play": "播放",
    "gui.playButton.stop": "停止",
    "gui.gui.variableScopeOptionAllSprites": "适用于所有角色",
    "gui.gui.variableScopeOptionSpriteOnly": "仅适用于当前角色",
    "gui.gui.cloudVariableOption": "云变量 (存储在服务器上)",
    "gui.gui.variablePromptAllSpritesMessage": "所有角色都可使用该变量。",
    "gui.gui.listPromptAllSpritesMessage": "所有角色都可使用该列表。",
    "gui.prompt.cancel": "取消",
    "gui.prompt.ok": "确定",
    "gui.playbackStep.stopMsg": "停止",
    "gui.playbackStep.playMsg": "播放",
    "gui.playbackStep.loadingMsg": "载入中……",
    "gui.playbackStep.saveMsg": "保存",
    "gui.playbackStep.reRecordMsg": "重新录制",
    "gui.recordModal.title": "录制声音",
    "gui.recordingStep.beginRecord": "点击下方的按钮开始录制",
    "gui.recordingStep.permission": "{arrow}我们需要你的许可才能使用麦克风。",
    "gui.recordingStep.stop": "停止录制",
    "gui.recordingStep.record": "录制",
    "gui.sliderModal.min": "最小值",
    "gui.sliderModal.max": "最大值",
    "gui.sliderModal.title": "改变滑块范围",
    "gui.sliderPrompt.cancel": "取消",
    "gui.sliderPrompt.ok": "确定",
    "gui.soundEditor.sound": "声音",
    "gui.soundEditor.play": "播放",
    "gui.soundEditor.stop": "停止",
    "gui.soundEditor.copy": "拷贝",
    "gui.soundEditor.paste": "粘贴",
    "gui.soundEditor.copyToNew": "新拷贝",
    "gui.soundEditor.delete": "删除",
    "gui.soundEditor.save": "保存",
    "gui.soundEditor.undo": "撤销",
    "gui.soundEditor.redo": "重做",
    "gui.soundEditor.faster": "快一点",
    "gui.soundEditor.slower": "慢一点",
    "gui.soundEditor.echo": "回声",
    "gui.soundEditor.robot": "机械化",
    "gui.soundEditor.louder": "响一点",
    "gui.soundEditor.softer": "轻一点",
    "gui.soundEditor.reverse": "反转",
    "gui.soundEditor.fadeOut": "渐弱",
    "gui.soundEditor.fadeIn": "渐强",
    "gui.soundEditor.mute": "静音",
    "gui.SpriteInfo.spritePlaceholder": "名字",
    "gui.SpriteInfo.sprite": "角色",
    "gui.SpriteInfo.show": "显示",
    "gui.SpriteInfo.size": "大小",
    "gui.spriteSelectorItem.contextMenuDuplicate": "复制",
    "gui.spriteSelectorItem.contextMenuExport": "导出",
    "gui.spriteSelectorItem.contextMenuDelete": "删除",
    "gui.spriteSelector.addSpriteFromLibrary": "选择一个角色",
    "gui.spriteSelector.addSpriteFromPaint": "绘制",
    "gui.spriteSelector.addSpriteFromSurprise": "随机",
    "gui.spriteSelector.addSpriteFromFile": "上传角色",
    "gui.stageHeader.stageSizeLarge": "放大舞台",
    "gui.stageHeader.stageSizeSmall": "缩小舞台",
    "gui.stageHeader.stageSizeFull": "进入全屏模式",
    "gui.stageHeader.stageSizeUnFull": "退出全屏模式",
    "gui.stageHeader.fullscreenControl": "全屏模式",
    "gui.spriteSelector.addBackdropFromLibrary": "选择一个背景",
    "gui.stageSelector.addBackdropFromPaint": "绘制",
    "gui.stageSelector.addBackdropFromSurprise": "随机",
    "gui.stageSelector.addBackdropFromFile": "上传背景",
    "gui.stageSelector.stage": "舞台",
    "gui.stageSelector.backdrops": "背景",
    "gui.telemetryOptIn.label": "统计使用情况并发送给Scratch",
    "gui.telemetryOptIn.body1": "允许Scratch自动发送使用情况信息给Scratch团队，帮助我们了解Scratch在全世界的使用情况。",
    "gui.telemetryOptIn.body2": "我们收集的信息包括所选语言、积木使用情况以及诸如保存、加载和上传作品等功能的使用情况。我们不会收集任何个人信息。请查看我们的{privacyPolicyLink}了解更多信息。",
    "gui.telemetryOptIn.privacyPolicyLink": "隐私政策",
    "gui.telemetryOptIn.optInText": "与 Openblock 团队分享我的使用数据",
    "gui.telemetryOptIn.optInTooltip": "发送统计信息",
    "gui.telemetryOptIn.optOutText": "不要与 Openblock 团队分享我的使用数据",
    "gui.telemetryOptIn.optOutTooltip": "不发送统计信息",
    "gui.telemetryOptIn.settingWasUpdated": "您的设置已更新。",
    "gui.telemetryOptIn.buttonClose": "关闭",
    "gui.turboMode.active": "加速模式",
    "gui.updateModal.close": "关闭",
    "gui.updateModal.downloading": "下载中",
    "gui.updateModal.abort": "中止",
    "gui.updateModel.tileCheckingForUpdate": "正在检查更新",
    "gui.updateModel.checkingTips": "取决于您的网络，此步骤可能需要几秒钟到十几秒钟，请稍候。",
    "gui.updateModel.tileUpdateExternalResource": "检测到新版本的外部资源",
    "gui.updateModel.tileUpdateApplication": "检测到新版本的此应用程序",
    "gui.updateModal.updateLater": "稍后升级",
    "gui.updateModal.updateAndRestart": "更新并重启",
    "gui.updateModel.tileAlreadyLatest": "未检测到新版本",
    "gui.updateModel.alreadyLatestTips": "Openblock 已经是最新的版本了。",
    "gui.updateModel.tileError": "操作失败",
    "gui.updateModel.upgradingExternalResource": "正在升级外部资源",
    "gui.updateModal.deletingCompressedFile": "正在删除压缩文件",
    "gui.updateModal.deletingCacheFile": "正在删除缓存文件",
    "gui.updateModal.extractingCompressedFile": "正在解压压缩文件",
    "gui.updateModal.verifyingCompressedFile": "正在校验压缩文件",
    "gui.updateModal.verifyingCacheFile": "正在校验缓存文件",
    "gui.updateModel.tileResourceUpdateFinish": "外部资源更新已完成",
    "gui.updateModal.resourceUpdateFinishTips": "外部资源更新已完成，应用程序将会在3秒后自动重启。",
    "gui.updateModel.downloadingApplication": "正在下载应用程序",
    "gui.updateModel.tileApplicationDownloadFinish": "应用程序下载完成",
    "gui.updateModal.applicationDownloadeFinishTips": "应用程序下载完成，将在3秒后自动退出并启动安装程序。",
    "gui.uploadProgress.uploading": "上传中",
    "gui.uploadProgress.uploadSuccess": "上传成功",
    "gui.uploadProgress.uploadError": "上传错误",
    "gui.uploadProgress.uploadTimeout": "上传超时",
    "gui.uploadProgress.uploadAborted": "上传被中止",
    "gui.uploadProgress.abort": "中止",
    "gui.uploadProgress.close": "关闭",
    "gui.webglModal.label": "你的浏览器不支持WebGL",
    "gui.webglModal.description": "非常遗憾，你的电脑或浏览器{webGlLink}。Scratch需要该技术才能运行。",
    "gui.webglModal.webgllink": "不支持WebGL",
    "gui.webglModal.back": "返回",
    "gui.webglModal.previewfaq": "访问{previewFaqLink}，了解更多。",
    "gui.webglModal.previewfaqlinktext": "常见问题",
    "gui.costumeLibrary.chooseABackdrop": "选择一个背景",
    "gui.costumeLibrary.chooseACostume": "选择一个造型",
    "gui.costumeTab.addBackdropFromLibrary": "选择一个背景",
    "gui.costumeTab.addCostumeFromLibrary": "选择一个造型",
    "gui.costumeTab.addBlankCostume": "绘制",
    "gui.costumeTab.addSurpriseCostume": "随机",
    "gui.costumeTab.addFileBackdrop": "上传背景",
    "gui.costumeTab.addFileCostume": "上传造型",
    "gui.deviceLibrary.chooseADevice": "选择一个设备",
    "gui.deviceLibrary.deviceUrl": "输入设备的URL",
    "gui.deviceLibrary.arduinoTag": "Arduino",
    "gui.deviceLibrary.microPythonTag": "MicroPython",
    "gui.deviceLibrary.kitTag": "易联魔方",
    "gui.deviceLibrary.sensorTag": "传感器",
    "gui.extensionLibrary.chooseAnExtension": "选择一个扩展",
    "gui.extensionLibrary.extensionUrl": "键入扩展的URL",
    "gui.library.shieldTag": "扩展板",
    "gui.library.actuatorTag": "执行器",
    "gui.library.sensorTag": "传感器",
    "gui.library.displayTag": "显示器",
    "gui.library.communicationTag": "通信",
    "gui.library.otherTag": "其它",
    "gui.hardwareConsole.noLineTerminators": "没有结束符",
    "gui.hardwareConsole.lineFeed": "换行符",
    "gui.hardwareConsole.carriageReturn": "回车",
    "gui.hardwareConsole.lfAndCr": "回车加换行",
    "gui.monitors.importListColumnPrompt": "使用第几列（1-{numberOfColumns}）？",
    "gui.recordingStep.alertMsg": "无法启动录音",
    "gui.soundLibrary.chooseASound": "选择一个声音",
    "gui.soundTab.fileUploadSound": "上传声音",
    "gui.soundTab.surpriseSound": "随机",
    "gui.soundTab.recordSound": "录制",
    "gui.soundTab.addSoundFromLibrary": "选择一个声音",
    "gui.spriteLibrary.chooseASprite": "选择一个角色",
    "gui.tipsLibrary.tutorials": "选择一个教程",
    "gui.updateModal.updateWarning": "当前未保存的工程将会丢失，继续更新并重启？",
    "gui.uploadProgress.uploadErrorMessage": "上传错误",
    "gui.uploadProgress.uploadTimeoutMessage": "上传超时",
    "gui.alerts.createsuccess": "作品已创建。",
    "gui.alerts.createcopysuccess": "作品已保存为副本。",
    "gui.alerts.createremixsuccess": "改编作品已保存。",
    "gui.alerts.creating": "正在创建...",
    "gui.alerts.creatingCopy": "正在复制作品……",
    "gui.alerts.creatingRemix": "正在改编作品……",
    "gui.alerts.creatingError": "无法创建作品。 请再试一次！",
    "gui.alerts.savingError": "作品未能保存。",
    "gui.alerts.savesuccess": "作品已保存。",
    "gui.alerts.saving": "正在保存作品……",
    "gui.alerts.cloudInfo": "请注意，云变量只支持数字，不能存放字母和符号。{learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "进一步了解。",
    "gui.alerts.importing": "正在导入……",
    "gui.alerts.workspaceIsEmpty": "工作空间是空的",
    "gui.alerts.workspaceIsNotEmpty": "工作区不是空的，请先清理你的工作空间",
    "gui.alerts.uploadError": "上传错误",
    "gui.alerts.uploadSuccess": "上传成功",
    "gui.alerts.selectADeviceFirst": "请先选择一个设备",
    "gui.alerts.connectAPeripheralFirst": "请先连接设备",
    "gui.alerts.codeEditorIsLocked": "代码编辑器处于锁定状态，如果要编辑代码，请先点击解锁按钮",
    "gui.alerts.codeEditorIsUnlocked": "代码编辑器处于解锁状态，如果你想由积木生成代码，请先点击锁定按钮",
    "gui.defaultProject.chirp": "啁啾",
    "gui.defaultProject.variable": "我的变量",
    "gui.howtos.intro-move-sayhello-hat.name": "入门",
    "gui.howtos.intro-move.step_stepMove": "添加「移动」积木",
    "gui.howtos.add-a-move-block.step_stepSay": "添加「说」积木",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "单击绿色小旗开始",
    "gui.howtos.intro-getting-started-ASL.name": "入门 - 美国手语",
    "gui.howtos.animate-a-name.name": "姓名动画",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "选一个字母角色",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "点击时播放声音",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "另选一个字母角色",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "改变颜色",
    "gui.howtos.animate-a-name.step_AnimateSpin": "选一个字母，让它旋转",
    "gui.howtos.animate-a-name.step_AnimateGrow": "另选一个字母，让它变大",
    "gui.howtos.imagine": "Imagine a World",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "Type What You Want to Say",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "Click the Green Flag to Start",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "Choose Any Backdrop",
    "gui.howtos.imagine.step_imagineChooseSprite": "Choose Any Sprite",
    "gui.howtos.imagine.step_imagineFlyAround": "Press the Space Key to Glide",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "Choose Another Sprite",
    "gui.howtos.imagine.step_imagineLeftRight": "Move Left-Right",
    "gui.howtos.imagine.step_imagineUpDown": "Move Up-Down",
    "gui.howtos.imagine.step_imagineChangeCostumes": "Change Costumes",
    "gui.howtos.imagine.step_imagineGlideToPoint": "Glide to a Point",
    "gui.howtos.imagine.step_imagineGrowShrink": "Grow and Shrink",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "Choose Another Backdrop",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "Switch Backdrops",
    "gui.howtos.imagine.step_imagineRecordASound": "Add a Sound",
    "gui.howtos.imagine.step_imagineChooseSound": "Choose Your Sound",
    "gui.howtos.make-music.name": "制作音乐",
    "gui.howtos.Make-Music.step_PickInstrument": "选一个乐器角色",
    "gui.howtos.Make-Music.step_PlaySoundClick": "点击时播放声音",
    "gui.howtos.Make-Music.step_MakeSong": "创作乐曲",
    "gui.howtos.make-music.step_MakeBeat": "选一种鼓，演奏鼓点",
    "gui.howtos.make-music.step_MakeBeatBox": "用麦克风角色演唱节奏口技",
    "gui.howtos.story.name": "创作故事",
    "gui.howtos.story.step_addbg": "添加一个背景",
    "gui.howtos.story.step_addsprite": "添加一个角色",
    "gui.howtos.story.step_saysomething": "让角色说些话",
    "gui.howtos.story.step_addanothersprite": "添加另一个角色",
    "gui.howtos.story.step_flip": "翻转方向",
    "gui.howtos.story.step_conversation": "进行对话",
    "gui.howtos.story.addanotherbg": "添加另一个背景",
    "gui.howtos.story.step_swithbg": "切换背景",
    "gui.howtos.story.step_hidewizard": "隐藏一个角色",
    "gui.howtos.story.step_showwizard": "展示一个角色",
    "gui.howtos.make-a-chase-game.name": "制作追赶游戏",
    "gui.howtos.Chase-Game.step_BG": "添加一个背景",
    "gui.howtos.chase-game.step_AddOcto": "添加一个角色",
    "gui.howtos.make-music.step_LeftRight": "用方向键控制左右移动",
    "gui.howtos.Chase-Game.step_UpDown": "用方向键控制上下移动",
    "gui.howtos.Chase-Game.step_AddStar": "添加另一个角色",
    "gui.howtos.Chase-Game.step_MoveRandom": "随机移动",
    "gui.howtos.Chase-Game.step_WhenTouch": "让章鱼被碰到的时候发出声音",
    "gui.howtos.Chase-Game.step_ScoreVariable": "建立一个得分变量",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "让章鱼被碰到时，增加得分",
    "gui.howtos.animate-char.name": "角色动画",
    "gui.howtos.animate-char.step_addbg": "添加一个背景",
    "gui.howtos.animate-char.step_addsprite": "添加一个角色",
    "gui.howtos.animate-char.step_saysomething": "让角色说些话",
    "gui.howtos.animate-char.step_addsound": "添加声音",
    "gui.howtos.animate-char.step_animatetalking": "交谈动画",
    "gui.howtos.animate-char.step_arrowkeys": "使用方向键移动",
    "gui.howtos.animate-char.step_jump": "跳跃",
    "gui.howtos.animate-char.step_changecolor": "改变颜色",
    "gui.howtos.make-a-game.name": "制作消除游戏",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "挑选一个角色",
    "gui.howtos.make-a-game.step_GamePlaySound": "点击时播放声音",
    "gui.howtos.make-a-game.step_GameAddScore": "建立一个得分变量",
    "gui.howtos.make-a-game.step_GameChangeScore": "被点击时增加分数",
    "gui.howtos.make-a-game.step_Random": "移动到随机位置",
    "gui.howtos.make-music.step_GameChangeColor": "改变颜色",
    "gui.howtos.make-music.step_ResetScore": "把得分清零",
    "gui.howtos.make-it-fly.name": "让角色飞行",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "选一个天空的背景",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "选择一个角色",
    "gui.howtos.fly.step_stepflySaySomething": "让角色说些话",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "用方向键控制移动",
    "gui.howtos.fly.step_stepflyChooseObject": "选择要采集的对象",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "让对象移动",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "点选你的角色",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "添加分数变量",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "保存成绩",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "加入景物",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "让景物移动",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "换成下一个造型",
    "gui.howtos.pong": "乒乓球游戏",
    "gui.howtos.pong.step_pongAddBackdrop": "添加一个背景",
    "gui.howtos.pong.step_pongAddBallSprite": "添加球体角色",
    "gui.howtos.pong.step_pongBounceAround": "让球反弹",
    "gui.howtos.pong.step_pongAddPaddle": "添加滑板",
    "gui.howtos.pong.step_pongMoveThePaddle": "控制滑板移动",
    "gui.howtos.pong.step_pongSelectBallSprite": "点选球体角色",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "添加代码让球体碰到滑板反弹",
    "gui.howtos.pong.step_pongAddAScore": "添加分数变量",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "从菜单中选择「分数」",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "插入「改变分数」积木",
    "gui.howtos.pong.step_pongResetScore": "把得分清零",
    "gui.howtos.pong.step_pongAddLineSprite": "添加线条角色",
    "gui.howtos.pong.step_pongGameOver": "碰到红线游戏结束",
    "gui.howtos.code-cartoon": "Code a Cartoon",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "Say Something When You Click the Green Flag",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "Animate a Character When You Click It",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "Select a Different Character",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "Use a Minus Sign to Get Smaller",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "Make a Character Grow and Shrink",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "Select a Different Character",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "Jump Up and Down",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "Click a Character to Change Scenes",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "Glide Around",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "Change Costumes",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "Choose More Characters to Add to Your Cartoon",
    "gui.howtos.cartoon-network": "冒险游戏动画",
    "gui.howtos.cartoon-network.step_CNcharacter": "选择要显示的角色",
    "gui.howtos.cartoon-network.step_CNsay": "让角色说些话",
    "gui.howtos.cartoon-network.step_CNglide": "滑来滑去",
    "gui.howtos.cartoon-network.step_CNpicksprite": "选择要捕捉的目标",
    "gui.howtos.cartoon-network.step_CNcollect": "收集物品",
    "gui.howtos.cartoon-network.step_CNvariable": "建立分数变量",
    "gui.howtos.cartoon-network.step_CNscore": "保存成绩",
    "gui.howtos.cartoon-network.step_CNbackdrop": "过关：改变背景",
    "gui.howtos.videosens.name": "视频侦测",
    "gui.howtos.videosens.step_addextension": "添加扩展",
    "gui.howtos.videosens.step_pet": "爱抚猫咪",
    "gui.howtos.videosens.step_animate": "动画",
    "gui.howtos.videosens.step_pop": "戳破气球",
    "gui.howtos.say-it-out-loud": "创建会说话的动画",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "添加文字朗读扩展积木",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "让角色说些话",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "设置语音",
    "gui.howtos.say-it-out-loud.step_TXTMove": "四处移动",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "添加一个背景",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "添加另一个角色",
    "gui.howtos.say-it-out-loud.step_TXTSong": "演奏一首歌",
    "gui.howtos.say-it-out-loud.step_TXTColor": "改变颜色",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "原地转动",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "变大变小",
    "gui.howtos.talking": "Talking Tales",
    "gui.howtos.talking.step_talesAddExtension": "Click to Add the Text-to-Speech Blocks",
    "gui.howtos.talking.step_talesChooseSprite": "Choose a Sprite",
    "gui.howtos.talking.step_talesSaySomething": "Make a Character Speak",
    "gui.howtos.talking.step_talesChooseBackdrop": "Choose a Backdrop",
    "gui.howtos.talking.step_talesSwitchBackdrop": "Click a Character to Go to the Next Backdrop",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "Choose Another Sprite",
    "gui.howtos.talking.step_talesMoveAround": "Move Around",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "Choose Another Backdrop",
    "gui.howtos.talking.step_talesAnimateTalking": "Animate Talking",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "Choose Another Backdrop",
    "gui.howtos.talking.step_talesChooseSound": "Choose a Song to Dance To",
    "gui.howtos.talking.step_talesDanceMoves": "Dance Moves",
    "gui.howtos.talking.step_talesAskAnswer": "Get the Ask and Answer Blocks from the Sensing Category",
    "gui.howtos.add-sprite.name": "添加一个角色",
    "gui.howtos.add-sprite.step_addSprite": "添加一个角色",
    "gui.howtos.add-a-backdrop.name": "添加一个背景",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "添加一个背景",
    "gui.howtos.change-size.name": "变大变小",
    "gui.howtos.change-size.step_changeSize": "变大变小",
    "gui.howtos.glide-around.name": "滑来滑去",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "滑来滑去",
    "gui.howtos.change-size.step_glideAroundPoint": "滑动到某处",
    "gui.howtos.record-a-sound.name": "录制声音",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "点击「声音」标签页",
    "gui.howtos.change-size.step_recordASoundClickRecord": "点击「录制」",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "按下录制按钮",
    "gui.howtos.change-size.step_recordASoundChooseSound": "选择已录制的声音",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "播放录制的声音",
    "gui.howtos.spin-video.name": "让字母旋转",
    "gui.howtos.change-size.step_spinTurn": "转动",
    "gui.howtos.change-size.step_spinPointInDirection": "设置方向",
    "gui.howtos.hide-and-show.name": "隐藏和出现",
    "gui.howtos.change-size.step_hideAndShow": "隐藏和出现",
    "gui.howtos.switch-costume.name": "角色动画",
    "gui.howtos.change-size.step_switchCostumes": "角色动画",
    "gui.howtos.move-around-with-arrow-keys.name": "使用方向键",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "左右移动",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "上下移动",
    "gui.howtos.add-effects.name": "添加一些效果",
    "gui.howtos.videosens.step_addEffects": "添加视觉效果",
    "gui.device.esp32.description": "功能强大且带有 Wi-Fi 和 蓝牙的控制板。",
    "gui.device.esp32.connectingMessage": "连接中",
    "gui.device.esp8266NodeMCU.description": "低功耗 Wi-Fi SOC 控制板。",
    "gui.device.esp8266NodeMCU.connectingMessage": "连接中",
    "gui.device.unselectDevice.name": "取消设备选择",
    "gui.device.unselectDevice.description": "取消设备选择，回到纯实时编程模式。",
    "gui.device.arduinoUno.description": "很好的电子编程入门控制板。",
    "gui.device.arduinoUno.connectingMessage": "连接中",
    "gui.device.arduinoNano.description": "Arduino Nano 用于构建项目的经典小控制板。",
    "gui.device.arduinoNano.connectingMessage": "连接中",
    "gui.device.arduinoLeonardo.description": "经典的Arduino板，可以用作鼠标或键盘。",
    "gui.device.arduinoLeonardo.connectingMessage": "连接中",
    "gui.device.arduinoMega2560.description": "拥有54个数字引脚，16个模拟输入，和4个串口的8位控制板。",
    "gui.device.arduinoMega2560.connectingMessage": "连接中",
    "gui.device.microbit.description": "可以学习电子知识的口袋计算机。",
    "gui.device.microbit.connectingMessage": "连接中",
    "gui.device.microbitV2.description": "升级的处理器，板载扬声器和麦克风，触摸感应徽标。",
    "gui.device.microbitV2.connectingMessage": "连接中",
    "gui.device.makeymakey.description": "把任何东西变成按键。",
    "gui.device.makeyMakey.connectingMessage": "连接中",
    "gui.device.k210MaixDock.description": "基于K210 RISC-V芯片的控制板，只有基本功能，引出了所有IO管脚。",
    "gui.device.k210MaixDock.connectingMessage": "连接中",
    "gui.device.k210Maixduino.description": "内置ESP32的K210 RISC-V控制板。",
    "gui.device.k210Maixduino.connectingMessage": "连接中",
    "gui.device.raspberryPiPicoIconURL.description": "功能强大且灵活的控制板。",
    "gui.device.raspberryPiPicoIconURL.connectingMessage": "连接中",
    "gui.extension.music.name": "音乐",
    "gui.extension.music.description": "演奏乐器，敲锣打鼓。",
    "gui.extension.pen.name": "画笔",
    "gui.extension.pen.description": "绘制角色。",
    "gui.extension.videosensing.name": "视频侦测",
    "gui.extension.videosensing.description": "使用摄像头侦测运动。",
    "gui.extension.text2speech.name": "文字朗读",
    "gui.extension.text2speech.description": "让你的作品开口说话",
    "gui.extension.translate.name": "翻译",
    "gui.extension.translate.description": "把文字翻译成多种语言。",
    "gui.extension.makeymakey.name": "Makey Makey",
    "gui.extension.makeymakey.description": "把任何东西变成按键",
    "gui.libraryTags.all": "所有",
    "gui.libraryTags.animals": "动物",
    "gui.libraryTags.dance": "舞蹈",
    "gui.libraryTags.effects": "效果",
    "gui.libraryTags.fantasy": "奇幻",
    "gui.libraryTags.fashion": "时尚",
    "gui.libraryTags.food": "食物",
    "gui.libraryTags.indoors": "室内",
    "gui.libraryTags.loops": "可循环",
    "gui.libraryTags.music": "音乐",
    "gui.libraryTags.notes": "音符",
    "gui.libraryTags.outdoors": "户外",
    "gui.libraryTags.patterns": "图案",
    "gui.libraryTags.people": "人物",
    "gui.libraryTags.percussion": "打击乐器",
    "gui.libraryTags.space": "太空",
    "gui.libraryTags.sports": "运动",
    "gui.libraryTags.underwater": "水下",
    "gui.libraryTags.voice": "人声",
    "gui.libraryTags.wacky": "古怪",
    "gui.libraryTags.animation": "动画",
    "gui.libraryTags.art": "艺术",
    "gui.libraryTags.games": "游戏",
    "gui.libraryTags.stories": "故事",
    "gui.libraryTags.letters": "字母",
    "gui.opcodeLabels.direction": "方向",
    "gui.opcodeLabels.xposition": "x 坐标",
    "gui.opcodeLabels.yposition": "y 坐标",
    "gui.opcodeLabels.size": "大小",
    "gui.opcodeLabels.costumename": "造型名称",
    "gui.opcodeLabels.costumenumber": "造型编号",
    "gui.opcodeLabels.backdropname": "背景名称",
    "gui.opcodeLabels.backdropnumber": "背景编号",
    "gui.opcodeLabels.volume": "音量",
    "gui.opcodeLabels.tempo": "演奏速度",
    "gui.opcodeLabels.answer": "回答",
    "gui.opcodeLabels.loudness": "响度",
    "gui.opcodeLabels.username": "用户名",
    "gui.opcodeLabels.year": "年",
    "gui.opcodeLabels.month": "月",
    "gui.opcodeLabels.date": "日",
    "gui.opcodeLabels.dayofweek": "星期",
    "gui.opcodeLabels.hour": "时",
    "gui.opcodeLabels.minute": "分",
    "gui.opcodeLabels.second": "秒",
    "gui.opcodeLabels.timer": "计时器",
    "gui.projectLoader.loadError": "加载作品文件失败。",
    "gui.sharedMessages.backdrop": "背景{index}",
    "gui.sharedMessages.costume": "造型{index}",
    "gui.sharedMessages.sprite": "角色{index}",
    "gui.sharedMessages.pop": "啵",
    "gui.sharedMessages.replaceProjectWarning": "是否丢弃当前作品中尚未保存的内容？",
    "gui.sharedMessages.clearCacheWarning": "确保你想要清除缓存并重启？",
    "gui.sharedMessages.loadFromComputerTitle": "从电脑中上传",
    "gui.gui.defaultProjectTitle": "Scratch作品",
    "gui.desktopMenuBar.about": "关于",
    "gui.desktopMenuBar.license": "许可证",
    "gui.menuBar.privacyPolicy": "隐私政策",
    "gui.menuBar.dataSettings": "数据设置",
    "gui.hardware.resources": "资源",
    "gui.hardware.SoC": "主控",
    "gui.hardware.software": "软件",
    "gui.hardware.sensor": "魔方",
    "arduinoEsp32.InterrupModeMenu.changeEdge": "电平改变",
    "arduinoEsp32.InterrupModeMenu.fallingEdge": "下降沿",
    "arduinoEsp32.InterrupModeMenu.high": "高电平",
    "arduinoEsp32.InterrupModeMenu.low": "低电平",
    "arduinoEsp32.InterrupModeMenu.risingEdge": "上升沿",
    "arduinoEsp32.category.data": "数据",
    "arduinoEsp32.category.pins": "引脚",
    "arduinoEsp32.category.serial": "串口",
    "arduinoEsp32.data.dataConstrain": "约束 [DATA] 介于 ([ARG0], [ARG1])",
    "arduinoEsp32.data.dataConvert": "转换 [DATA] 为 [TYPE]",
    "arduinoEsp32.data.dataConvertASCIICharacter": "转换 [DATA] 为 ASCII 字符",
    "arduinoEsp32.data.dataConvertASCIINumber": "转换 [DATA] 为 ASCII 编码",
    "arduinoEsp32.data.dataMap": "映射 [DATA] 从 ([ARG0], [ARG1]) 到 ([ARG2], [ARG3])",
    "arduinoEsp32.dataTypeMenu.decimal": "小数",
    "arduinoEsp32.dataTypeMenu.integer": "整数",
    "arduinoEsp32.dataTypeMenu.string": "字符串",
    "arduinoEsp32.eolMenu.noWarp": "不换行",
    "arduinoEsp32.eolMenu.warp": "换行",
    "arduinoEsp32.levelMenu.high": "高",
    "arduinoEsp32.levelMenu.low": "低",
    "arduinoEsp32.modeMenu.input": "输入",
    "arduinoEsp32.modeMenu.inputPulldown": "输入下拉",
    "arduinoEsp32.modeMenu.inputPullup": "输入上拉",
    "arduinoEsp32.modeMenu.output": "输出",
    "arduinoEsp32.pins.esp32AttachInterrupt": "设置中断引脚 [PIN] 模式 [MODE] 执行",
    "arduinoEsp32.pins.esp32DetachInterrupt": "取消中断引脚 [PIN]",
    "arduinoEsp32.pins.esp32ReadTouchPin": "读取触摸引脚 [PIN]",
    "arduinoEsp32.pins.esp32SetDACOutput": "设置 dac 引脚 [PIN] 输出 [OUT]",
    "arduinoEsp32.pins.esp32SetPwmOutput": "设置 pwm 引脚 [PIN] 使用通道 [CH] 输出 [OUT]",
    "arduinoEsp32.pins.readAnalogPin": "读取模拟引脚 [PIN]",
    "arduinoEsp32.pins.readDigitalPin": "读取数字引脚 [PIN]",
    "arduinoEsp32.pins.setDigitalOutput": "设置引脚 [PIN] 输出 [LEVEL]",
    "arduinoEsp32.pins.setPinMode": "设置引脚 [PIN] 模式 [MODE]",
    "arduinoEsp32.pins.setServoOutput": "设置舵机引脚 [PIN] 使用通道 [CH] 输出 [OUT]",
    "arduinoEsp32.serial.multiSerialAvailable": "串口 [NO] 可读取字节数",
    "arduinoEsp32.serial.multiSerialBegin": "串口 [NO] 启动波特率  [VALUE]",
    "arduinoEsp32.serial.multiSerialPrint": "串口 [NO] 打印 [VALUE] [EOL]",
    "arduinoEsp32.serial.multiSerialReadAByte": "串口 [NO] 读取1个字节",
    "arduinoEsp8266.InterrupModeMenu.changeEdge": "电平改变",
    "arduinoEsp8266.InterrupModeMenu.fallingEdge": "下降沿",
    "arduinoEsp8266.InterrupModeMenu.risingEdge": "上升沿",
    "arduinoEsp8266.category.data": "数据",
    "arduinoEsp8266.category.pins": "引脚",
    "arduinoEsp8266.category.serial": "串口",
    "arduinoEsp8266.data.dataConstrain": "约束 [DATA] 介于 ([ARG0], [ARG1])",
    "arduinoEsp8266.data.dataConvert": "转换 [DATA] 为 [TYPE]",
    "arduinoEsp8266.data.dataConvertASCIICharacter": "转换 [DATA] 为 ASCII 字符",
    "arduinoEsp8266.data.dataConvertASCIINumber": "转换 [DATA] 为 ASCII 编码",
    "arduinoEsp8266.data.dataMap": "映射 [DATA] 从 ([ARG0], [ARG1]) 到 ([ARG2], [ARG3])",
    "arduinoEsp8266.dataTypeMenu.decimal": "小数",
    "arduinoEsp8266.dataTypeMenu.integer": "整数",
    "arduinoEsp8266.dataTypeMenu.string": "字符串",
    "arduinoEsp8266.eolMenu.noWarp": "不换行",
    "arduinoEsp8266.eolMenu.warp": "换行",
    "arduinoEsp8266.levelMenu.high": "高",
    "arduinoEsp8266.levelMenu.low": "低",
    "arduinoEsp8266.modeMenu.input": "输入",
    "arduinoEsp8266.modeMenu.inputPullup": "输入上拉",
    "arduinoEsp8266.modeMenu.output": "输出",
    "arduinoEsp8266.pins.detachInterrupt": "取消中断引脚 [PIN]",
    "arduinoEsp8266.pins.esp8266AttachInterrupt": "设置中断引脚 [PIN] 模式 [MODE] 执行",
    "arduinoEsp8266.pins.readAnalogPin": "读取模拟引脚 [PIN]",
    "arduinoEsp8266.pins.readDigitalPin": "读取数字引脚 [PIN]",
    "arduinoEsp8266.pins.setDigitalOutput": "设置引脚 [PIN] 输出 [LEVEL]",
    "arduinoEsp8266.pins.setPinMode": "设置引脚 [PIN] 模式 [MODE]",
    "arduinoEsp8266.pins.setPwmOutput": "设置 pwm 引脚 [PIN] 输出 [OUT]",
    "arduinoEsp8266.pins.setServoOutput": "设置舵机引脚 [PIN] 输出 [OUT]",
    "arduinoEsp8266.serial.serialAvailable": "串口可读取字节数",
    "arduinoEsp8266.serial.serialBegin": "串口启动波特率  [VALUE]",
    "arduinoEsp8266.serial.serialPrint": "串口打印 [VALUE] [EOL]",
    "arduinoEsp8266.serial.serialReadAByte": "串口读取1个字节",
    "arduinoK210.InterrupModeMenu.changeEdge": "电平改变",
    "arduinoK210.InterrupModeMenu.fallingEdge": "下降沿",
    "arduinoK210.InterrupModeMenu.high": "高电平",
    "arduinoK210.InterrupModeMenu.low": "低电平",
    "arduinoK210.InterrupModeMenu.risingEdge": "上升沿",
    "arduinoK210.category.data": "数据",
    "arduinoK210.category.pins": "引脚",
    "arduinoK210.category.serial": "串口",
    "arduinoK210.data.dataConstrain": "约束 [DATA] 介于 ([ARG0], [ARG1])",
    "arduinoK210.data.dataConvert": "转换 [DATA] 为 [TYPE]",
    "arduinoK210.data.dataConvertASCIICharacter": "转换 [DATA] 为 ASCII 字符",
    "arduinoK210.data.dataConvertASCIINumber": "转换 [DATA] 为 ASCII 编码",
    "arduinoK210.data.dataMap": "映射 [DATA] 从 ([ARG0], [ARG1]) 到 ([ARG2], [ARG3])",
    "arduinoK210.dataTypeMenu.decimal": "小数",
    "arduinoK210.dataTypeMenu.integer": "整数",
    "arduinoK210.dataTypeMenu.string": "字符串",
    "arduinoK210.eolMenu.noWarp": "不换行",
    "arduinoK210.eolMenu.warp": "换行",
    "arduinoK210.levelMenu.high": "高",
    "arduinoK210.levelMenu.low": "低",
    "arduinoK210.modeMenu.input": "输入",
    "arduinoK210.modeMenu.inputPulldown": "输入下拉",
    "arduinoK210.modeMenu.inputPullup": "输入上拉",
    "arduinoK210.modeMenu.output": "输出",
    "arduinoK210.pins.attachInterrupt": "设置中断引脚 [PIN] 模式 [MODE] 执行",
    "arduinoK210.pins.detachInterrupt": "取消中断引脚 [PIN]",
    "arduinoK210.pins.readDigitalPin": "读取数字引脚 [PIN]",
    "arduinoK210.pins.setDigitalOutput": "设置引脚 [PIN] 输出 [LEVEL]",
    "arduinoK210.pins.setPinMode": "设置引脚 [PIN] 模式 [MODE]",
    "arduinoK210.pins.setPwmOutput": "设置 pwm 引脚 [PIN] 输出 [OUT]",
    "arduinoK210.pins.setServoOutput": "设置舵机引脚 [PIN] 输出 [OUT]",
    "arduinoK210.serial.multiSerialAvailable": "串口 [NO] 可读取字节数",
    "arduinoK210.serial.multiSerialBegin": "串口 [NO] 启动波特率 [BAUD] 引脚 RX [RX_PIN] TX [TX_PIN]",
    "arduinoK210.serial.multiSerialPrint": "串口 [NO] 打印 [VALUE] [EOL]",
    "arduinoK210.serial.multiSerialReadAByte": "串口 [NO] 读取1个字节",
    "arduinoLeonardo.InterrupModeMenu.changeEdge": "电平改变",
    "arduinoLeonardo.InterrupModeMenu.fallingEdge": "下降沿",
    "arduinoLeonardo.InterrupModeMenu.low": "低",
    "arduinoLeonardo.InterrupModeMenu.risingEdge": "上升沿",
    "arduinoLeonardo.category.data": "数据",
    "arduinoLeonardo.category.pins": "引脚",
    "arduinoLeonardo.category.serial": "串口",
    "arduinoLeonardo.data.dataConstrain": "约束[DATA] 介于 ([ARG0], [ARG1])",
    "arduinoLeonardo.data.dataConvert": "转换 [DATA] 为 [TYPE]",
    "arduinoLeonardo.data.dataConvertASCIICharacter": "转换 [DATA] 为 ASCII 字符",
    "arduinoLeonardo.data.dataConvertASCIINumber": "转换 [DATA] 为 ASCII 编码",
    "arduinoLeonardo.data.dataMap": "映射 [DATA] 从 ([ARG0], [ARG1]) 到 ([ARG2], [ARG3])",
    "arduinoLeonardo.dataTypeMenu.decimal": "小数",
    "arduinoLeonardo.dataTypeMenu.integer": "整数",
    "arduinoLeonardo.dataTypeMenu.string": "字符串",
    "arduinoLeonardo.eolMenu.noWarp": "不换行",
    "arduinoLeonardo.eolMenu.warp": "换行",
    "arduinoLeonardo.levelMenu.high": "高",
    "arduinoLeonardo.levelMenu.low": "低",
    "arduinoLeonardo.modeMenu.input": "输入",
    "arduinoLeonardo.modeMenu.inputPullup": "输入上拉",
    "arduinoLeonardo.modeMenu.output": "输出",
    "arduinoLeonardo.pins.attachInterrupt": "设置中断引脚 [PIN] 模式 [MODE] 执行",
    "arduinoLeonardo.pins.detachInterrupt": "取消中断引脚 [PIN]",
    "arduinoLeonardo.pins.readAnalogPin": "读取模拟引脚 [PIN]",
    "arduinoLeonardo.pins.readDigitalPin": "读取数字引脚 [PIN]",
    "arduinoLeonardo.pins.setDigitalOutput": "设置引脚 [PIN] 输出为 [LEVEL]",
    "arduinoLeonardo.pins.setPinMode": "设置引脚 [PIN] 模式 [MODE]",
    "arduinoLeonardo.pins.setPwmOutput": "设置 pwm 引脚 [PIN] 输出 [OUT]",
    "arduinoLeonardo.pins.setServoOutput": "设置舵机引脚 [PIN] 输出 [OUT]",
    "arduinoLeonardo.serial.serialAvailable": "串口可读取字节数",
    "arduinoLeonardo.serial.serialBegin": "串口启动波特率  [VALUE]",
    "arduinoLeonardo.serial.serialPrint": "串口打印 [VALUE] [EOL]",
    "arduinoLeonardo.serial.serialReadAByte": "串口读取1个字节",
    "arduinoMega2560.InterrupModeMenu.changeEdge": "电平改变",
    "arduinoMega2560.InterrupModeMenu.fallingEdge": "下降沿",
    "arduinoMega2560.InterrupModeMenu.low": "低",
    "arduinoMega2560.InterrupModeMenu.risingEdge": "上升沿",
    "arduinoMega2560.category.data": "数据",
    "arduinoMega2560.category.pins": "引脚",
    "arduinoMega2560.category.serial": "串口",
    "arduinoMega2560.data.dataConstrain": "约束[DATA] 介于 ([ARG0], [ARG1])",
    "arduinoMega2560.data.dataConvert": "转换 [DATA] 为 [TYPE]",
    "arduinoMega2560.data.dataConvertASCIICharacter": "转换 [DATA] 为 ASCII 字符",
    "arduinoMega2560.data.dataConvertASCIINumber": "转换 [DATA] 为 ASCII 编码",
    "arduinoMega2560.data.dataMap": "映射 [DATA] 从 ([ARG0], [ARG1]) 到 ([ARG2], [ARG3])",
    "arduinoMega2560.dataTypeMenu.decimal": "小数",
    "arduinoMega2560.dataTypeMenu.integer": "整数",
    "arduinoMega2560.dataTypeMenu.string": "字符串",
    "arduinoMega2560.eolMenu.noWarp": "不换行",
    "arduinoMega2560.eolMenu.warp": "换行",
    "arduinoMega2560.levelMenu.high": "高",
    "arduinoMega2560.levelMenu.low": "低",
    "arduinoMega2560.modeMenu.input": "输入",
    "arduinoMega2560.modeMenu.inputPullup": "输入上拉",
    "arduinoMega2560.modeMenu.output": "输出",
    "arduinoMega2560.pins.attachInterrupt": "设置中断引脚 [PIN] 模式 [MODE] 执行",
    "arduinoMega2560.pins.detachInterrupt": "取消中断引脚 [PIN]",
    "arduinoMega2560.pins.readAnalogPin": "读取模拟引脚 [PIN]",
    "arduinoMega2560.pins.readDigitalPin": "读取数字引脚 [PIN]",
    "arduinoMega2560.pins.setDigitalOutput": "设置引脚 [PIN] 输出为 [LEVEL]",
    "arduinoMega2560.pins.setPinMode": "设置引脚 [PIN] 模式 [MODE]",
    "arduinoMega2560.pins.setPwmOutput": "设置 pwm 引脚 [PIN] 输出 [OUT]",
    "arduinoMega2560.pins.setServoOutput": "设置舵机引脚 [PIN] 输出 [OUT]",
    "arduinoMega2560.serial.multiSerialAvailable": "串口 [NO] 可读取字节数",
    "arduinoMega2560.serial.multiSerialBegin": "串口 [NO] 启动波特率  [VALUE]",
    "arduinoMega2560.serial.multiSerialPrint": "串口 [NO] 打印 [VALUE] [EOL]",
    "arduinoMega2560.serial.multiSerialReadAByte": "串口 [NO] 读取1个字节",
    "arduinoPeripheral.connection.connectFirmataTimeout": "尝试连接 firmata 超时, 请先下载固件",
    "arduinoRaspberryPiPico.InterrupModeMenu.changeEdge": "电平改变",
    "arduinoRaspberryPiPico.InterrupModeMenu.fallingEdge": "下降沿",
    "arduinoRaspberryPiPico.InterrupModeMenu.high": "高电平",
    "arduinoRaspberryPiPico.InterrupModeMenu.low": "低电平",
    "arduinoRaspberryPiPico.InterrupModeMenu.risingEdge": "上升沿",
    "arduinoRaspberryPiPico.category.data": "数据",
    "arduinoRaspberryPiPico.category.pins": "引脚",
    "arduinoRaspberryPiPico.category.serial": "串口",
    "arduinoRaspberryPiPico.data.dataConstrain": "约束 [DATA] 介于 ([ARG0], [ARG1])",
    "arduinoRaspberryPiPico.data.dataConvert": "转换 [DATA] 为 [TYPE]",
    "arduinoRaspberryPiPico.data.dataConvertASCIICharacter": "转换 [DATA] 为 ASCII 字符",
    "arduinoRaspberryPiPico.data.dataConvertASCIINumber": "转换 [DATA] 为 ASCII 编码",
    "arduinoRaspberryPiPico.data.dataMap": "映射 [DATA] 从 ([ARG0], [ARG1]) 到 ([ARG2], [ARG3])",
    "arduinoRaspberryPiPico.dataTypeMenu.decimal": "小数",
    "arduinoRaspberryPiPico.dataTypeMenu.integer": "整数",
    "arduinoRaspberryPiPico.dataTypeMenu.string": "字符串",
    "arduinoRaspberryPiPico.eolMenu.noWarp": "不换行",
    "arduinoRaspberryPiPico.eolMenu.warp": "换行",
    "arduinoRaspberryPiPico.levelMenu.high": "高",
    "arduinoRaspberryPiPico.levelMenu.low": "低电平",
    "arduinoRaspberryPiPico.modeMenu.input": "输入",
    "arduinoRaspberryPiPico.modeMenu.inputPulldown": "输入下拉",
    "arduinoRaspberryPiPico.modeMenu.inputPullup": "输入上拉",
    "arduinoRaspberryPiPico.modeMenu.output": "输出",
    "arduinoRaspberryPiPico.pins.attachInterrupt": "设置中断引脚 [PIN] 模式 [MODE] 执行",
    "arduinoRaspberryPiPico.pins.detachInterrupt": "取消中断引脚 [PIN]",
    "arduinoRaspberryPiPico.pins.readAnalogPin": "读取模拟引脚 [PIN]",
    "arduinoRaspberryPiPico.pins.readDigitalPin": "读取数字引脚 [PIN]",
    "arduinoRaspberryPiPico.pins.setDigitalOutput": "设置引脚 [PIN] 输出 [LEVEL]",
    "arduinoRaspberryPiPico.pins.setPinMode": "设置引脚 [PIN] 模式 [MODE]",
    "arduinoRaspberryPiPico.pins.setPwmOutput": "设置 pwm 引脚 [PIN] 输出 [OUT]",
    "arduinoRaspberryPiPico.pins.setServoOutput": "设置舵机引脚 [PIN] 输出 [OUT]",
    "arduinoRaspberryPiPico.serial.multiSerialAvailable": "串口 [NO] 可读取字节数",
    "arduinoRaspberryPiPico.serial.multiSerialPrint": "串口 [NO] 打印 [VALUE] [EOL]",
    "arduinoRaspberryPiPico.serial.multiSerialReadAByte": "串口 [NO] 读取1个字节",
    "arduinoRaspberryPiPico.serial.raspberryPiPicoMultiSerialBegin": "串口 [NO] 启动波特率  [VALUE]",
    "arduinoUno.InterrupModeMenu.changeEdge": "电平改变",
    "arduinoUno.InterrupModeMenu.fallingEdge": "下降沿",
    "arduinoUno.InterrupModeMenu.low": "低电平",
    "arduinoUno.InterrupModeMenu.risingEdge": "上升沿",
    "arduinoUno.category.data": "数据",
    "arduinoUno.category.pins": "引脚",
    "arduinoUno.category.serial": "串口",
    "arduinoUno.data.dataConstrain": "约束[DATA] 介于 ([ARG0], [ARG1])",
    "arduinoUno.data.dataConvert": "转换 [DATA] 为 [TYPE]",
    "arduinoUno.data.dataConvertASCIICharacter": "转换 [DATA] 为 ASCII 字符",
    "arduinoUno.data.dataConvertASCIINumber": "转换 [DATA] 为 ASCII 编码",
    "arduinoUno.data.dataMap": "映射 [DATA] 从 ([ARG0], [ARG1]) 到 ([ARG2], [ARG3])",
    "arduinoUno.dataTypeMenu.decimal": "小数",
    "arduinoUno.dataTypeMenu.integer": "整数",
    "arduinoUno.dataTypeMenu.string": "字符串",
    "arduinoUno.eolMenu.noWarp": "不换行",
    "arduinoUno.eolMenu.warp": "换行",
    "arduinoUno.levelMenu.high": "高",
    "arduinoUno.levelMenu.low": "低",
    "arduinoUno.modeMenu.input": "输入",
    "arduinoUno.modeMenu.inputPullup": "输入上拉",
    "arduinoUno.modeMenu.output": "输出",
    "arduinoUno.pins.attachInterrupt": "设置中断引脚 [PIN] 模式 [MODE] 执行",
    "arduinoUno.pins.detachInterrupt": "取消中断引脚 [PIN]",
    "arduinoUno.pins.readAnalogPin": "读取模拟引脚 [PIN]",
    "arduinoUno.pins.readDigitalPin": "读取数字引脚 [PIN]",
    "arduinoUno.pins.setDigitalOutput": "设置引脚 [PIN] 输出为 [LEVEL]",
    "arduinoUno.pins.setPinMode": "设置引脚 [PIN] 模式 [MODE]",
    "arduinoUno.pins.setPwmOutput": "设置引脚 [PIN] pwm为 [OUT]",
    "arduinoUno.pins.setServoOutput": "设置舵机引脚 [PIN] 输出 [OUT]",
    "arduinoUno.serial.serialAvailable": "串口可读取字节数",
    "arduinoUno.serial.serialBegin": "串口启动波特率  [VALUE]",
    "arduinoUno.serial.serialPrint": "串口打印 [VALUE] [EOL]",
    "arduinoUno.serial.serialReadAByte": "串口读取1个字节",
    "boost.color.any": "任何颜色",
    "boost.color.black": "黑色",
    "boost.color.blue": "蓝色",
    "boost.color.green": "绿色",
    "boost.color.red": "黄色",
    "boost.color.white": "白色",
    "boost.color.yellow": "黄色",
    "boost.getMotorPosition": "马达 [MOTOR_REPORTER_ID] 位置",
    "boost.getTiltAngle": "向[TILT_DIRECTION]倾角",
    "boost.motorDirection.backward": "逆时针",
    "boost.motorDirection.forward": "顺时针",
    "boost.motorDirection.reverse": "反转",
    "boost.motorOff": "关闭马达 [MOTOR_ID]",
    "boost.motorOn": "开启马达 [MOTOR_ID]",
    "boost.motorOnFor": "使马达 [MOTOR_ID]转动 [DURATION] 秒",
    "boost.motorOnForRotation": "使马达 [MOTOR_ID]转动 [ROTATION] 圈",
    "boost.seeingColor": "看到 [COLOR]积木 ?",
    "boost.setLightHue": "将灯光颜色设为[HUE]",
    "boost.setMotorDirection": "将马达[MOTOR_ID] 方向设为 [MOTOR_DIRECTION]",
    "boost.setMotorPower": "将马达 [MOTOR_ID] 速度设为 [POWER]%",
    "boost.tiltDirection.any": "任意方向",
    "boost.tiltDirection.down": "下",
    "boost.tiltDirection.left": "左",
    "boost.tiltDirection.right": "右",
    "boost.tiltDirection.up": "上",
    "boost.whenColor": "当看到[COLOR]积木",
    "boost.whenTilted": "当向[TILT_DIRECTION_ANY]倾斜",
    "ev3.beepNote": "鸣笛[NOTE][TIME]秒",
    "ev3.buttonPressed": "按下按钮[PORT]？",
    "ev3.getBrightness": "亮度",
    "ev3.getDistance": "距离",
    "ev3.getMotorPosition": "马达[PORT]的位置",
    "ev3.motorSetPower": "马达[PORT]功率设为[POWER]%",
    "ev3.motorTurnClockwise": "马达[PORT]正转[TIME]秒",
    "ev3.motorTurnCounterClockwise": "马达[PORT]反转[TIME]秒",
    "ev3.whenBrightnessLessThan": "当亮度 < [DISTANCE]",
    "ev3.whenButtonPressed": "当按下按钮[PORT]",
    "ev3.whenDistanceLessThan": "当距离 < [DISTANCE]",
    "gdxfor.getAcceleration": "向[DIRECTION]的加速度",
    "gdxfor.getForce": "受力",
    "gdxfor.getSpin": "向[DIRECTION]的旋转速度",
    "gdxfor.getTilt": "向[TILT]倾角",
    "gdxfor.isFreeFalling": "自由落体？",
    "gdxfor.isTilted": "向[TILT]倾斜？",
    "gdxfor.pulled": "拉扯",
    "gdxfor.pushed": "挤压",
    "gdxfor.shaken": "被晃动",
    "gdxfor.startedFalling": "开始自由落体",
    "gdxfor.tiltDirectionMenu.any": "任意方向",
    "gdxfor.tiltDirectionMenu.back": "后",
    "gdxfor.tiltDirectionMenu.front": "前",
    "gdxfor.tiltDirectionMenu.left": "左",
    "gdxfor.tiltDirectionMenu.right": "右",
    "gdxfor.turnedFaceDown": "正面向下",
    "gdxfor.turnedFaceUp": "正面向上",
    "gdxfor.whenForcePushedOrPulled": "当力传感器被[PUSH_PULL]",
    "gdxfor.whenGesture": "当传感器[GESTURE]",
    "gdxfor.whenTilted": "当向[TILT]倾斜",
    "makeymakey.downArrow": "↓",
    "makeymakey.downArrowShort": "下",
    "makeymakey.leftArrow": "←",
    "makeymakey.leftArrowShort": "左",
    "makeymakey.rightArrow": "→",
    "makeymakey.rightArrowShort": "右",
    "makeymakey.spaceKey": "空格",
    "makeymakey.upArrow": "↑",
    "makeymakey.upArrowShort": "上",
    "makeymakey.whenKeyPressed": "当按下 [KEY] 键",
    "makeymakey.whenKeysPressedInOrder": "当依次按下[SEQUENCE]键时",
    "microPythonEsp32.InterrupModeMenu.changeEdge": "电平改变",
    "microPythonEsp32.InterrupModeMenu.fallingEdge": "下降沿",
    "microPythonEsp32.InterrupModeMenu.high": "高电平",
    "microPythonEsp32.InterrupModeMenu.low": "低电平",
    "microPythonEsp32.InterrupModeMenu.risingEdge": "上升沿",
    "microPythonEsp32.category.console": "控制台",
    "microPythonEsp32.category.pins": "引脚",
    "microPythonEsp32.console.consoleInput": "提示 [TEXT] 并读取输入",
    "microPythonEsp32.console.consolePrint": "打印 [TEXT] [EOL]",
    "microPythonEsp32.eolMenu.noWarp": "不换行",
    "microPythonEsp32.eolMenu.warp": "换行",
    "microPythonEsp32.levelMenu.high": "高",
    "microPythonEsp32.levelMenu.low": "低",
    "microPythonEsp32.modeMenu.input": "输入",
    "microPythonEsp32.modeMenu.inputPulldown": "输入下拉",
    "microPythonEsp32.modeMenu.inputPullup": "输入上拉",
    "microPythonEsp32.modeMenu.output": "输出",
    "microPythonEsp32.pins.esp32AttachInterrupt": "设置中断引脚 [PIN] 模式 [MODE] 执行",
    "microPythonEsp32.pins.esp32ReadAnalogPin": "读取模拟引脚 [PIN]",
    "microPythonEsp32.pins.esp32ReadDigitalPin": "读取数字引脚 [PIN]",
    "microPythonEsp32.pins.esp32ReadTouchPin": "读取触摸引脚 [PIN]",
    "microPythonEsp32.pins.esp32SetDACOutput": "设置 dac 引脚 [PIN] 输出 [OUT]",
    "microPythonEsp32.pins.esp32SetDigitalOutput": "设置引脚 [PIN] 输出 [LEVEL]",
    "microPythonEsp32.pins.esp32SetPinMode": "设置引脚 [PIN] 模式 [MODE]",
    "microPythonEsp32.pins.esp32SetPwmOutput": "设置 pwm 引脚 [PIN] 输出 [OUT]",
    "microPythonEsp32.pins.setServoOutput": "设置舵机引脚 [PIN] 输出 [OUT]",
    "microPythonEsp8266.category.console": "控制台",
    "microPythonEsp8266.category.pins": "引脚",
    "microPythonEsp8266.console.consoleInput": "提示 [TEXT] 并读取输入",
    "microPythonEsp8266.console.consolePrint": "打印 [TEXT] [EOL]",
    "microPythonEsp8266.eolMenu.noWarp": "不换行",
    "microPythonEsp8266.eolMenu.warp": "换行",
    "microPythonEsp8266.levelMenu.high": "高",
    "microPythonEsp8266.levelMenu.low": "低",
    "microPythonEsp8266.modeMenu.input": "输入",
    "microPythonEsp8266.modeMenu.inputPullup": "输入上拉",
    "microPythonEsp8266.modeMenu.output": "输出",
    "microPythonEsp8266.pins.esp8266AttachInterrupt": "设置中断引脚 [PIN] 模式 [MODE] 执行",
    "microPythonEsp8266.pins.readAnalogPin": "读取模拟引脚 [PIN]",
    "microPythonEsp8266.pins.readDigitalPin": "读取数字引脚 [PIN]",
    "microPythonEsp8266.pins.setDigitalOutput": "设置引脚 [PIN] 输出 [LEVEL]",
    "microPythonEsp8266.pins.setPinMode": "设置引脚 [PIN] 模式 [MODE]",
    "microPythonEsp8266.pins.setPwmOutput": "设置 pwm 引脚 [PIN] 输出 [OUT]",
    "microPythonEsp8266.pins.setServoOutput": "设置舵机引脚 [PIN] 输出 [OUT]",
    "microPythonK210.InterrupModeMenu.changeEdge": "电平改变",
    "microPythonK210.InterrupModeMenu.fallingEdge": "下降沿",
    "microPythonK210.InterrupModeMenu.risingEdge": "上升沿",
    "microPythonK210.category.console": "控制台",
    "microPythonK210.category.pins": "引脚",
    "microPythonK210.category.serial": "串口",
    "microPythonK210.console.consoleInput": "提示 [TEXT] 并读取输入",
    "microPythonK210.console.consolePrint": "打印 [TEXT] [EOL]",
    "microPythonK210.eolMenu.noWarp": "不换行",
    "microPythonK210.eolMenu.warp": "换行",
    "microPythonK210.levelMenu.high": "高",
    "microPythonK210.levelMenu.low": "低",
    "microPythonK210.modeMenu.input": "输入",
    "microPythonK210.modeMenu.inputPulldown": "输入下拉",
    "microPythonK210.modeMenu.inputPullup": "输入上拉",
    "microPythonK210.modeMenu.output": "输出",
    "microPythonK210.pins.k210AttachInterrupt": "设置中断引脚 [PIN] 模式 [MODE] 执行",
    "microPythonK210.pins.k210SetPinMode": "设置引脚 [PIN] 模式 [MODE]",
    "microPythonK210.pins.k210SetPwmOutput": "设置 pwm 引脚 [PIN] 使用通道 [CH] 输出 [OUT]",
    "microPythonK210.pins.k210SetServoOutput": "设置舵机引脚 [PIN] 使用通道 [CH] 输出 [OUT]",
    "microPythonK210.pins.readDigitalPin": "读取数字引脚 [PIN]",
    "microPythonK210.pins.setDigitalOutput": "设置引脚 [PIN] 输出 [LEVEL]",
    "microPythonK210.serial.k210SerialBegin": "串口 [NO] 启动波特率 [BAUD] 引脚 RX [RX_PIN] TX [TX_PIN]",
    "microPythonK210.serial.serialPrint": "串口 [NO] 打印 [VALUE] [EOL]",
    "microPythonK210.serial.serialReadALine": "串口 [NO] 读取1行",
    "microPythonRaspberryPiPico.InterrupModeMenu.changeEdge": "电平改变",
    "microPythonRaspberryPiPico.InterrupModeMenu.fallingEdge": "下降沿",
    "microPythonRaspberryPiPico.InterrupModeMenu.risingEdge": "上升沿",
    "microPythonRaspberryPiPico.category.console": "控制台",
    "microPythonRaspberryPiPico.category.pins": "引脚",
    "microPythonRaspberryPiPico.category.serial": "串口",
    "microPythonRaspberryPiPico.console.consoleInput": "提示 [TEXT] 并读取输入",
    "microPythonRaspberryPiPico.console.consolePrint": "打印 [TEXT] [EOL]",
    "microPythonRaspberryPiPico.eolMenu.noWarp": "不换行",
    "microPythonRaspberryPiPico.eolMenu.warp": "换行",
    "microPythonRaspberryPiPico.levelMenu.high": "高",
    "microPythonRaspberryPiPico.levelMenu.low": "低电平",
    "microPythonRaspberryPiPico.modeMenu.input": "输入",
    "microPythonRaspberryPiPico.modeMenu.inputPulldown": "输入下拉",
    "microPythonRaspberryPiPico.modeMenu.inputPullup": "输入上拉",
    "microPythonRaspberryPiPico.modeMenu.output": "输出",
    "microPythonRaspberryPiPico.pins.attachInterrupt": "设置中断引脚 [PIN] 模式 [MODE] 执行",
    "microPythonRaspberryPiPico.pins.readAnalogPin": "读取模拟引脚 [PIN]",
    "microPythonRaspberryPiPico.pins.readDigitalPin": "读取数字引脚 [PIN]",
    "microPythonRaspberryPiPico.pins.setDigitalOutput": "设置引脚 [PIN] 输出 [LEVEL]",
    "microPythonRaspberryPiPico.pins.setPinMode": "设置引脚 [PIN] 模式 [MODE]",
    "microPythonRaspberryPiPico.pins.setPwmOutputU16": "设置 pwm 引脚 [PIN] 输出 [OUT]",
    "microPythonRaspberryPiPico.pins.setServoOutputU16": "设置舵机引脚 [PIN] 输出 [OUT]",
    "microPythonRaspberryPiPico.serial.multiSerialPrint": "串口 [NO] 打印 [VALUE] [EOL]",
    "microPythonRaspberryPiPico.serial.multiSerialReadALine": "串口 [NO] 读取1行",
    "microPythonRaspberryPiPico.serial.raspberryPiPicoSerialBegin": "串口 [NO] 启动波特率 [BAUD] 引脚 RX [RX_PIN] TX [TX_PIN]",
    "microbit.axisMenu.xAxis": "x轴",
    "microbit.axisMenu.yAxis": "y轴",
    "microbit.axisMenu.zAxis": "z轴",
    "microbit.buttonsMenu.any": "任意",
    "microbit.category.console": "控制台",
    "microbit.category.display": "显示",
    "microbit.category.pins": "引脚",
    "microbit.category.sensor": "传感器",
    "microbit.category.wireless": "无线电",
    "microbit.clearDisplay": "清空屏幕",
    "microbit.console.consolePrint": "打印 [TEXT]",
    "microbit.defaultTextToDisplay": "Hello!",
    "microbit.display.clearDisplay": "清空屏幕",
    "microbit.display.lightPixelAt": "[STATE] 坐标 x: [X] , y: [Y] 灯",
    "microbit.display.show": "显示 [TEXT]",
    "microbit.display.showImage": "显示图案 [VALUE]",
    "microbit.display.showImageUntil": "显示图案 [VALUE] 持续 [TIME] 秒",
    "microbit.display.showOnPiexlbrightness": "设置坐标 x: [X], y: [Y] 的亮度为 [BRT]",
    "microbit.display.showUntilScrollDone": "显示 [TEXT] 直到滚动结束",
    "microbit.displaySymbol": "显示[MATRIX]",
    "microbit.displayText": "显示文本[TEXT]",
    "microbit.gestruesMenu.faceDown": "正面朝下",
    "microbit.gestruesMenu.faceUp": "正面朝上",
    "microbit.gestruesMenu.freefall": "自由下落",
    "microbit.gestruesMenu.shaken": "被摇晃",
    "microbit.gestruesMenu.tiltedDownward": "向下倾斜",
    "microbit.gestruesMenu.tiltedLeftward": "向左倾斜",
    "microbit.gestruesMenu.tiltedRightward": "向右倾斜",
    "microbit.gestruesMenu.tiltedUpward": "向上倾斜",
    "microbit.gesturesMenu.jumped": "抛起",
    "microbit.gesturesMenu.moved": "移动",
    "microbit.gesturesMenu.shaken": "晃动",
    "microbit.isButtonPressed": "按下[BTN]按钮？",
    "microbit.isTilted": "向[DIRECTION]倾斜？",
    "microbit.ledState.off": "熄灭",
    "microbit.ledState.on": "点亮",
    "microbit.levelMenu.high": "高",
    "microbit.levelMenu.low": "低",
    "microbit.pinStateMenu.off": "低电平",
    "microbit.pinStateMenu.on": "高电平",
    "microbit.pins.pinIsTouched": "引脚 [PIN] 被触摸",
    "microbit.pins.readAnalogPin": "读取模拟引脚 [PIN]",
    "microbit.pins.readDigitalPin": "读取数字引脚 [PIN]",
    "microbit.pins.setDigitalOutput": "设置引脚 [PIN] 输出 [LEVEL]",
    "microbit.pins.setPwmOutput": "设置 pwm 引脚 [PIN] 输出 [OUT]",
    "microbit.sensor.axisAcceleration": "[AXIS] 轴加速度",
    "microbit.sensor.buttonIsPressed": "按键 [KEY] 被按下?",
    "microbit.sensor.calibrateCompass": "校准指南针",
    "microbit.sensor.compassAngle": "指南针角度",
    "microbit.sensor.compassMagneticDensity": "指南针磁场强度",
    "microbit.sensor.gestureIsX": "姿态是 [STA]?",
    "microbit.sensor.lightLevel": "亮度",
    "microbit.sensor.runningTime": "运行时间",
    "microbit.sensor.temperature": "温度",
    "microbit.tiltAngle": "向[DIRECTION]倾角",
    "microbit.tiltDirectionMenu.any": "任意",
    "microbit.tiltDirectionMenu.back": "后",
    "microbit.tiltDirectionMenu.front": "前",
    "microbit.tiltDirectionMenu.left": "左",
    "microbit.tiltDirectionMenu.right": "右",
    "microbit.whenButtonPressed": "当按下[BTN]按钮",
    "microbit.whenGesture": "当被[GESTURE]",
    "microbit.whenPinConnected": "当引脚[PIN]接地",
    "microbit.whenTilted": "当向[DIRECTION]倾斜",
    "microbit.wireless.closeWirelessCommunication": "关闭无线通讯",
    "microbit.wireless.openWirelessCommunication": "打开无线通讯",
    "microbit.wireless.receiveWirelessMessage": "收到无线消息",
    "microbit.wireless.resetWirelessCommunication": "复位无线通讯",
    "microbit.wireless.sendWirelessMessage": "发送无线消息 [TEXT]",
    "microbit.wireless.setWirelessCommunicationChannel": "设置无线通讯频道为 [CH]",
    "music.categoryName": "音乐",
    "music.changeTempo": "将演奏速度增加[TEMPO]",
    "music.drumBass": "(2) 低音鼓",
    "music.drumBongo": "(13) 邦戈鼓",
    "music.drumCabasa": "(15) 卡巴萨",
    "music.drumClaves": "(9) 音棒",
    "music.drumClosedHiHat": "(6) 闭击踩镲",
    "music.drumConga": "(14) 康加鼓",
    "music.drumCowbell": "(11) 牛铃",
    "music.drumCrashCymbal": "(4) 碎音钹",
    "music.drumCuica": "(18) 锯加鼓",
    "music.drumGuiro": "(16) 刮瓜",
    "music.drumHandClap": "(8) 手掌",
    "music.drumOpenHiHat": "(5) 开击踩镲",
    "music.drumSideStick": "(3) 敲鼓边",
    "music.drumSnare": "(1) 小军鼓",
    "music.drumTambourine": "(7) 铃鼓",
    "music.drumTriangle": "(12) 三角铁",
    "music.drumVibraslap": "(17) 颤音器",
    "music.drumWoodBlock": "(10) 木鱼",
    "music.getTempo": "演奏速度",
    "music.instrumentBass": "(6) 贝斯",
    "music.instrumentBassoon": "(14) 巴松管",
    "music.instrumentCello": "(8) 大提琴",
    "music.instrumentChoir": "(15) 唱诗班",
    "music.instrumentClarinet": "(10) 单簧管",
    "music.instrumentElectricGuitar": "(5) 电吉他",
    "music.instrumentElectricPiano": "(2) 电钢琴",
    "music.instrumentFlute": "(12) 长笛",
    "music.instrumentGuitar": "(4) 吉他",
    "music.instrumentMarimba": "(19) 马林巴琴",
    "music.instrumentMusicBox": "(17) 八音盒",
    "music.instrumentOrgan": "(3) 风琴",
    "music.instrumentPiano": "(1) 钢琴",
    "music.instrumentPizzicato": "(7) 拨弦",
    "music.instrumentSaxophone": "(11) 萨克斯管",
    "music.instrumentSteelDrum": "(18) 钢鼓",
    "music.instrumentSynthLead": "(20) 合成主音",
    "music.instrumentSynthPad": "(21) 合成柔音",
    "music.instrumentTrombone": "(9) 长号",
    "music.instrumentVibraphone": "(16) 颤音琴",
    "music.instrumentWoodenFlute": "(13) 木长笛",
    "music.midiPlayDrumForBeats": "击打 [DRUM] [BEATS] 拍",
    "music.midiSetInstrument": "将乐器设为 [INSTRUMENT]",
    "music.playDrumForBeats": "击打 [DRUM] [BEATS] 拍",
    "music.playNoteForBeats": "演奏音符[NOTE][BEATS]拍",
    "music.restForBeats": "休止[BEATS]拍",
    "music.setInstrument": "将乐器设为 [INSTRUMENT]",
    "music.setTempo": "将演奏速度设定为[TEMPO]",
    "pen.categoryName": "画笔",
    "pen.changeColorParam": "将笔的 [COLOR_PARAM] 增加[VALUE]",
    "pen.changeHue": "将笔的颜色增加[HUE]",
    "pen.changeShade": "将笔的亮度增加[SHADE]",
    "pen.changeSize": "将笔的粗细增加[SIZE]",
    "pen.clear": "全部擦除",
    "pen.colorMenu.brightness": "亮度",
    "pen.colorMenu.color": "颜色",
    "pen.colorMenu.saturation": "饱和度",
    "pen.colorMenu.transparency": "透明度",
    "pen.penDown": "落笔",
    "pen.penUp": "抬笔",
    "pen.setColor": "将笔的颜色设为[COLOR]",
    "pen.setColorParam": "将笔的 [COLOR_PARAM] 设为[VALUE]",
    "pen.setHue": "将笔的颜色设为[HUE]",
    "pen.setShade": "将笔的亮度设为[SHADE]",
    "pen.setSize": "将笔的粗细设为[SIZE]",
    "pen.stamp": "图章",
    "speech.defaultWhenIHearValue": "开始",
    "speech.extensionName": "语音识别",
    "speech.listenAndWait": "听候语音输入",
    "speech.speechReporter": "语音输入",
    "speech.whenIHear": "当听到[PHRASE]",
    "text2speech.alto": "中音",
    "text2speech.categoryName": "文字朗读",
    "text2speech.defaultTextToSpeak": "你好",
    "text2speech.giant": "巨人",
    "text2speech.kitten": "小猫",
    "text2speech.setLanguageBlock": "将朗读语言设置为[LANGUAGE]",
    "text2speech.setVoiceBlock": "使用 [VOICE] 嗓音",
    "text2speech.speakAndWaitBlock": "朗读 [WORDS]",
    "text2speech.squeak": "尖细",
    "text2speech.tenor": "男高音",
    "translate.categoryName": "翻译",
    "translate.defaultTextToTranslate": "你好",
    "translate.translateBlock": "将 [WORDS] 译为 [LANGUAGE]",
    "translate.viewerLanguage": "访客语言",
    "videoSensing.categoryName": "视频侦测",
    "videoSensing.direction": "方向",
    "videoSensing.motion": "运动",
    "videoSensing.off": "关闭",
    "videoSensing.on": "开启",
    "videoSensing.onFlipped": "镜像开启",
    "videoSensing.setVideoTransparency": "将视频透明度设为[TRANSPARENCY]",
    "videoSensing.sprite": "角色",
    "videoSensing.stage": "舞台",
    "videoSensing.videoOn": "相对于[SUBJECT]的视频[ATTRIBUTE]",
    "videoSensing.videoToggle": "[VIDEO_STATE]摄像头",
    "videoSensing.whenMotionGreaterThan": "当视频运动 > [REFERENCE]",
    "wedo2.getDistance": "距离",
    "wedo2.getTiltAngle": "向[TILT_DIRECTION]倾角",
    "wedo2.isTilted": "向[TILT_DIRECTION_ANY]倾斜？",
    "wedo2.motorDirection.backward": "逆时针",
    "wedo2.motorDirection.forward": "顺时针",
    "wedo2.motorDirection.reverse": "反转",
    "wedo2.motorId.a": "马达A",
    "wedo2.motorId.all": "所有马达",
    "wedo2.motorId.b": "马达B",
    "wedo2.motorId.default": "马达",
    "wedo2.motorOff": "关闭[MOTOR_ID]",
    "wedo2.motorOn": "开启[MOTOR_ID]",
    "wedo2.motorOnFor": "开启[MOTOR_ID][DURATION]秒",
    "wedo2.playNoteFor": "演奏音符[NOTE][DURATION]秒",
    "wedo2.setLightHue": "将灯光颜色设为[HUE]",
    "wedo2.setMotorDirection": "将[MOTOR_ID]转向设为[MOTOR_DIRECTION]",
    "wedo2.startMotorPower": "将[MOTOR_ID]功率设为[POWER]",
    "wedo2.tiltDirection.any": "任意方向",
    "wedo2.tiltDirection.down": "下",
    "wedo2.tiltDirection.left": "左",
    "wedo2.tiltDirection.right": "右",
    "wedo2.tiltDirection.up": "上",
    "wedo2.whenDistance": "当距离[OP][REFERENCE]",
    "wedo2.whenTilted": "当向[TILT_DIRECTION_ANY]倾斜",
    "YMLED.categoryName": "灯光",
    "YMLED.setLightMode": "将灯光模式设为[MODE]",
    "YMLED.setLightMode.1": "常亮",
    "YMLED.setLightMode.2": "闪烁",
    "YMLED.setLightMode.3": "呼吸",
    "YMLED.setLightSwitch": "将灯光开关设为[SWITCH]",
    "YMLED.setLightSwitch.1": "开",
    "YMLED.setLightSwitch.0": "关",
    "YMLED.setBrightness": "将亮度设为[BRIGHTNESS]",
    "YMLED.setFlashFrequency": "将闪烁频率设为[FREQUENCY]",
    "YMLED.setFlashFrequency.0": "慢",
    "YMLED.setFlashFrequency.1": "快",
    "YMLED.setFlashMode": "将闪光灯模式设为[MODE]",
    "YMLED.setFlashMode.0": "关",
    "YMLED.setFlashMode.1": "开",
    "YMLED.ble": "蓝牙",
    "YMLED.ble.connect": "连接 LM-LED-[DEVICE_NAME]",
    "YMLED.ble.disconnect": "断开连接",
    "YMAU.categoryName": "声音",
    "YMAU.ble.connect": "连接 YM-AU-[DEVICE_NAME] ",
    "YMAU.ble.disconnect": "断开连接",
    "YMAU.startRecording": "开始",
    "YMAU.stopRecording": "停止",
    "YMAU.playRecording": "播放",
    "YMAU.setPromptTone": "播放 [PROMPT_TONE]音调",
    "YMAU.setPromptTone.1": "声音1",
    "YMAU.setPromptTone.2": "声音2",
    "YMAU.setPromptTone.3": "声音3",
    "YMAU.setPromptTone.4": "声音4",
    "YMAU.setPromptTone.5": "声音5",
    "YMAU.recordingState.recording": "记录：开",
    "YMAU.recordingState.stopped": "记录：关",
    "YMIMU6.categoryName": "六轴",
    "YMIMU6.ble.connect": "连接 YM-IMU6-[DEVICE_NAME] ",
    "YMIMU6.ble.disconnect": "断开连接",
    "YMIMU6.getAccelerationX": "X轴加速度",
    "YMIMU6.getAccelerationY": "Y轴加速度",
    "YMIMU6.getAccelerationZ": "Z轴加速度",
    "YMIMU6.getGyroscopeX": "X轴角速度",
    "YMIMU6.getGyroscopeY": "Y轴角速度",
    "YMIMU6.getGyroscopeZ": "Z轴角速度",
    "YMIMU9.categoryName": "九轴",
    "YMIMU9.ble.connect": "连接 YM-IMU9-[DEVICE_NAME] ",
    "YMIMU9.ble.disconnect": "断开连接",
    "YMIMU9.getAccelerationX": "X轴加速度",
    "YMIMU9.getAccelerationY": "Y轴加速度",
    "YMIMU9.getAccelerationZ": "Z轴加速度",
    "YMIMU9.getGyroscopeX": "X轴角速度",
    "YMIMU9.getGyroscopeY": "Y轴角速度",
    "YMIMU9.getGyroscopeZ": "Z轴角速度",
    "YMIMU9.getMagnetometerX": "X轴",
    "YMIMU9.getMagnetometerY": "Y轴",
    "YMIMU9.getMagnetometerZ": "Z轴",
    "YMPIR.categoryName": "红外感应",
    "YMPIR.ble.connect": "连接 YM-PIR-[DEVICE_NAME] ",
    "YMPIR.ble.disconnect": "断开连接",
    "YMPIR.getStatus": "状态",
    "YMDLGT.categoryName": "小夜灯",
    "YMDLGT.ble.connect": "连接 YM-DLGT-[DEVICE_NAME] ",
    "YMDLGT.ble.disconnect": "断开连接",
    "YMDLGT.setLightSwitch": "将灯光开关设为[SWITCH]",
    "YMDLGT.setBrightness": "将亮度设为[BRIGHTNESS]",
    "YMDLGT.setFlashMode": "将闪光灯模式设为[MODE]",
    "YMDLGT.getBrightness": "获取光照强度",
    "YMDLGT.setLightSwitch.1": "开",
    "YMDLGT.setLightSwitch.0": "关",
    "YMDLGT.setFlashMode.1": "拍照闪光",
    "YMDLGT.setFlashMode.0": "关",
    "YMNLGT.getStatus": "状态：",
    "yiPlug.categoryName": "智能插座",
    "yiPlug.ble.connect": "连接 yiPlug-[DEVICE_NAME] ",
    "yiPlug.ble.connected": "是否连接",
    "yiPlug.ble.disconnect": "断开连接",
    "yiPlug.setPluginSwitch": "[SWITCH]插座开关",
    "yiPlug.getPluginSwitch": "开关",
    "yiPlug.getElectricity": "电流",
    "yiPlug.getVoltage": "电压",
    "yiPlug.getPower": "电量",
    "yiPlug.getVersion": "版本",
    "yiPlug.setHold": "设置掉电记忆[HOLD_SWITCH]",
    "yiPlug.getHold": "掉电记忆",
    "yiPlug.setPluginSwitch.0": "关",
    "yiPlug.setPluginSwitch.1": "开",
    "yiPlug.setHold.1": "关",
    "yiPlug.setHold.0": "开",
    "YMTH1D.categoryName": "温湿度",
    "YMTH1D.ble.connect": "连接 YM-TH1D-[DEVICE_NAME] ",
    "YMTH1D.ble.disconnect": "断开连接",
    "YMTH1D.getTemperature": "温度",
    "YMTH1D.getHumidity": "湿度",
    "YMTH1P.categoryName": "温度",
    "YMTH1P.ble.connect": "连接 YM-TH1-[DEVICE_NAME] ",
    "YMTH1P.ble.disconnect": "断开连接",
    "YMTH1P.getTemperature": "温度",
    "YMBEEP.categoryName": "蜂鸣器",
    "YMBEEP.ble.connect": "连接 YM-BEEP-[DEVICE_NAME] ",
    "YMBEEP.ble.disconnect": "断开连接",
    "YMLED.beepOn": "设置开关 [SWITCH]",
    "YMBEEP.setBeepFreq": "设置频率 [FREQ] Hz",
    "YMBEEP.beepOn": "将开关设为[SWITCH]",
    "YMBEEP.beepOn.1": "开",
    "YMBEEP.beepOff.0": "关",
    "YMK3.categoryName": "3按键",
    "YMK3.ble.connect": "连接 YM-K3-[DEVICE_NAME] ",
    "YMK3.ble.disconnect": "断开连接",
    "YMK3.whenKey1Pressed": "按键1",
    "YMK3.whenKey2Pressed": "按键2",
    "YMK3.whenKey3Pressed": "按键3",
    "YMRYG.categoryName": "3色LED",
    "YMRYG.ble.connect": "连接 YM-RYG-[DEVICE_NAME] ",
    "YMRYG.ble.disconnect": "断开连接",
    "YMRYG.setLight": "设置模式 [LIGHT]",
    "YMRYG.light.green": "绿灯",
    "YMRYG.light.yellow": "黄灯",
    "YMRYG.light.red": "红灯",
    "YMRYG.setGLightSwitch": "将绿灯开关设为[SWITCH]",
    "YMRYG.setRLightSwitch": "将红灯开关设为[SWITCH]",
    "YMRYG.setYLightSwitch": "将黄灯开关设为[SWITCH]",
    "YMRYG.light.red_green": "红-绿",
    "YMRYG.light.red_yellow": "红-黄",
    "YMRYG.light.yellow_green": "黄-绿",
    "YMRYG.light.all_on": "全开",
    "YMRYG.light.all_off": "全关",
    "YMSWUSB.categoryName": "USB电源",
    "YMSWUSB.ble.connect": "连接 YM-SWUSB-[DEVICE_NAME] ",
    "YMSWUSB.ble.disconnect": "断开连接",
    "YMSWUSB.setSwitch": "设置占空比 [DUTY_CYCLE]%",
    "YMSWUSB.setUsbSwitch": "将USB电源开关设为[SWITCH]",
    "YCAIS.categoryName": "控制器",
    "YCAIS.ble.connect": "连接到 YC-AIS-[DEVICE_NAME]",
    "YCAIS.ble.disconnect": "断开 YC AIS 连接",
    "YCAIS.programme.start": "启动编程模式",
    "YCAIS.programme.sendFileName": "发送文件名 [FILENAME]",
    "YCAIS.programme.sendFileContent": "发送文件内容 [CONTENT]",
    "YCAIS.programme.endFileSend": "结束文件发送",
    "YCAIS.programme.endProgramming": "结束编程模式",
    "YCAIS.programme.abortProgramming": "中止编程模式",
    "YCAIS.ui.createScreen": "创建屏幕",
    "YCAIS.util.delay": "延迟[TIME]毫秒",
    "YCAIS.ui.showScreen": "重绘[SCREEN]屏幕",
    "YCAIS.ui.setScreenBgColor": "设置屏幕 [SCREEN] 背景颜色为 [COLOR]",
    "YCAIS.ui.createLabel": "在屏幕 [SCREEN] 上创建标签，文本为 [TEXT]，位置 x:[X] y:[Y] 宽度:[WIDTH] 高度:[HEIGHT]",
    "YCAIS.ui.setLabelColor": "设置标签 [LABEL] 颜色为 [COLOR]",
    "YCAIS.ui.setLabelText": "设置标签 [LABEL] 内容为 [TEXT]",
    "YCAIS.ui.setLabelFont": "设置标签 [LABEL] 字体为 [FONT]",
    "YCAIS.ui.setLabelAlign": "设置标签 [LABEL] 对齐方式为 [ALIGN]",
    "YCAIS.util.float2str": "将[FLOAT_VALUE]转成字符串",
    "YCAIS.util.int2str": "将[INT_VALUE]转成字符串",
    "YM5G.categoryName": "YM5G",
    "YM5G.ble.connect": "连接到 YM-5G-[DEVICE_NAME]",
    "YM5G.ble.disconnect": "断开 YM 5G 连接",
    "YM5G.getSignalStrength": "获取信号强度",
    "YM5G.getIMEI": "获取 IMEI",
    "YM5G.getOperator": "获取运营商",
    "YM5G.getICCID": "获取 ICCID",
    "YM5G.getSIMId": "获取 SIM TYPE",
    "YM5G.get5GStatus": "获取 5G 状态",
    "YM5G.mqtt.setClientId": "设置 MQTT 客户端 ID 为 [CLIENTID]",
    "YM5G.mqtt.setHost": "设置 MQTT 主机为 [HOST]",
    "YM5G.mqtt.setPort": "设置 MQTT 端口为 [PORT]",
    "YM5G.mqtt.setUser": "设置 MQTT 用户为 [USER]",
    "YM5G.mqtt.setPassword": "设置 MQTT 密码为 [PASSWORD]",
    "YM5G.mqtt.setQos": "设置 MQTT QoS 为 [QOS]",
    "YM5G.mqtt.connect": "连接到 MQTT ",
    "YM5G.mqtt.disconnect": "断开 MQTT连接",
    "YM5G.mqtt.getStatus": "MQTT 连接状态",
    "YM5G.mqtt.getConfig": "MQTT [CONFIG] 值",
    "YM5G.mqtt.publish": "发布主题 [TOPIC] 消息 [MESSAGE]",
    "YM5G.mqtt.subscribe": "订阅主题 [TOPIC]",
    "YM5G.mqtt.getLatestMessage": "最新 MQTT 消息",
    "YM5G.mqtt.config.clientId": "客户端 ID",
    "YM5G.mqtt.config.host": "主机域名",
    "YM5G.mqtt.config.port": "端口",
    "YM5G.mqtt.config.user": "用户名",
    "YM5G.mqtt.config.qos": "QoS",
    "YMGNSS.categoryName": "定位",
    "YMGNSS.ble.connect": "连接到 YM-GNSS-[DEVICE_NAME]",
    "YMGNSS.ble.disconnect": "断开 YM GNSS 连接",
    "YMGNSS.getLon": "获取经度",
    "YMGNSS.getLat": "获取纬度",
    "YMGNSS.getAltitude": "获取海拔高度",
    "YMGNSS.getLonStr": "获取经度(字符串)",
    "YMGNSS.getLatStr": "获取纬度(字符串)",
    "YMGNSS.getAltitudeStr": "获取海拔高度(字符串)",
    "YMGNSS.getAcceleration": "获取加速度",
    "YMGNSS.getSpeed": "获取速度",
    "YMGNSS.getAngleOfMotion": "获取运动角度",
    "YMGNSS.getAllSatelliteInfo": "获取所有卫星信息",
    "YMGNSS.getSatellitesStr": "获取卫星数量(字符串)",
    "YMGNSS.getPositionStatus": "获取定位状态",
    "YMGNSS.ym_gnss2json": "将纬度：[LAT] 经度；[LON] 海拔高度；[ALT] 卫星数： [SAT] 组合成 [BUFFER]",
    "YMGNSS.getTotalSatellites": "获取所有卫星信息",
    "YMGNSS.getBeidouSatellites": "获取北斗卫星信息",
    "YMGNSS.getGpsSatellites": "获取GPS卫星信息",
    "YMGNSS.calculateDistance": "计算当前位置 [LAT], [LON] 与远程位置 [REMOTE_LAT], [REMOTE_LON] 之间的距离",
    "YMGNSS.jsonToGnss": "将JSON转换成GNSS数据",
    "YMGNSS.getRemoteAlt": "获取远程设备的海拔高度信息",
    "YMGNSS.getRemoteLat": "获取远程设备的维度信息",
    "YMGNSS.getRemoteLon": "获取远程设备的经度信息",
    "YMGNSS.getRemoteSat": "获取远程设备的卫星信息",
    "YMGNSS.formatLocationString": "将 [VAL]赋值成： [TEXT] 纬度[LAT] 经度[LON] 海拔[ALT] 卫星数[SAT]",
    "YMUS.categoryName": "YM 超声波传感器",
    "YMUS.ble.connect": "连接到 YM-US-[DEVICE_NAME]",
    "YMUS.ble.disconnect": "断开 YM US 连接",
    "YMUS.getDistance": "获取距离",
    "paint.colorPicker.swap": "交换",
    "paint.paintEditor.hue": "颜色",
    "paint.paintEditor.saturation": "饱和度",
    "paint.paintEditor.brightness": "亮度",
    "paint.paintEditor.costume": "造型",
    "paint.paintEditor.group": "组合",
    "paint.paintEditor.ungroup": "拆散",
    "paint.paintEditor.undo": "撤销",
    "paint.paintEditor.redo": "重做",
    "paint.paintEditor.forward": "往前放",
    "paint.paintEditor.backward": "往后放",
    "paint.paintEditor.front": "放最前面",
    "paint.paintEditor.back": "放最后面",
    "paint.paintEditor.more": "更多",
    "paint.modeTools.brushSize": "粗细",
    "paint.modeTools.eraserSize": "橡皮擦大小",
    "paint.modeTools.copy": "复制",
    "paint.modeTools.paste": "粘贴",
    "paint.modeTools.delete": "删除",
    "paint.modeTools.curved": "曲线",
    "paint.modeTools.pointed": "折线",
    "paint.modeTools.thickness": "粗细",
    "paint.modeTools.flipHorizontal": "水平翻转",
    "paint.modeTools.flipVertical": "垂直翻转",
    "paint.modeTools.filled": "实心",
    "paint.modeTools.outlined": "轮廓",
    "paint.paintEditor.bitmap": "转换为位图",
    "paint.paintEditor.vector": "转换为矢量图",
    "paint.paintEditor.fill": "填充",
    "paint.paintEditor.stroke": "轮廓",
    "paint.brushMode.brush": "画笔",
    "paint.eraserMode.eraser": "橡皮擦",
    "paint.fillMode.fill": "填充",
    "paint.lineMode.line": "线段",
    "paint.ovalMode.oval": "圆",
    "paint.rectMode.rect": "矩形",
    "paint.reshapeMode.reshape": "变形",
    "paint.roundedRectMode.roundedRect": "圆角矩形",
    "paint.selectMode.select": "选择",
    "paint.textMode.text": "文本"
  },
  "zh-tw": {
    "gui.alerts.lostPeripheralConnection": "Scratch 與 {extensionName} 的連線中斷。",
    "gui.alerts.tryAgain": "再試一次",
    "gui.alerts.download": "下載",
    "gui.connection.reconnect": "重新連接",
    "gui.alerts.uploadFirmware": "上傳韌體",
    "gui.backpack.costumeLabel": "造型",
    "gui.backpack.soundLabel": "音效",
    "gui.backpack.scriptLabel": "程式",
    "gui.backpack.spriteLabel": "角色",
    "gui.backpack.header": "背包",
    "gui.backpack.errorBackpack": "載入背包時發生錯誤",
    "gui.backpack.loadingBackpack": "正在載入…",
    "gui.backpack.more": "更多資訊",
    "gui.backpack.emptyBackpack": "背包空無一物",
    "gui.unsupportedBrowser.label": "瀏覽器不支援",
    "gui.unsupportedBrowser.errorLabel": "發生錯誤",
    "gui.unsupportedBrowser.notRecommended": "很抱歉，這個版本的瀏覽器無法支援 Scratch。建議你改用其它的，像是 Google Chrome、Mozilla Firefox、Microsoft Edge、Apple Safari。",
    "gui.unsupportedBrowser.description": "很抱歉，這個瀏覽器無法支援 Scratch。建議你改用其它的，像是 Google Chrome、Mozilla Firefox、Microsoft Edge、Apple Safari。",
    "gui.unsupportedBrowser.back": "返回",
    "gui.unsupportedBrowser.previewfaq": "若要進一步瞭解，請至 {previewFaqLink}。",
    "gui.unsupportedBrowser.previewfaqlinktext": "常見問答",
    "gui.cards.all-tutorials": "教程",
    "gui.cards.shrink": "縮小",
    "gui.cards.expand": "放大",
    "gui.cards.close": "關閉",
    "gui.cards.more-things-to-try": "試試其它東西！",
    "gui.cards.see-more": "觀看更多",
    "gui.comingSoon.message1": "別擔心，我們在做囉 {emoji}",
    "gui.comingSoon.message2": "即將推出...",
    "gui.comingSoon.message3": "我們在做囉 {emoji}",
    "gui.connection.auto-scanning.noPeripheralsFound": "沒有找到裝置",
    "gui.connection.auto-scanning.prescan": "把你的裝置放得近一些，然後再開始搜索。",
    "gui.connection.auto-scanning.pressbutton": "按下裝置上的按鈕。",
    "gui.connection.auto-scanning.start-search": "開始搜尋",
    "gui.connection.connecting-searchbutton": "正在搜尋…",
    "gui.connection.auto-scanning.try-again": "再試一次",
    "gui.connection.connected": "裝置已連線",
    "gui.connection.disconnect": "中斷裝置連線",
    "gui.connection.go-to-editor": "回到編輯區",
    "gui.connection.connecting-cancelbutton": "正在連線...",
    "gui.connection.accessDeniedError.errorMessage": "糟糕，串口訪問被拒絕，請檢查串口是否被佔用。",
    "gui.connection.unknownErrorCode31.errorMessage": "糟糕，未知錯誤代碼31，建議重新插入設備。",
    "gui.connection.error.errorMessage": "喔，好像有什麼地方出錯了。",
    "gui.connection.error.tryagainbutton": "再試一次",
    "gui.connection.error.helpbutton": "幫助",
    "gui.connection.peripheral-name-label": "裝置名稱",
    "gui.connection.connect": "開始連線",
    "gui.connection.scanning.listAll": "顯示全部可連接的設備",
    "gui.connection.scanning.lookingforperipherals": "正在尋找裝置",
    "gui.connection.scanning.noPeripheralsFound": "沒有找到裝置",
    "gui.connection.scanning.instructions": "在列表中選擇你的裝置",
    "gui.connection.search": "重新整理",
    "gui.connection.unavailable.installscratchlink": "確定你已經安裝並執行 Scratch Link",
    "gui.connection.unavailable.connectUsbEnableBluetooth": "請確認USB線已連接或藍牙已經開啟",
    "gui.connection.unavailable.tryagainbutton": "再試一次",
    "gui.connection.unavailable.helpbutton": "幫助",
    "gui.controls.go": "開始",
    "gui.controls.stop": "停止",
    "gui.crashMessage.label": "哎呀！發生了一些錯誤。",
    "gui.crashMessage.description": "很抱歉，看起來 Scratch 崩潰了，錯誤已自動回報給 Scratch 團隊，請重新整理你的頁面，再試一次吧！",
    "gui.crashMessage.errorNumber": "錯誤已被紀錄，id 為 {errorId}",
    "gui.crashMessage.reload": "重新載入",
    "gui.customProcedures.myblockModalTitle": "建立一個積木",
    "gui.customProcedures.addAnInputNumber": "添加輸入項",
    "gui.customProcedures.numberType": "數字",
    "gui.customProcedures.addAnInputText": "新增輸入項",
    "gui.customProcedures.TextType": "文字",
    "gui.customProcedures.addAnInputBoolean": "新增輸入方塊",
    "gui.customProcedures.booleanType": "布林值",
    "gui.customProcedures.addALabel": "新增說明文字",
    "gui.customProcedures.runWithoutScreenRefresh": "執行完畢再更新畫面",
    "gui.customProcedures.cancel": "取消",
    "gui.customProcedures.ok": "確定",
    "gui.deviceTypeModal.deviceTypeTitle": "選擇編程類型",
    "gui.deviceTypeModal.arduino": "Arduino",
    "gui.deviceTypeModal.python": "Python",
    "gui.deviceTypeModal.microPython": "MicroPython",
    "gui.deviceTypeModal.cancel": "取消",
    "gui.SpriteInfo.direction": "方向",
    "gui.directionPicker.rotationStyles.allAround": "不設限",
    "gui.directionPicker.rotationStyles.leftRight": "左-右",
    "gui.directionPicker.rotationStyles.dontRotate": "不旋轉",
    "gui.gui.addExtension": "添加擴展",
    "gui.gui.codeTab": "程式",
    "gui.gui.backdropsTab": "背景",
    "gui.gui.costumesTab": "造型",
    "gui.gui.soundsTab": "音效",
    "gui.hardwareConsole.send": "發送",
    "gui.hardwareConsole.buadrate": "鮑率",
    "gui.hardwareConsole.endOfLine": "行結尾",
    "gui.hardwareConsole.hexform": "16進位格式",
    "gui.hardwareConsole.autoScroll": "自動捲動",
    "gui.hardwareHeader.upload": "上傳",
    "gui.stageHeader.codeStageSizeLarge": "模式切換 - 大舞台",
    "gui.stageHeader.codeStageSizeSmall": "模式切換 - 小舞台",
    "gui.stageHeader.hideStage": "隱藏舞台",
    "gui.extensionLibrary.comingSoon": "即將推出",
    "gui.extensionLibrary.requires": "需求",
    "gui.extensionLibrary.collaboration": "合作者",
    "gui.extensionLibrary.manufactor": "製造商",
    "gui.extensionLibrary.version": "版本",
    "gui.extensionLibrary.author": "作者",
    "gui.extensionLibrary.programMode": "編程模式",
    "gui.extensionLibrary.programLanguage": "編程語言",
    "gui.extensionLibrary.deviceLearnMore": "了解更多",
    "gui.extensionLibrary.extensionHelp": "幫助",
    "gui.extensionLibrary.Processing": "處理中...",
    "gui.extensionLibrary.loaded": "已載入",
    "gui.extensionLibrary.notLoaded": "未載入",
    "gui.library.filterPlaceholder": "搜尋",
    "gui.library.allTag": "全部",
    "gui.loader.message1": "正在創建積木…",
    "gui.loader.message2": "正在載入角色…",
    "gui.loader.message3": "正在載入音效…",
    "gui.loader.message4": "正在載入擴展…",
    "gui.loader.message5": "Herding cats …",
    "gui.loader.message6": "Transmitting nanos …",
    "gui.loader.message7": "Inflating gobos …",
    "gui.loader.message8": "正在準備表情符號…",
    "gui.loader.headline": "正在載入專案",
    "gui.loader.creating": "正在建立專案",
    "gui.accountMenu.profile": "個人資料",
    "gui.accountMenu.myStuff": "我的作品",
    "gui.accountMenu.myClasses": "我的所有班級",
    "gui.accountMenu.myClass": "我的班級",
    "gui.accountMenu.accountSettings": "帳戶設定",
    "gui.accountMenu.signOut": "登出",
    "gui.authorInfo.byUser": "建立者 {username}",
    "gui.menuBar.seeProjectPage": "切換到專案頁面",
    "general.username": "用戶名稱",
    "general.password": "用戶密碼",
    "general.signIn": "登入",
    "login.needHelp": "需要幫助？",
    "form.validationRequired": "必填欄位",
    "gui.menuBar.LanguageSelector": "語言選擇器",
    "gui.menuBar.tutorialsLibrary": "教程",
    "gui.menuBar.community": "開放社區",
    "gui.menuBar.wiki": "維基",
    "gui.menuBar.restoreSprite": "復原角色",
    "gui.menuBar.restoreSound": "復原音效",
    "gui.menuBar.restoreCostume": "復原造型",
    "gui.menuBar.restore": "復原",
    "gui.menuBar.saveNow": "儲存",
    "gui.menuBar.saveAsCopy": "另存成複本",
    "gui.menuBar.remix": "改編",
    "gui.menuBar.new": "新建專案",
    "gui.menuBar.checkUpdate": "檢查更新",
    "gui.menuBar.installDriver": "安裝驅動",
    "gui.menuBar.clearCacheAndRestart": "清除緩存並重啟",
    "gui.menuBar.file": "檔案",
    "gui.menuBar.downloadToComputer": "下載到你的電腦",
    "gui.menuBar.edit": "編輯",
    "gui.menuBar.turboModeOff": "關閉加速模式",
    "gui.menuBar.turboModeOn": "開啟加速模式",
    "gui.menuBar.noDeviceSelected": "未選擇設備",
    "gui.menuBar.noConnection": "沒有連接",
    "gui.menuBar.uploadFirmware": "上傳韌體",
    "gui.menu-bar.programMode": "編程模式",
    "gui.gui.projectTitlePlaceholder": "在這輸入專案名稱",
    "gui.menuBar.saveNowLink": "立刻儲存",
    "gui.menuBar.isShared": "已分享",
    "gui.menuBar.share": "分享",
    "gui.modal.help": "幫助",
    "gui.modal.back": "返回",
    "gui.monitor.listMonitor.empty": "(empty)",
    "gui.monitor.listMonitor.listLength": "長度 {length}",
    "gui.monitor.contextMenu.default": "一般顯示",
    "gui.monitor.contextMenu.large": "大型顯示",
    "gui.monitor.contextMenu.slider": "滑桿",
    "gui.monitor.contextMenu.sliderRange": "變更滑桿數值範圍",
    "gui.monitor.contextMenu.import": "匯入",
    "gui.monitor.contextMenu.export": "匯出",
    "gui.playButton.play": "播放",
    "gui.playButton.stop": "停止",
    "gui.gui.variableScopeOptionAllSprites": "適用於所有角色",
    "gui.gui.variableScopeOptionSpriteOnly": "僅適用當前角色",
    "gui.gui.cloudVariableOption": "雲端變數（儲存於伺服器）",
    "gui.gui.variablePromptAllSpritesMessage": "這個變數適用於所有角色。",
    "gui.gui.listPromptAllSpritesMessage": "這個清單適用於所有角色。",
    "gui.prompt.cancel": "取消",
    "gui.prompt.ok": "確定",
    "gui.playbackStep.stopMsg": "停止",
    "gui.playbackStep.playMsg": "播放",
    "gui.playbackStep.loadingMsg": "正在載入…",
    "gui.playbackStep.saveMsg": "儲存",
    "gui.playbackStep.reRecordMsg": "重新錄音",
    "gui.recordModal.title": "錄音",
    "gui.recordingStep.beginRecord": "點擊下方按鈕開始錄製",
    "gui.recordingStep.permission": "{arrow} 我們需要你的允許才能使用麥克風",
    "gui.recordingStep.stop": "停止錄製",
    "gui.recordingStep.record": "錄製",
    "gui.sliderModal.min": "最小值",
    "gui.sliderModal.max": "最大值",
    "gui.sliderModal.title": "變更滑桿數值範圍",
    "gui.sliderPrompt.cancel": "取消",
    "gui.sliderPrompt.ok": "確定",
    "gui.soundEditor.sound": "音效",
    "gui.soundEditor.play": "播放",
    "gui.soundEditor.stop": "停止",
    "gui.soundEditor.copy": "拷貝",
    "gui.soundEditor.paste": "貼上",
    "gui.soundEditor.copyToNew": "複製",
    "gui.soundEditor.delete": "刪除",
    "gui.soundEditor.save": "保存",
    "gui.soundEditor.undo": "復原",
    "gui.soundEditor.redo": "重做",
    "gui.soundEditor.faster": "快播",
    "gui.soundEditor.slower": "慢播",
    "gui.soundEditor.echo": "回音",
    "gui.soundEditor.robot": "機器",
    "gui.soundEditor.louder": "響亮",
    "gui.soundEditor.softer": "輕柔",
    "gui.soundEditor.reverse": "反轉",
    "gui.soundEditor.fadeOut": "淡出",
    "gui.soundEditor.fadeIn": "淡入",
    "gui.soundEditor.mute": "靜音",
    "gui.SpriteInfo.spritePlaceholder": "名稱",
    "gui.SpriteInfo.sprite": "角色",
    "gui.SpriteInfo.show": "顯示",
    "gui.SpriteInfo.size": "尺寸",
    "gui.spriteSelectorItem.contextMenuDuplicate": "複製",
    "gui.spriteSelectorItem.contextMenuExport": "匯出",
    "gui.spriteSelectorItem.contextMenuDelete": "刪除",
    "gui.spriteSelector.addSpriteFromLibrary": "選個角色",
    "gui.spriteSelector.addSpriteFromPaint": "繪畫",
    "gui.spriteSelector.addSpriteFromSurprise": "驚喜",
    "gui.spriteSelector.addSpriteFromFile": "上傳",
    "gui.stageHeader.stageSizeLarge": "模式切換 - 大舞台",
    "gui.stageHeader.stageSizeSmall": "模式切換 - 小舞台",
    "gui.stageHeader.stageSizeFull": "模式切換 - 全螢幕",
    "gui.stageHeader.stageSizeUnFull": "離開全螢幕模式",
    "gui.stageHeader.fullscreenControl": "顯示模式切換",
    "gui.spriteSelector.addBackdropFromLibrary": "選個背景",
    "gui.stageSelector.addBackdropFromPaint": "繪畫",
    "gui.stageSelector.addBackdropFromSurprise": "驚喜",
    "gui.stageSelector.addBackdropFromFile": "上傳",
    "gui.stageSelector.stage": "舞台",
    "gui.stageSelector.backdrops": "背景",
    "gui.telemetryOptIn.label": "回報統計數據以協助改善 Scratch",
    "gui.telemetryOptIn.body1": "Scratch 團隊希望能深入瞭解 Scratch 在世界各地的使用情況。如果可以的話，希望你能允許 Scratch 將你的使用情形紀錄下來並發送給 Scratch 團隊。",
    "gui.telemetryOptIn.body2": "我們會蒐集的資訊包含了語言的選擇、積木的使用量，還有一些事件，像是儲存、載入、上傳專案。我們保證不會收集任何個人資訊。你可以觀看我們的 {privacyPolicyLink} 以進一步瞭解相關訊息。",
    "gui.telemetryOptIn.privacyPolicyLink": "隱私政策",
    "gui.telemetryOptIn.optInText": "分享我的使用資料給 Scratch 團隊",
    "gui.telemetryOptIn.optInTooltip": "啟用 Telemetry",
    "gui.telemetryOptIn.optOutText": "不分享我的使用資料給 Scratch 團隊",
    "gui.telemetryOptIn.optOutTooltip": "停用 Telemetry",
    "gui.telemetryOptIn.settingWasUpdated": "您的設定已更新。",
    "gui.telemetryOptIn.buttonClose": "關閉",
    "gui.turboMode.active": "加速模式",
    "gui.updateModal.close": "關閉",
    "gui.updateModal.downloading": "下載中",
    "gui.updateModal.abort": "中止",
    "gui.updateModel.tileCheckingForUpdate": "正在檢查更新",
    "gui.updateModel.checkingTips": "根據您的網絡，此步驟可能需要幾秒鐘到十幾秒鐘，請稍候。",
    "gui.updateModel.tileUpdateExternalResource": "檢測到新版本的外部資源",
    "gui.updateModel.tileUpdateApplication": "檢測到新版本的此應用程序",
    "gui.updateModal.updateLater": "稍後升級",
    "gui.updateModal.updateAndRestart": "升級並重啟",
    "gui.updateModel.tileAlreadyLatest": "未檢測到新版本",
    "gui.updateModel.alreadyLatestTips": "Openblock 已經是最新的版本了。",
    "gui.updateModel.tileError": "操作失敗",
    "gui.updateModel.upgradingExternalResource": "正在升級外部資源",
    "gui.updateModal.deletingCompressedFile": "正在刪除壓縮文件",
    "gui.updateModal.deletingCacheFile": "正在刪除緩存文件",
    "gui.updateModal.extractingCompressedFile": "正在解壓壓縮文件",
    "gui.updateModal.verifyingCompressedFile": "正在校驗壓縮文件",
    "gui.updateModal.verifyingCacheFile": "正在校驗緩存文件",
    "gui.updateModel.tileResourceUpdateFinish": "外部資源更新已完成",
    "gui.updateModal.resourceUpdateFinishTips": "外部資源更新已完成，應用程序將會在3秒後自動重啟。",
    "gui.updateModel.downloadingApplication": "正在下載應用程序",
    "gui.updateModel.tileApplicationDownloadFinish": "應用程序下載完成",
    "gui.updateModal.applicationDownloadeFinishTips": "應用程序下載完成，將在3秒後自動退出並啟動安裝程序。",
    "gui.uploadProgress.uploading": "上傳中",
    "gui.uploadProgress.uploadSuccess": "上傳成功",
    "gui.uploadProgress.uploadError": "上傳錯誤",
    "gui.uploadProgress.uploadTimeout": "上傳超時",
    "gui.uploadProgress.uploadAborted": "上傳被中止",
    "gui.uploadProgress.abort": "中止",
    "gui.uploadProgress.close": "關閉",
    "gui.webglModal.label": "你的瀏覽器不支援 WebGL",
    "gui.webglModal.description": "似乎你的瀏覽器或裝置 {webGlLink}，這是讓 Scratch 運作的必要技術。",
    "gui.webglModal.webgllink": "不支援 WebGL",
    "gui.webglModal.back": "返回",
    "gui.webglModal.previewfaq": "若要進一步瞭解，請至 {previewFaqLink}。",
    "gui.webglModal.previewfaqlinktext": "常見問答",
    "gui.costumeLibrary.chooseABackdrop": "範例背景",
    "gui.costumeLibrary.chooseACostume": "範例造型",
    "gui.costumeTab.addBackdropFromLibrary": "選個背景",
    "gui.costumeTab.addCostumeFromLibrary": "選個造型",
    "gui.costumeTab.addBlankCostume": "繪畫",
    "gui.costumeTab.addSurpriseCostume": "驚喜",
    "gui.costumeTab.addFileBackdrop": "上傳",
    "gui.costumeTab.addFileCostume": "上傳",
    "gui.deviceLibrary.chooseADevice": "選擇一個設備",
    "gui.deviceLibrary.deviceUrl": "輸入設備的URL",
    "gui.deviceLibrary.arduinoTag": "Arduino",
    "gui.deviceLibrary.microPythonTag": "MicroPython",
    "gui.deviceLibrary.kitTag": "易联魔方",
    "gui.deviceLibrary.sensorTag": "感測器",
    "gui.extensionLibrary.chooseAnExtension": "選擇擴充功能",
    "gui.extensionLibrary.extensionUrl": "輸入擴充功能的網址",
    "gui.library.shieldTag": "擴展板",
    "gui.library.actuatorTag": "執行器",
    "gui.library.sensorTag": "感測器",
    "gui.library.displayTag": "顯示",
    "gui.library.communicationTag": "通訊",
    "gui.library.otherTag": "其它",
    "gui.hardwareConsole.noLineTerminators": "沒有結束符",
    "gui.hardwareConsole.lineFeed": "換行符",
    "gui.hardwareConsole.carriageReturn": "回車",
    "gui.hardwareConsole.lfAndCr": "確定加換行",
    "gui.monitors.importListColumnPrompt": "該使用哪一欄（1-{numberOfColumns}）？",
    "gui.recordingStep.alertMsg": "無法開始錄製",
    "gui.soundLibrary.chooseASound": "範例音效",
    "gui.soundTab.fileUploadSound": "上傳",
    "gui.soundTab.surpriseSound": "驚喜",
    "gui.soundTab.recordSound": "錄製",
    "gui.soundTab.addSoundFromLibrary": "選個音效",
    "gui.spriteLibrary.chooseASprite": "範例角色",
    "gui.tipsLibrary.tutorials": "選擇教程",
    "gui.updateModal.updateWarning": "當前未保存的工程將會丟失，繼續更新並重啟？",
    "gui.uploadProgress.uploadErrorMessage": "上傳錯誤",
    "gui.uploadProgress.uploadTimeoutMessage": "上傳超時",
    "gui.alerts.createsuccess": "專案創建成功。",
    "gui.alerts.createcopysuccess": "已另存為複本。",
    "gui.alerts.createremixsuccess": "已另存為改編本。",
    "gui.alerts.creating": "正在創建新的專案…",
    "gui.alerts.creatingCopy": "正在複製專案…",
    "gui.alerts.creatingRemix": "正在改編專案…",
    "gui.alerts.creatingError": "專案無法創建，麻煩再試一次！",
    "gui.alerts.savingError": "專案無法儲存。",
    "gui.alerts.savesuccess": "專案儲存成功。",
    "gui.alerts.saving": "正在儲存專案…",
    "gui.alerts.cloudInfo": "注意，雲端變數目前只支援數字，不能存取文字等其它符號。{learnMoreLink}",
    "gui.alerts.cloudInfoLearnMore": "進一步瞭解",
    "gui.alerts.importing": "正在匯入…",
    "gui.alerts.workspaceIsEmpty": "工作空間是空的",
    "gui.alerts.workspaceIsNotEmpty": "工作區不是空的，請先清理你的工作空間",
    "gui.alerts.uploadError": "上傳錯誤",
    "gui.alerts.uploadSuccess": "上傳成功",
    "gui.alerts.selectADeviceFirst": "請先選擇一個設備",
    "gui.alerts.connectAPeripheralFirst": "請先連接設備",
    "gui.alerts.codeEditorIsLocked": "代碼編輯器處於鎖定狀態，如果要編輯代碼，請先點擊解鎖按鈕",
    "gui.alerts.codeEditorIsUnlocked": "代碼編輯器處於解鎖狀態，如果你想由積木生成代碼，請先點擊鎖定按鈕",
    "gui.defaultProject.chirp": "啁啾",
    "gui.defaultProject.variable": "my variable",
    "gui.howtos.intro-move-sayhello-hat.name": "新手入門",
    "gui.howtos.intro-move.step_stepMove": "新增一個移動積木",
    "gui.howtos.add-a-move-block.step_stepSay": "新增一個說出積木",
    "gui.howtos.add-a-move-block.step_stepGreenFlag": "點擊綠旗以執行程式",
    "gui.howtos.intro-getting-started-ASL.name": "新手入門 - 美國手語",
    "gui.howtos.animate-a-name.name": "姓名動畫",
    "gui.howtos.animate-a-name.step_AnimatePickLetter": "選擇一個字母",
    "gui.howtos.animate-a-name.step_AnimatePlaySound": "當被點擊時播放一個音效",
    "gui.howtos.animate-a-name.step_AnimatePickLetter2": "選擇另一個字母",
    "gui.howtos.animate-a-name.step_AnimateChangeColor": "更改顏色",
    "gui.howtos.animate-a-name.step_AnimateSpin": "選擇另一個字母並讓它旋轉",
    "gui.howtos.animate-a-name.step_AnimateGrow": "選擇另一個字母並讓它縮放",
    "gui.howtos.imagine": "想像的世界",
    "gui.howtos.imagine.step_imagineTypeWhatYouWant": "輸入你想要說的內容",
    "gui.howtos.imagine.step_imagineClickGreenFlag": "點擊綠旗運行看看",
    "gui.howtos.imagine.step_imagineChooseBackdrop": "選個背景",
    "gui.howtos.imagine.step_imagineChooseSprite": "選個角色",
    "gui.howtos.imagine.step_imagineFlyAround": "按下空白鍵就可以滑行",
    "gui.howtos.imagine.step_imagineChooseAnotherSprite": "選另一個角色",
    "gui.howtos.imagine.step_imagineLeftRight": "左右移動",
    "gui.howtos.imagine.step_imagineUpDown": "上下移動",
    "gui.howtos.imagine.step_imagineChangeCostumes": "變更造型",
    "gui.howtos.imagine.step_imagineGlideToPoint": "滑行到一個地方",
    "gui.howtos.imagine.step_imagineGrowShrink": "放大與縮小",
    "gui.howtos.imagine.step_imagineChooseAnotherBackdrop": "選另一個背景",
    "gui.howtos.imagine.step_imagineSwitchBackdrops": "切換背景",
    "gui.howtos.imagine.step_imagineRecordASound": "新增一個音效",
    "gui.howtos.imagine.step_imagineChooseSound": "選個音效",
    "gui.howtos.make-music.name": "音樂創作",
    "gui.howtos.Make-Music.step_PickInstrument": "選擇一個樂器當角色",
    "gui.howtos.Make-Music.step_PlaySoundClick": "當被點擊時播放音效",
    "gui.howtos.Make-Music.step_MakeSong": "創建一首歌曲",
    "gui.howtos.make-music.step_MakeBeat": "選擇一種樂器並打出節拍",
    "gui.howtos.make-music.step_MakeBeatBox": "選擇角色 Microphone（麥克風）& 用驚喜按鈕產生 Beatbox",
    "gui.howtos.story.name": "創作故事",
    "gui.howtos.story.step_addbg": "新增一個背景",
    "gui.howtos.story.step_addsprite": "新增一個角色",
    "gui.howtos.story.step_saysomething": "讓角色說些話",
    "gui.howtos.story.step_addanothersprite": "加入另一個角色",
    "gui.howtos.story.step_flip": "翻轉造型",
    "gui.howtos.story.step_conversation": "開始對話",
    "gui.howtos.story.addanotherbg": "新增其它背景",
    "gui.howtos.story.step_swithbg": "切換背景",
    "gui.howtos.story.step_hidewizard": "隱藏一個角色",
    "gui.howtos.story.step_showwizard": "顯示一個角色",
    "gui.howtos.make-a-chase-game.name": "創作一個追逐遊戲",
    "gui.howtos.Chase-Game.step_BG": "新增一個背景",
    "gui.howtos.chase-game.step_AddOcto": "新增一個角色",
    "gui.howtos.make-music.step_LeftRight": "用方向鍵左右移動",
    "gui.howtos.Chase-Game.step_UpDown": "用方向鍵上下移動",
    "gui.howtos.Chase-Game.step_AddStar": "新增其他角色",
    "gui.howtos.Chase-Game.step_MoveRandom": "任意移動",
    "gui.howtos.Chase-Game.step_WhenTouch": "當碰到 Octopus（章魚）角色時播放音效",
    "gui.howtos.Chase-Game.step_ScoreVariable": "創建一個變數以紀錄分數",
    "gui.howtos.Chase-Game.ScoreWhenTouch": "當碰到 Octopus（章魚）角色時增加分數",
    "gui.howtos.animate-char.name": "讓角色動起來",
    "gui.howtos.animate-char.step_addbg": "新增一個背景",
    "gui.howtos.animate-char.step_addsprite": "新增一個角色",
    "gui.howtos.animate-char.step_saysomething": "讓角色說些話",
    "gui.howtos.animate-char.step_addsound": "新增聲音",
    "gui.howtos.animate-char.step_animatetalking": "讓角色說些話",
    "gui.howtos.animate-char.step_arrowkeys": "用方向鍵移動",
    "gui.howtos.animate-char.step_jump": "跳躍",
    "gui.howtos.animate-char.step_changecolor": "更改顏色",
    "gui.howtos.make-a-game.name": "創作一個點擊遊戲",
    "gui.howtos.Make-A-Game.step_GamePickSprite": "挑選一個角色",
    "gui.howtos.make-a-game.step_GamePlaySound": "當被點擊時播放音效",
    "gui.howtos.make-a-game.step_GameAddScore": "創建一個變數以紀錄分數",
    "gui.howtos.make-a-game.step_GameChangeScore": "單擊時增加分數",
    "gui.howtos.make-a-game.step_Random": "定位到隨機位置",
    "gui.howtos.make-music.step_GameChangeColor": "更改顏色",
    "gui.howtos.make-music.step_ResetScore": "重設分數",
    "gui.howtos.make-it-fly.name": "讓它飛吧",
    "gui.howtos.fly.step_stepflyChooseBackdrop": "選個天空背景",
    "gui.howtos.add-a-move-block.step_stepflyChooseCharacter": "選擇一個角色",
    "gui.howtos.fly.step_stepflySaySomething": "讓角色說些話",
    "gui.howtos.add-a-move-block.step_stepflyMoveArrows": "用方向鍵移動",
    "gui.howtos.fly.step_stepflyChooseObject": "選個要收集的東西",
    "gui.howtos.add-a-move-block.step_stepflyFlyingObject": "讓東西動起來",
    "gui.howtos.add-a-move-block.step_stepflySelectFlyingSprite": "選個主角",
    "gui.howtos.add-a-move-block.step_stepflyAddScore": "加入得分",
    "gui.howtos.add-a-move-block.step_stepflyKeepScore": "紀錄分數",
    "gui.howtos.add-a-move-block.step_stepflyAddScenery": "加入景物",
    "gui.howtos.add-a-move-block.step_stepflyMoveScenery": "移動佈景",
    "gui.howtos.add-a-move-block.step_stepflySwitchLooks": "下個造型",
    "gui.howtos.pong": "乒乓球遊戲",
    "gui.howtos.pong.step_pongAddBackdrop": "新增一個背景",
    "gui.howtos.pong.step_pongAddBallSprite": "新增一個球當角色",
    "gui.howtos.pong.step_pongBounceAround": "碰到邊緣就反彈",
    "gui.howtos.pong.step_pongAddPaddle": "新增一個球拍",
    "gui.howtos.pong.step_pongMoveThePaddle": "控制球拍",
    "gui.howtos.pong.step_pongSelectBallSprite": "選取角色球",
    "gui.howtos.pong.step_pongAddMoreCodeToBall": "加入碰到球拍就反彈的程式",
    "gui.howtos.pong.step_pongAddAScore": "加入得分",
    "gui.howtos.pong.step_pongChooseScoreFromMenu": "從選單選擇「得分」",
    "gui.howtos.pong.step_pongInsertChangeScoreBlock": "插入「變數得分改變為」積木",
    "gui.howtos.pong.step_pongResetScore": "重設分數",
    "gui.howtos.pong.step_pongAddLineSprite": "新增線條的角色",
    "gui.howtos.pong.step_pongGameOver": "遊戲結束",
    "gui.howtos.code-cartoon": "動畫編程",
    "gui.howtos.code-cartoon.step_codeCartoonSaySomething": "點擊綠旗圖示時讓角色說些話",
    "gui.howtos.code-cartoon.step_codeCartoonAnimate": "點擊角色時讓它動起來",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter": "選個其它的角色",
    "gui.howtos.code-cartoon.step_codeCartoonUseMinusSign": "輸入負數讓角色變得愈來愈小",
    "gui.howtos.code-cartoon.step_codeCartoonGrowShrink": "讓角色放大與縮小",
    "gui.howtos.code-cartoon.step_codeCartoonSelectDifferentCharacter2": "選個其它的角色",
    "gui.howtos.code-cartoon.step_codeCartoonJump": "跳上跳下",
    "gui.howtos.code-cartoon.step_codeCartoonChangeScenes": "點擊角色以變更場景",
    "gui.howtos.code-cartoon.step_codeCartoonGlideAround": "角色滑行",
    "gui.howtos.code-cartoon.step_codeCartoonChangeCostumes": "變更造型",
    "gui.howtos.code-cartoon.step_codeCartoonChooseMoreCharacters": "在你的動畫中加入更多角色",
    "gui.howtos.cartoon-network": "探險遊戲做動畫",
    "gui.howtos.cartoon-network.step_CNcharacter": "選一個你想用的角色",
    "gui.howtos.cartoon-network.step_CNsay": "讓角色說些話",
    "gui.howtos.cartoon-network.step_CNglide": "角色滑行",
    "gui.howtos.cartoon-network.step_CNpicksprite": "選一個要追逐的對象",
    "gui.howtos.cartoon-network.step_CNcollect": "要收集的東西",
    "gui.howtos.cartoon-network.step_CNvariable": "建立一個紀錄得分的變數",
    "gui.howtos.cartoon-network.step_CNscore": "紀錄分數",
    "gui.howtos.cartoon-network.step_CNbackdrop": "進一步：改變背景",
    "gui.howtos.videosens.name": "視訊偵測",
    "gui.howtos.videosens.step_addextension": "新增擴展",
    "gui.howtos.videosens.step_pet": "餵食貓咪",
    "gui.howtos.videosens.step_animate": "讓它動起來",
    "gui.howtos.videosens.step_pop": "彈出一個氣球",
    "gui.howtos.say-it-out-loud": "創作對話的動畫",
    "gui.howtos.say-it-out-loud.step_AddTXTextension": "加入文字轉語音積木",
    "gui.howtos.say-it-out-loud.step_TXTSpeech": "讓角色說些話",
    "gui.howtos.say-it-out-loud_TXTSetVoice": "選擇一種語音",
    "gui.howtos.say-it-out-loud.step_TXTMove": "四處移動",
    "gui.howtos.say-it-out-loud.step_TXTBackdrop": "新增一個背景",
    "gui.howtos.say-it-out-loud.step_TXTAddSprite": "加入另一個角色",
    "gui.howtos.say-it-out-loud.step_TXTSong": "演奏一首歌曲",
    "gui.howtos.say-it-out-loud.step_TXTColor": "更改顏色",
    "gui.howtos.say-it-out-loud.step_TXTSpin": "讓角色旋轉",
    "gui.howtos.say-it-out-loud.step_TXTGrow": "放大與縮小",
    "gui.howtos.talking": "說個故事",
    "gui.howtos.talking.step_talesAddExtension": "點擊以添加文字轉語音的積木",
    "gui.howtos.talking.step_talesChooseSprite": "範例角色",
    "gui.howtos.talking.step_talesSaySomething": "讓角色講點話",
    "gui.howtos.talking.step_talesChooseBackdrop": "範例背景",
    "gui.howtos.talking.step_talesSwitchBackdrop": "點擊角色以切換到下一個場景",
    "gui.howtos.talking.step_talesChooseAnotherSprite": "選另一個角色",
    "gui.howtos.talking.step_talesMoveAround": "四處移動",
    "gui.howtos.talking.step_talesChooseAnotherBackdrop": "選另一個背景",
    "gui.howtos.talking.step_talesAnimateTalking": "讓角色說些話",
    "gui.howtos.talking.step_talesChooseThirdBackdrop": "選另一個背景",
    "gui.howtos.talking.step_talesChooseSound": "選個跳舞用的音樂",
    "gui.howtos.talking.step_talesDanceMoves": "舞蹈動作",
    "gui.howtos.talking.step_talesAskAnswer": "從偵測類中找到詢問並回答的積木",
    "gui.howtos.add-sprite.name": "新增一個角色",
    "gui.howtos.add-sprite.step_addSprite": "新增一個角色",
    "gui.howtos.add-a-backdrop.name": "新增一個背景",
    "gui.howtos.add-a-backdrop.step_addBackdrop": "新增一個背景",
    "gui.howtos.change-size.name": "尺寸改變",
    "gui.howtos.change-size.step_changeSize": "尺寸改變",
    "gui.howtos.glide-around.name": "角色滑行",
    "gui.howtos.change-size.step_glideAroundBackAndForth": "角色滑行",
    "gui.howtos.change-size.step_glideAroundPoint": "滑行到一個地方",
    "gui.howtos.record-a-sound.name": "聲音錄製",
    "gui.howtos.change-size.step_recordASoundSoundsTab": "切換到「音效」頁籤",
    "gui.howtos.change-size.step_recordASoundClickRecord": "點擊「錄製」",
    "gui.howtos.change-size.step_recordASoundPressRecordButton": "按下錄製按鈕",
    "gui.howtos.change-size.step_recordASoundChooseSound": "選個音效",
    "gui.howtos.change-size.step_recordASoundPlayYourSound": "播放你的音效",
    "gui.howtos.spin-video.name": "角色旋轉",
    "gui.howtos.change-size.step_spinTurn": "轉向",
    "gui.howtos.change-size.step_spinPointInDirection": "設置方向",
    "gui.howtos.hide-and-show.name": "隱藏和顯示",
    "gui.howtos.change-size.step_hideAndShow": "隱藏和顯示",
    "gui.howtos.switch-costume.name": "角色動畫",
    "gui.howtos.change-size.step_switchCostumes": "角色動畫",
    "gui.howtos.move-around-with-arrow-keys.name": "用方向鍵控制",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysLeftRight": "左右移動",
    "gui.howtos.add-a-backdrop.step_moveArrowKeysUpDown": "上下移動",
    "gui.howtos.add-effects.name": "新增一些效果",
    "gui.howtos.videosens.step_addEffects": "新增一些效果",
    "gui.device.esp32.description": "功能強大且帶有 Wi-Fi 和 藍牙的控制板。",
    "gui.device.esp32.connectingMessage": "連接中",
    "gui.device.esp8266NodeMCU.description": "低功耗 Wi-Fi SOC 控制板。",
    "gui.device.esp8266NodeMCU.connectingMessage": "連接中",
    "gui.device.unselectDevice.name": "取消設備選擇",
    "gui.device.unselectDevice.description": "取消設備選擇，回到純實時編程模式。",
    "gui.device.arduinoUno.description": "很好的電子編程入門控制板。",
    "gui.device.arduinoUno.connectingMessage": "連接中",
    "gui.device.arduinoNano.description": "Arduino Nano 用於構建項目的經典小控制板。",
    "gui.device.arduinoNano.connectingMessage": "連接中",
    "gui.device.arduinoLeonardo.description": "經典的Arduino板，可以用作鼠標或鍵盤。",
    "gui.device.arduinoLeonardo.connectingMessage": "連接中",
    "gui.device.arduinoMega2560.description": "擁有54個數位腳位，16個類比輸入，和4個串口的8位控制板。",
    "gui.device.arduinoMega2560.connectingMessage": "連接中",
    "gui.device.microbit.description": "可以學習電子知識的迷你電腦。",
    "gui.device.microbit.connectingMessage": "連接中",
    "gui.device.microbitV2.description": "升級的處理器，板載揚聲器和麥克風，觸摸感應徽標。",
    "gui.device.microbitV2.connectingMessage": "連接中",
    "gui.device.makeymakey.description": "把任何東西變成按鍵。",
    "gui.device.makeyMakey.connectingMessage": "連接中",
    "gui.device.k210MaixDock.description": "基於K210 RISC-V芯片的控制板，只有基本功能，引出了所有IO管腳。",
    "gui.device.k210MaixDock.connectingMessage": "連接中",
    "gui.device.k210Maixduino.description": "內置ESP32的K210 RISC-V控制板。",
    "gui.device.k210Maixduino.connectingMessage": "連接中",
    "gui.device.raspberryPiPicoIconURL.description": "功能強大且靈活的控制板。",
    "gui.device.raspberryPiPicoIconURL.connectingMessage": "連接中",
    "gui.extension.music.name": "音樂",
    "gui.extension.music.description": "演奏樂器與節拍。",
    "gui.extension.pen.name": "畫筆",
    "gui.extension.pen.description": "使用你的角色來畫圖。",
    "gui.extension.videosensing.name": "視訊偵測",
    "gui.extension.videosensing.description": "使用攝影機偵測動作。",
    "gui.extension.text2speech.name": "文字轉語音",
    "gui.extension.text2speech.description": "讓你的專案能夠說話",
    "gui.extension.translate.name": "翻譯",
    "gui.extension.translate.description": "將文字訊息翻譯為各國語言。",
    "gui.extension.makeymakey.name": "Makey Makey",
    "gui.extension.makeymakey.description": "把任何東西變成鑰匙。",
    "gui.libraryTags.all": "全部",
    "gui.libraryTags.animals": "動物",
    "gui.libraryTags.dance": "舞蹈",
    "gui.libraryTags.effects": "效果",
    "gui.libraryTags.fantasy": "魔幻",
    "gui.libraryTags.fashion": "時尚",
    "gui.libraryTags.food": "食物",
    "gui.libraryTags.indoors": "室內",
    "gui.libraryTags.loops": "循環",
    "gui.libraryTags.music": "音樂",
    "gui.libraryTags.notes": "音階",
    "gui.libraryTags.outdoors": "戶外",
    "gui.libraryTags.patterns": "圖案",
    "gui.libraryTags.people": "人物",
    "gui.libraryTags.percussion": "節奏",
    "gui.libraryTags.space": "太空",
    "gui.libraryTags.sports": "運動",
    "gui.libraryTags.underwater": "水中",
    "gui.libraryTags.voice": "人聲",
    "gui.libraryTags.wacky": "滑稽",
    "gui.libraryTags.animation": "動畫",
    "gui.libraryTags.art": "藝術",
    "gui.libraryTags.games": "遊戲",
    "gui.libraryTags.stories": "故事",
    "gui.libraryTags.letters": "字母",
    "gui.opcodeLabels.direction": "方向",
    "gui.opcodeLabels.xposition": "x 座標",
    "gui.opcodeLabels.yposition": "y 座標",
    "gui.opcodeLabels.size": "尺寸",
    "gui.opcodeLabels.costumename": "造型名稱",
    "gui.opcodeLabels.costumenumber": "造型編號",
    "gui.opcodeLabels.backdropname": "背景名稱",
    "gui.opcodeLabels.backdropnumber": "背景編號",
    "gui.opcodeLabels.volume": "音量",
    "gui.opcodeLabels.tempo": "演奏速度",
    "gui.opcodeLabels.answer": "詢問的答案",
    "gui.opcodeLabels.loudness": "聲音響度",
    "gui.opcodeLabels.username": "用戶名稱",
    "gui.opcodeLabels.year": "年",
    "gui.opcodeLabels.month": "月",
    "gui.opcodeLabels.date": "日",
    "gui.opcodeLabels.dayofweek": "週",
    "gui.opcodeLabels.hour": "時",
    "gui.opcodeLabels.minute": "分",
    "gui.opcodeLabels.second": "秒",
    "gui.opcodeLabels.timer": "計時器",
    "gui.projectLoader.loadError": "所選的專案檔案載入失敗。",
    "gui.sharedMessages.backdrop": "backdrop{index}",
    "gui.sharedMessages.costume": "costume{index}",
    "gui.sharedMessages.sprite": "Sprite{index}",
    "gui.sharedMessages.pop": "pop",
    "gui.sharedMessages.replaceProjectWarning": "是否取代現有專案？",
    "gui.sharedMessages.clearCacheWarning": "確保你想要清除緩存並重啟？",
    "gui.sharedMessages.loadFromComputerTitle": "從你的電腦選擇",
    "gui.gui.defaultProjectTitle": "Scratch專案",
    "gui.desktopMenuBar.about": "關於",
    "gui.desktopMenuBar.license": "許可証",
    "gui.menuBar.privacyPolicy": "隱私政策",
    "gui.menuBar.dataSettings": "數據設置",
    "arduinoEsp32.InterrupModeMenu.changeEdge": "電位改變",
    "arduinoEsp32.InterrupModeMenu.fallingEdge": "下降沿",
    "arduinoEsp32.InterrupModeMenu.high": "高電位",
    "arduinoEsp32.InterrupModeMenu.low": "低電位",
    "arduinoEsp32.InterrupModeMenu.risingEdge": "上升沿",
    "arduinoEsp32.category.data": "數據",
    "arduinoEsp32.category.pins": "腳位",
    "arduinoEsp32.category.serial": "串口",
    "arduinoEsp32.data.dataConstrain": "約束 [DATA] 介於 ([ARG0], [ARG1])",
    "arduinoEsp32.data.dataConvert": "轉換 [DATA] 為 [TYPE]",
    "arduinoEsp32.data.dataConvertASCIICharacter": "轉換 [DATA] 為 ASCII 字符",
    "arduinoEsp32.data.dataConvertASCIINumber": "轉換 [DATA] 為 ASCII 編碼",
    "arduinoEsp32.data.dataMap": "映射 [DATA] 從 ([ARG0], [ARG1]) 到 ([ARG2], [ARG3])",
    "arduinoEsp32.dataTypeMenu.decimal": "小數",
    "arduinoEsp32.dataTypeMenu.integer": "整數",
    "arduinoEsp32.dataTypeMenu.string": "字串",
    "arduinoEsp32.eolMenu.noWarp": "不換行",
    "arduinoEsp32.eolMenu.warp": "換行",
    "arduinoEsp32.levelMenu.high": "高",
    "arduinoEsp32.levelMenu.low": "低",
    "arduinoEsp32.modeMenu.input": "輸入",
    "arduinoEsp32.modeMenu.inputPulldown": "輸入下拉",
    "arduinoEsp32.modeMenu.inputPullup": "輸入上拉",
    "arduinoEsp32.modeMenu.output": "輸出",
    "arduinoEsp32.pins.esp32AttachInterrupt": "設置中斷腳位 [PIN] 模式 [MODE] 執行",
    "arduinoEsp32.pins.esp32DetachInterrupt": "取消中斷腳位 [PIN]",
    "arduinoEsp32.pins.esp32ReadTouchPin": "讀取觸摸腳位 [PIN]",
    "arduinoEsp32.pins.esp32SetDACOutput": "設置 dac 腳位 [PIN] 輸出 [OUT]",
    "arduinoEsp32.pins.esp32SetPwmOutput": "設置 pwm 腳位 [PIN] 使用通道 [CH] 輸出 [OUT]",
    "arduinoEsp32.pins.readAnalogPin": "讀取類比腳位 [PIN]",
    "arduinoEsp32.pins.readDigitalPin": "讀取數位腳位 [PIN]",
    "arduinoEsp32.pins.setDigitalOutput": "設置腳位 [PIN] 輸出 [LEVEL]",
    "arduinoEsp32.pins.setPinMode": "設置腳位 [PIN] 模式 [MODE]",
    "arduinoEsp32.pins.setServoOutput": "設置舵機腳位 [PIN] 使用通道 [CH] 輸出 [OUT]",
    "arduinoEsp32.serial.multiSerialAvailable": "串口 [NO] 可讀取字節數",
    "arduinoEsp32.serial.multiSerialBegin": "串口 [NO] 啟動鮑率 [VALUE]",
    "arduinoEsp32.serial.multiSerialPrint": "串口 [NO] 列印 [VALUE] [EOL]",
    "arduinoEsp32.serial.multiSerialReadAByte": "串口 [NO] 讀取1個字節",
    "arduinoEsp8266.InterrupModeMenu.changeEdge": "電位改變",
    "arduinoEsp8266.InterrupModeMenu.fallingEdge": "下降沿",
    "arduinoEsp8266.InterrupModeMenu.risingEdge": "上升沿",
    "arduinoEsp8266.category.data": "數據",
    "arduinoEsp8266.category.pins": "腳位",
    "arduinoEsp8266.category.serial": "串口",
    "arduinoEsp8266.data.dataConstrain": "約束 [DATA] 介於 ([ARG0], [ARG1])",
    "arduinoEsp8266.data.dataConvert": "轉換 [DATA] 為 [TYPE]",
    "arduinoEsp8266.data.dataConvertASCIICharacter": "轉換 [DATA] 為 ASCII 字符",
    "arduinoEsp8266.data.dataConvertASCIINumber": "轉換 [DATA] 為 ASCII 編碼",
    "arduinoEsp8266.data.dataMap": "映射 [DATA] 從 ([ARG0], [ARG1]) 到 ([ARG2], [ARG3])",
    "arduinoEsp8266.dataTypeMenu.decimal": "小數",
    "arduinoEsp8266.dataTypeMenu.integer": "整數",
    "arduinoEsp8266.dataTypeMenu.string": "字串",
    "arduinoEsp8266.eolMenu.noWarp": "不換行",
    "arduinoEsp8266.eolMenu.warp": "換行",
    "arduinoEsp8266.levelMenu.high": "高",
    "arduinoEsp8266.levelMenu.low": "低",
    "arduinoEsp8266.modeMenu.input": "輸入",
    "arduinoEsp8266.modeMenu.inputPullup": "輸入上拉",
    "arduinoEsp8266.modeMenu.output": "輸出",
    "arduinoEsp8266.pins.detachInterrupt": "取消中斷腳位 [PIN]",
    "arduinoEsp8266.pins.esp8266AttachInterrupt": "設置中斷腳位 [PIN] 模式 [MODE] 執行",
    "arduinoEsp8266.pins.readAnalogPin": "讀取類比腳位 [PIN]",
    "arduinoEsp8266.pins.readDigitalPin": "讀取數字腳位 [PIN]",
    "arduinoEsp8266.pins.setDigitalOutput": "設置腳位 [PIN] 輸出 [LEVEL]",
    "arduinoEsp8266.pins.setPinMode": "設置腳位 [PIN] 模式 [MODE]",
    "arduinoEsp8266.pins.setPwmOutput": "設置 pwm 腳位 [PIN] 輸出 [OUT]",
    "arduinoEsp8266.pins.setServoOutput": "設置舵機腳位 [PIN] 輸出 [OUT]",
    "arduinoEsp8266.serial.serialAvailable": "串口可讀取字節數",
    "arduinoEsp8266.serial.serialBegin": "串口啟動鮑率 [VALUE]",
    "arduinoEsp8266.serial.serialPrint": "串口列印 [VALUE] [EOL]",
    "arduinoEsp8266.serial.serialReadAByte": "串口讀取1個字節",
    "arduinoK210.InterrupModeMenu.changeEdge": "電位改變",
    "arduinoK210.InterrupModeMenu.fallingEdge": "下降沿",
    "arduinoK210.InterrupModeMenu.high": "高電位",
    "arduinoK210.InterrupModeMenu.low": "低電位",
    "arduinoK210.InterrupModeMenu.risingEdge": "上升沿",
    "arduinoK210.category.data": "數據",
    "arduinoK210.category.pins": "腳位",
    "arduinoK210.category.serial": "串口",
    "arduinoK210.data.dataConstrain": "約束 [DATA] 介於 ([ARG0], [ARG1])",
    "arduinoK210.data.dataConvert": "轉換 [DATA] 為 [TYPE]",
    "arduinoK210.data.dataConvertASCIICharacter": "轉換 [DATA] 為 ASCII 字符",
    "arduinoK210.data.dataConvertASCIINumber": "轉換 [DATA] 為 ASCII 編碼",
    "arduinoK210.data.dataMap": "映射 [DATA] 從 ([ARG0], [ARG1]) 到 ([ARG2], [ARG3])",
    "arduinoK210.dataTypeMenu.decimal": "小數",
    "arduinoK210.dataTypeMenu.integer": "整數",
    "arduinoK210.dataTypeMenu.string": "字串",
    "arduinoK210.eolMenu.noWarp": "不換行",
    "arduinoK210.eolMenu.warp": "換行",
    "arduinoK210.levelMenu.high": "高",
    "arduinoK210.levelMenu.low": "低",
    "arduinoK210.modeMenu.input": "輸入",
    "arduinoK210.modeMenu.inputPulldown": "輸入下拉",
    "arduinoK210.modeMenu.inputPullup": "輸入上拉",
    "arduinoK210.modeMenu.output": "輸出",
    "arduinoK210.pins.attachInterrupt": "設置中斷腳位 [PIN] 模式 [MODE] 執行",
    "arduinoK210.pins.detachInterrupt": "取消中斷腳位 [PIN]",
    "arduinoK210.pins.readDigitalPin": "讀取數字腳位 [PIN]",
    "arduinoK210.pins.setDigitalOutput": "設置腳位 [PIN] 輸出 [LEVEL]",
    "arduinoK210.pins.setPinMode": "設置腳位 [PIN] 模式 [MODE]",
    "arduinoK210.pins.setPwmOutput": "設置 pwm 腳位 [PIN] 輸出 [OUT]",
    "arduinoK210.pins.setServoOutput": "設置舵機腳位 [PIN] 輸出 [OUT]",
    "arduinoK210.serial.multiSerialAvailable": "串口 [NO] 可讀取字節數",
    "arduinoK210.serial.multiSerialBegin": "串口 [NO] 啟動波特率 [BAUD] 引腳 RX [RX_PIN] TX [TX_PIN]",
    "arduinoK210.serial.multiSerialPrint": "串口 [NO] 列印 [VALUE] [EOL]",
    "arduinoK210.serial.multiSerialReadAByte": "串口 [NO] 讀取1個字節",
    "arduinoLeonardo.InterrupModeMenu.changeEdge": "電位改變",
    "arduinoLeonardo.InterrupModeMenu.fallingEdge": "下降沿",
    "arduinoLeonardo.InterrupModeMenu.low": "低",
    "arduinoLeonardo.InterrupModeMenu.risingEdge": "上升沿",
    "arduinoLeonardo.category.data": "數據",
    "arduinoLeonardo.category.pins": "腳位",
    "arduinoLeonardo.category.serial": "串口",
    "arduinoLeonardo.data.dataConstrain": "約束 [DATA] 介於 ([ARG0], [ARG1])",
    "arduinoLeonardo.data.dataConvert": "轉換 [DATA] 為 [TYPE]",
    "arduinoLeonardo.data.dataConvertASCIICharacter": "轉換 [DATA] 為 ASCII 字符",
    "arduinoLeonardo.data.dataConvertASCIINumber": "轉換 [DATA] 為 ASCII 編碼",
    "arduinoLeonardo.data.dataMap": "映射 [DATA] 從 ([ARG0], [ARG1]) 到 ([ARG2], [ARG3])",
    "arduinoLeonardo.dataTypeMenu.decimal": "小數",
    "arduinoLeonardo.dataTypeMenu.integer": "整數",
    "arduinoLeonardo.dataTypeMenu.string": "字串",
    "arduinoLeonardo.eolMenu.noWarp": "不換行",
    "arduinoLeonardo.eolMenu.warp": "換行",
    "arduinoLeonardo.levelMenu.high": "高",
    "arduinoLeonardo.levelMenu.low": "低",
    "arduinoLeonardo.modeMenu.input": "輸入",
    "arduinoLeonardo.modeMenu.inputPullup": "輸入上拉",
    "arduinoLeonardo.modeMenu.output": "輸出",
    "arduinoLeonardo.pins.attachInterrupt": "設置中斷腳位 [PIN] 模式 [MODE] 執行",
    "arduinoLeonardo.pins.detachInterrupt": "取消中斷腳位 [PIN]",
    "arduinoLeonardo.pins.readAnalogPin": "讀取類比腳位 [PIN]",
    "arduinoLeonardo.pins.readDigitalPin": "讀取數位腳位 [PIN]",
    "arduinoLeonardo.pins.setDigitalOutput": "設置腳位 [PIN] 輸出 [LEVEL]",
    "arduinoLeonardo.pins.setPinMode": "設置腳位 [PIN] 模式 [MODE]",
    "arduinoLeonardo.pins.setPwmOutput": "設置 pwm 腳位 [PIN] 輸出 [OUT]",
    "arduinoLeonardo.pins.setServoOutput": "設置舵機腳位 [PIN] 輸出 [OUT]",
    "arduinoLeonardo.serial.serialAvailable": "串口可讀取字節數",
    "arduinoLeonardo.serial.serialBegin": "串口啟動鮑率 [VALUE]",
    "arduinoLeonardo.serial.serialPrint": "串口列印 [VALUE] [EOL]",
    "arduinoLeonardo.serial.serialReadAByte": "串口讀取1個字節",
    "arduinoMega2560.InterrupModeMenu.changeEdge": "電位改變",
    "arduinoMega2560.InterrupModeMenu.fallingEdge": "下降沿",
    "arduinoMega2560.InterrupModeMenu.low": "低",
    "arduinoMega2560.InterrupModeMenu.risingEdge": "上升沿",
    "arduinoMega2560.category.data": "數據",
    "arduinoMega2560.category.pins": "腳位",
    "arduinoMega2560.category.serial": "串口",
    "arduinoMega2560.data.dataConstrain": "約束 [DATA] 介於 ([ARG0], [ARG1])",
    "arduinoMega2560.data.dataConvert": "轉換 [DATA] 為 [TYPE]",
    "arduinoMega2560.data.dataConvertASCIICharacter": "轉換 [DATA] 為 ASCII 字符",
    "arduinoMega2560.data.dataConvertASCIINumber": "轉換 [DATA] 為 ASCII 編碼",
    "arduinoMega2560.data.dataMap": "映射 [DATA] 從 ([ARG0], [ARG1]) 到 ([ARG2], [ARG3])",
    "arduinoMega2560.dataTypeMenu.decimal": "小數",
    "arduinoMega2560.dataTypeMenu.integer": "整數",
    "arduinoMega2560.dataTypeMenu.string": "字串",
    "arduinoMega2560.eolMenu.noWarp": "不換行",
    "arduinoMega2560.eolMenu.warp": "換行",
    "arduinoMega2560.levelMenu.high": "高",
    "arduinoMega2560.levelMenu.low": "低",
    "arduinoMega2560.modeMenu.input": "輸入",
    "arduinoMega2560.modeMenu.inputPullup": "輸入上拉",
    "arduinoMega2560.modeMenu.output": "輸出",
    "arduinoMega2560.pins.attachInterrupt": "設置中斷腳位 [PIN] 模式 [MODE] 執行",
    "arduinoMega2560.pins.detachInterrupt": "取消中斷腳位 [PIN]",
    "arduinoMega2560.pins.readAnalogPin": "讀取類比腳位 [PIN]",
    "arduinoMega2560.pins.readDigitalPin": "讀取數位腳位 [PIN]",
    "arduinoMega2560.pins.setDigitalOutput": "設置腳位 [PIN] 輸出 [LEVEL]",
    "arduinoMega2560.pins.setPinMode": "設置腳位 [PIN] 模式 [MODE]",
    "arduinoMega2560.pins.setPwmOutput": "設置 pwm 腳位 [PIN] 輸出 [OUT]",
    "arduinoMega2560.pins.setServoOutput": "設置舵機腳位 [PIN] 輸出 [OUT]",
    "arduinoMega2560.serial.multiSerialAvailable": "串口 [NO] 可讀取字節數",
    "arduinoMega2560.serial.multiSerialBegin": "串口 [NO] 啟動鮑率 [VALUE]",
    "arduinoMega2560.serial.multiSerialPrint": "串口 [NO] 列印 [VALUE] [EOL]",
    "arduinoMega2560.serial.multiSerialReadAByte": "串口 [NO] 讀取1個字節",
    "arduinoPeripheral.connection.connectFirmataTimeout": "嘗試連接 firmata 超時, 請先下載韌體",
    "arduinoRaspberryPiPico.InterrupModeMenu.changeEdge": "電位改變",
    "arduinoRaspberryPiPico.InterrupModeMenu.fallingEdge": "下降沿",
    "arduinoRaspberryPiPico.InterrupModeMenu.high": "高電位",
    "arduinoRaspberryPiPico.InterrupModeMenu.low": "低電位",
    "arduinoRaspberryPiPico.InterrupModeMenu.risingEdge": "上升沿",
    "arduinoRaspberryPiPico.category.data": "數據",
    "arduinoRaspberryPiPico.category.pins": "腳位",
    "arduinoRaspberryPiPico.category.serial": "串口",
    "arduinoRaspberryPiPico.data.dataConstrain": "約束 [DATA] 介於 ([ARG0], [ARG1])",
    "arduinoRaspberryPiPico.data.dataConvert": "轉換 [DATA] 為 [TYPE]",
    "arduinoRaspberryPiPico.data.dataConvertASCIICharacter": "轉換 [DATA] 為 ASCII 字符",
    "arduinoRaspberryPiPico.data.dataConvertASCIINumber": "轉換 [DATA] 為 ASCII 編碼",
    "arduinoRaspberryPiPico.data.dataMap": "映射 [DATA] 從 ([ARG0], [ARG1]) 到 ([ARG2], [ARG3])",
    "arduinoRaspberryPiPico.dataTypeMenu.decimal": "小數",
    "arduinoRaspberryPiPico.dataTypeMenu.integer": "整數",
    "arduinoRaspberryPiPico.dataTypeMenu.string": "字串",
    "arduinoRaspberryPiPico.eolMenu.noWarp": "不換行",
    "arduinoRaspberryPiPico.eolMenu.warp": "換行",
    "arduinoRaspberryPiPico.levelMenu.high": "高",
    "arduinoRaspberryPiPico.levelMenu.low": "低",
    "arduinoRaspberryPiPico.modeMenu.input": "輸入",
    "arduinoRaspberryPiPico.modeMenu.inputPulldown": "輸入下拉",
    "arduinoRaspberryPiPico.modeMenu.inputPullup": "輸入上拉",
    "arduinoRaspberryPiPico.modeMenu.output": "輸出",
    "arduinoRaspberryPiPico.pins.attachInterrupt": "設置中斷腳位 [PIN] 模式 [MODE] 執行",
    "arduinoRaspberryPiPico.pins.detachInterrupt": "取消中斷腳位 [PIN]",
    "arduinoRaspberryPiPico.pins.readAnalogPin": "讀取類比腳位 [PIN]",
    "arduinoRaspberryPiPico.pins.readDigitalPin": "讀取數字腳位 [PIN]",
    "arduinoRaspberryPiPico.pins.setDigitalOutput": "設置腳位 [PIN] 輸出 [LEVEL]",
    "arduinoRaspberryPiPico.pins.setPinMode": "設置腳位 [PIN] 模式 [MODE]",
    "arduinoRaspberryPiPico.pins.setPwmOutput": "設置 pwm 腳位 [PIN] 輸出 [OUT]",
    "arduinoRaspberryPiPico.pins.setServoOutput": "設置舵機腳位 [PIN] 輸出 [OUT]",
    "arduinoRaspberryPiPico.serial.multiSerialAvailable": "串口 [NO] 可讀取字節數",
    "arduinoRaspberryPiPico.serial.multiSerialPrint": "串口 [NO] 列印 [VALUE] [EOL]",
    "arduinoRaspberryPiPico.serial.multiSerialReadAByte": "串口 [NO] 讀取1個字節",
    "arduinoRaspberryPiPico.serial.raspberryPiPicoMultiSerialBegin": "串口 [NO] 啟動鮑率 [VALUE]",
    "arduinoUno.InterrupModeMenu.changeEdge": "電位改變",
    "arduinoUno.InterrupModeMenu.fallingEdge": "下降沿",
    "arduinoUno.InterrupModeMenu.low": "低",
    "arduinoUno.InterrupModeMenu.risingEdge": "上升沿",
    "arduinoUno.category.data": "數據",
    "arduinoUno.category.pins": "腳位",
    "arduinoUno.category.serial": "串口",
    "arduinoUno.data.dataConstrain": "約束 [DATA] 介於 ([ARG0], [ARG1])",
    "arduinoUno.data.dataConvert": "轉換 [DATA] 為 [TYPE]",
    "arduinoUno.data.dataConvertASCIICharacter": "轉換 [DATA] 為 ASCII 字符",
    "arduinoUno.data.dataConvertASCIINumber": "轉換 [DATA] 為 ASCII 編碼",
    "arduinoUno.data.dataMap": "映射 [DATA] 從 ([ARG0], [ARG1]) 到 ([ARG2], [ARG3])",
    "arduinoUno.dataTypeMenu.decimal": "小數",
    "arduinoUno.dataTypeMenu.integer": "整數",
    "arduinoUno.dataTypeMenu.string": "字串",
    "arduinoUno.eolMenu.noWarp": "不換行",
    "arduinoUno.eolMenu.warp": "換行",
    "arduinoUno.levelMenu.high": "高",
    "arduinoUno.levelMenu.low": "低",
    "arduinoUno.modeMenu.input": "輸入",
    "arduinoUno.modeMenu.inputPullup": "輸入上拉",
    "arduinoUno.modeMenu.output": "輸出",
    "arduinoUno.pins.attachInterrupt": "設置中斷腳位 [PIN] 模式 [MODE] 執行",
    "arduinoUno.pins.detachInterrupt": "取消中斷腳位 [PIN]",
    "arduinoUno.pins.readAnalogPin": "讀取類比腳位 [PIN]",
    "arduinoUno.pins.readDigitalPin": "讀取數位腳位 [PIN]",
    "arduinoUno.pins.setDigitalOutput": "設置腳位 [PIN] 輸出 [LEVEL]",
    "arduinoUno.pins.setPinMode": "設置腳位 [PIN] 模式 [MODE]",
    "arduinoUno.pins.setPwmOutput": "設置 pwm 腳位 [PIN] 輸出 [OUT]",
    "arduinoUno.pins.setServoOutput": "設置舵機腳位 [PIN] 輸出 [OUT]",
    "arduinoUno.serial.serialAvailable": "串口可讀取字節數",
    "arduinoUno.serial.serialBegin": "串口啟動鮑率 [VALUE]",
    "arduinoUno.serial.serialPrint": "串口列印 [VALUE] [EOL]",
    "arduinoUno.serial.serialReadAByte": "串口讀取1個字節",
    "boost.color.any": "任何顏色",
    "boost.color.black": "黑色",
    "boost.color.blue": "藍色",
    "boost.color.green": "綠色",
    "boost.color.red": "紅色",
    "boost.color.white": "白色",
    "boost.color.yellow": "黃色",
    "boost.getMotorPosition": "[MOTOR_REPORTER_ID] 轉向角度",
    "boost.getTiltAngle": "傾斜角度 [TILT_DIRECTION]",
    "boost.motorDirection.backward": "逆時針",
    "boost.motorDirection.forward": "順時針",
    "boost.motorDirection.reverse": "反轉",
    "boost.motorOff": "[MOTOR_ID] 停止",
    "boost.motorOn": "[MOTOR_ID] 啟動",
    "boost.motorOnFor": "[MOTOR_ID] 啟動 持續 [DURATION] 秒",
    "boost.motorOnForRotation": "[MOTOR_ID] 啟動 持續 [ROTATION] 圈",
    "boost.seeingColor": "看到顏色 [COLOR]？",
    "boost.setLightHue": "LED 顏色設為 [HUE]",
    "boost.setMotorDirection": "[MOTOR_ID] 方向設為 [MOTOR_DIRECTION]",
    "boost.setMotorPower": "[MOTOR_ID] 動力設為 [POWER] %",
    "boost.tiltDirection.any": "任何",
    "boost.tiltDirection.down": "向下",
    "boost.tiltDirection.left": "向左",
    "boost.tiltDirection.right": "向右",
    "boost.tiltDirection.up": "向上",
    "boost.whenColor": "當顏色 [COLOR]  被看到",
    "boost.whenTilted": "當傾斜 [TILT_DIRECTION_ANY]",
    "ev3.beepNote": "演奏音階 [NOTE] 持續 [TIME] 秒",
    "ev3.buttonPressed": "按鈕 [PORT] 被按下？",
    "ev3.getBrightness": "亮度",
    "ev3.getDistance": "距離",
    "ev3.getMotorPosition": "馬達 埠[PORT] 轉向角度",
    "ev3.motorSetPower": "馬達 埠[PORT] 動力設為 [POWER] %",
    "ev3.motorTurnClockwise": "馬達 埠[PORT] 順時針旋轉 [TIME] 秒",
    "ev3.motorTurnCounterClockwise": "馬達 埠[PORT] 逆時針旋轉 [TIME] 秒",
    "ev3.whenBrightnessLessThan": "當亮度 < [DISTANCE]",
    "ev3.whenButtonPressed": "當按鈕 [PORT] 被按下",
    "ev3.whenDistanceLessThan": "當距離 < [DISTANCE]",
    "gdxfor.getAcceleration": "加速度 [DIRECTION]",
    "gdxfor.getForce": "力量",
    "gdxfor.getSpin": "旋轉速度 [DIRECTION]",
    "gdxfor.getTilt": "傾斜角度 [TILT]",
    "gdxfor.isFreeFalling": "自由掉落？",
    "gdxfor.isTilted": "傾斜 [TILT]？",
    "gdxfor.pulled": "向外拉",
    "gdxfor.pushed": "向內推",
    "gdxfor.shaken": "晃動",
    "gdxfor.startedFalling": "開始掉落",
    "gdxfor.tiltDirectionMenu.any": "任何",
    "gdxfor.tiltDirectionMenu.back": "向下",
    "gdxfor.tiltDirectionMenu.front": "向上",
    "gdxfor.tiltDirectionMenu.left": "向左",
    "gdxfor.tiltDirectionMenu.right": "向右",
    "gdxfor.turnedFaceDown": "背面朝上",
    "gdxfor.turnedFaceUp": "正面朝上",
    "gdxfor.whenForcePushedOrPulled": "當重力感測器[PUSH_PULL]",
    "gdxfor.whenGesture": "當 [GESTURE]",
    "gdxfor.whenTilted": "當傾斜 [TILT]",
    "makeymakey.downArrow": "向下",
    "makeymakey.downArrowShort": "向下",
    "makeymakey.leftArrow": "向左",
    "makeymakey.leftArrowShort": "向左",
    "makeymakey.rightArrow": "向右",
    "makeymakey.rightArrowShort": "向右",
    "makeymakey.spaceKey": "空白",
    "makeymakey.upArrow": "向上",
    "makeymakey.upArrowShort": "向上",
    "makeymakey.whenKeyPressed": "當 [KEY] 按鈕被按下",
    "makeymakey.whenKeysPressedInOrder": "當 [SEQUENCE] 按鈕被依序按下",
    "microPythonEsp32.InterrupModeMenu.changeEdge": "電位改變",
    "microPythonEsp32.InterrupModeMenu.fallingEdge": "下降沿",
    "microPythonEsp32.InterrupModeMenu.high": "高電位",
    "microPythonEsp32.InterrupModeMenu.low": "低電位",
    "microPythonEsp32.InterrupModeMenu.risingEdge": "上升沿",
    "microPythonEsp32.category.console": "控制台",
    "microPythonEsp32.category.pins": "腳位",
    "microPythonEsp32.console.consoleInput": "提示 [TEXT] 並讀取輸入",
    "microPythonEsp32.console.consolePrint": "列印 [TEXT] [EOL]",
    "microPythonEsp32.eolMenu.noWarp": "不換行",
    "microPythonEsp32.eolMenu.warp": "換行",
    "microPythonEsp32.levelMenu.high": "高",
    "microPythonEsp32.levelMenu.low": "低",
    "microPythonEsp32.modeMenu.input": "輸入",
    "microPythonEsp32.modeMenu.inputPulldown": "輸入下拉",
    "microPythonEsp32.modeMenu.inputPullup": "輸入上拉",
    "microPythonEsp32.modeMenu.output": "輸出",
    "microPythonEsp32.pins.esp32AttachInterrupt": "設置中斷腳位 [PIN] 模式 [MODE] 執行",
    "microPythonEsp32.pins.esp32ReadAnalogPin": "讀取類比腳位 [PIN]",
    "microPythonEsp32.pins.esp32ReadDigitalPin": "讀取數字腳位 [PIN]",
    "microPythonEsp32.pins.esp32ReadTouchPin": "讀取觸摸腳位 [PIN]",
    "microPythonEsp32.pins.esp32SetDACOutput": "設置 dac 腳位 [PIN] 輸出 [OUT]",
    "microPythonEsp32.pins.esp32SetDigitalOutput": "設置腳位 [PIN] 輸出 [LEVEL]",
    "microPythonEsp32.pins.esp32SetPinMode": "設置腳位 [PIN] 模式 [MODE]",
    "microPythonEsp32.pins.esp32SetPwmOutput": "設置 pwm 腳位 [PIN] 輸出 [OUT]",
    "microPythonEsp32.pins.setServoOutput": "設置舵機腳位 [PIN] 輸出 [OUT]",
    "microPythonEsp8266.category.console": "控制台",
    "microPythonEsp8266.category.pins": "腳位",
    "microPythonEsp8266.console.consoleInput": "提示 [TEXT] 並讀取輸入",
    "microPythonEsp8266.console.consolePrint": "列印 [TEXT] [EOL]",
    "microPythonEsp8266.eolMenu.noWarp": "不換行",
    "microPythonEsp8266.eolMenu.warp": "換行",
    "microPythonEsp8266.levelMenu.high": "高",
    "microPythonEsp8266.levelMenu.low": "低",
    "microPythonEsp8266.modeMenu.input": "輸入",
    "microPythonEsp8266.modeMenu.inputPullup": "輸入上拉",
    "microPythonEsp8266.modeMenu.output": "輸出",
    "microPythonEsp8266.pins.esp8266AttachInterrupt": "設置中斷腳位 [PIN] 模式 [MODE] 執行",
    "microPythonEsp8266.pins.readAnalogPin": "讀取類比腳位 [PIN]",
    "microPythonEsp8266.pins.readDigitalPin": "讀取數字腳位 [PIN]",
    "microPythonEsp8266.pins.setDigitalOutput": "設置腳位 [PIN] 輸出 [LEVEL]",
    "microPythonEsp8266.pins.setPinMode": "設置腳位 [PIN] 模式 [MODE]",
    "microPythonEsp8266.pins.setPwmOutput": "設置 pwm 腳位 [PIN] 輸出 [OUT]",
    "microPythonEsp8266.pins.setServoOutput": "設置舵機腳位 [PIN] 輸出 [OUT]",
    "microPythonK210.InterrupModeMenu.changeEdge": "電位改變",
    "microPythonK210.InterrupModeMenu.fallingEdge": "下降沿",
    "microPythonK210.InterrupModeMenu.risingEdge": "上升沿",
    "microPythonK210.category.console": "控制台",
    "microPythonK210.category.pins": "腳位",
    "microPythonK210.category.serial": "串口",
    "microPythonK210.console.consoleInput": "提示 [TEXT] 並讀取輸入",
    "microPythonK210.console.consolePrint": "列印 [TEXT] [EOL]",
    "microPythonK210.eolMenu.noWarp": "不換行",
    "microPythonK210.eolMenu.warp": "換行",
    "microPythonK210.levelMenu.high": "高",
    "microPythonK210.levelMenu.low": "低",
    "microPythonK210.modeMenu.input": "輸入",
    "microPythonK210.modeMenu.inputPulldown": "輸入下拉",
    "microPythonK210.modeMenu.inputPullup": "輸入上拉",
    "microPythonK210.modeMenu.output": "輸出",
    "microPythonK210.pins.k210AttachInterrupt": "設置中斷腳位 [PIN] 模式 [MODE] 執行",
    "microPythonK210.pins.k210SetPinMode": "設置腳位 [PIN] 模式 [MODE]",
    "microPythonK210.pins.k210SetPwmOutput": "設置 pwm 腳位 [PIN] 使用通道 [CH] 輸出 [OUT]",
    "microPythonK210.pins.k210SetServoOutput": "設置舵機腳位 [PIN] 使用通道 [CH] 輸出 [OUT]",
    "microPythonK210.pins.readDigitalPin": "讀取數字腳位 [PIN]",
    "microPythonK210.pins.setDigitalOutput": "設置腳位 [PIN] 輸出 [LEVEL]",
    "microPythonK210.serial.k210SerialBegin": "串口 [NO] 啟動波特率 [BAUD] 引腳 RX [RX_PIN] TX [TX_PIN]",
    "microPythonK210.serial.serialPrint": "串口 [NO] 列印 [VALUE] [EOL]",
    "microPythonK210.serial.serialReadALine": "串口 [NO] 讀取1行",
    "microPythonRaspberryPiPico.InterrupModeMenu.changeEdge": "電位改變",
    "microPythonRaspberryPiPico.InterrupModeMenu.fallingEdge": "下降沿",
    "microPythonRaspberryPiPico.InterrupModeMenu.risingEdge": "上升沿",
    "microPythonRaspberryPiPico.category.console": "控制台",
    "microPythonRaspberryPiPico.category.pins": "腳位",
    "microPythonRaspberryPiPico.category.serial": "串口",
    "microPythonRaspberryPiPico.console.consoleInput": "提示 [TEXT] 並讀取輸入",
    "microPythonRaspberryPiPico.console.consolePrint": "列印 [TEXT] [EOL]",
    "microPythonRaspberryPiPico.eolMenu.noWarp": "不換行",
    "microPythonRaspberryPiPico.eolMenu.warp": "換行",
    "microPythonRaspberryPiPico.levelMenu.high": "高",
    "microPythonRaspberryPiPico.levelMenu.low": "低",
    "microPythonRaspberryPiPico.modeMenu.input": "輸入",
    "microPythonRaspberryPiPico.modeMenu.inputPulldown": "輸入下拉",
    "microPythonRaspberryPiPico.modeMenu.inputPullup": "輸入上拉",
    "microPythonRaspberryPiPico.modeMenu.output": "輸出",
    "microPythonRaspberryPiPico.pins.attachInterrupt": "設置中斷腳位 [PIN] 模式 [MODE] 執行",
    "microPythonRaspberryPiPico.pins.readAnalogPin": "讀取類比腳位 [PIN]",
    "microPythonRaspberryPiPico.pins.readDigitalPin": "讀取數字腳位 [PIN]",
    "microPythonRaspberryPiPico.pins.setDigitalOutput": "設置腳位 [PIN] 輸出 [LEVEL]",
    "microPythonRaspberryPiPico.pins.setPinMode": "設置腳位 [PIN] 模式 [MODE]",
    "microPythonRaspberryPiPico.pins.setPwmOutputU16": "設置 pwm 腳位 [PIN] 輸出 [OUT]",
    "microPythonRaspberryPiPico.pins.setServoOutputU16": "設置舵機腳位 [PIN] 輸出 [OUT]",
    "microPythonRaspberryPiPico.serial.multiSerialPrint": "串口 [NO] 列印 [VALUE] [EOL]",
    "microPythonRaspberryPiPico.serial.multiSerialReadALine": "串口 [NO] 讀取1行",
    "microPythonRaspberryPiPico.serial.raspberryPiPicoSerialBegin": "串口 [NO] 啟動波特率 [BAUD] 引腳 RX [RX_PIN] TX [TX_PIN]",
    "microbit.axisMenu.xAxis": "x軸",
    "microbit.axisMenu.yAxis": "y軸",
    "microbit.axisMenu.zAxis": "z軸",
    "microbit.buttonsMenu.any": "任何",
    "microbit.category.console": "控制台",
    "microbit.category.display": "顯示",
    "microbit.category.pins": "腳位",
    "microbit.category.sensor": "感測器",
    "microbit.category.wireless": "無線",
    "microbit.clearDisplay": "清空畫面",
    "microbit.console.consolePrint": "列印 [TEXT]",
    "microbit.defaultTextToDisplay": "Hello!",
    "microbit.display.clearDisplay": "清空螢幕",
    "microbit.display.lightPixelAt": " [STATE] 坐標 x: [X] , y: [Y] 燈",
    "microbit.display.show": "顯示 [TEXT]",
    "microbit.display.showImage": "顯示圖案 [VALUE]",
    "microbit.display.showImageUntil": "顯示圖案 [VALUE] 持續 [TIME] 秒",
    "microbit.display.showOnPiexlbrightness": "設置坐標 x: [X], y: [Y] 的亮度為 [BRT]",
    "microbit.display.showUntilScrollDone": "顯示 [TEXT] 直到滾動結束",
    "microbit.displaySymbol": "顯示圖示 [MATRIX]",
    "microbit.displayText": "顯示文字 [TEXT]",
    "microbit.gestruesMenu.faceDown": "正面朝下",
    "microbit.gestruesMenu.faceUp": "正面朝上",
    "microbit.gestruesMenu.freefall": "自由落體",
    "microbit.gestruesMenu.shaken": "晃動",
    "microbit.gestruesMenu.tiltedDownward": "向下傾斜",
    "microbit.gestruesMenu.tiltedLeftward": "向左傾斜",
    "microbit.gestruesMenu.tiltedRightward": "向右傾斜",
    "microbit.gestruesMenu.tiltedUpward": "向上傾斜",
    "microbit.gesturesMenu.jumped": "跳動",
    "microbit.gesturesMenu.moved": "移動",
    "microbit.gesturesMenu.shaken": "晃動",
    "microbit.isButtonPressed": "按鈕 [BTN] 被按下？",
    "microbit.isTilted": "傾斜 [DIRECTION]？",
    "microbit.ledState.off": "熄滅",
    "microbit.ledState.on": "點亮",
    "microbit.levelMenu.high": "高",
    "microbit.levelMenu.low": "低",
    "microbit.pinStateMenu.off": "關閉",
    "microbit.pinStateMenu.on": "開啟",
    "microbit.pins.pinIsTouched": "腳位 [PIN] 被觸摸",
    "microbit.pins.readAnalogPin": "讀取類比腳位 [PIN]",
    "microbit.pins.readDigitalPin": "讀取數字腳位 [PIN]",
    "microbit.pins.setDigitalOutput": "設置腳位 [PIN] 輸出 [LEVEL]",
    "microbit.pins.setPwmOutput": "設置 pwm 腳位 [PIN] 輸出 [OUT]",
    "microbit.sensor.axisAcceleration": "[AXIS] 軸加速度",
    "microbit.sensor.buttonIsPressed": "按鍵 [KEY] 被按下?",
    "microbit.sensor.calibrateCompass": "校準指南針",
    "microbit.sensor.compassAngle": "指南針角度",
    "microbit.sensor.compassMagneticDensity": "指南針磁場強度",
    "microbit.sensor.gestureIsX": "姿態是 [STA]?",
    "microbit.sensor.lightLevel": "亮度",
    "microbit.sensor.runningTime": "運行時間",
    "microbit.sensor.temperature": "溫度",
    "microbit.tiltAngle": "傾斜角度 [DIRECTION]",
    "microbit.tiltDirectionMenu.any": "任何",
    "microbit.tiltDirectionMenu.back": "向下",
    "microbit.tiltDirectionMenu.front": "向上",
    "microbit.tiltDirectionMenu.left": "向左",
    "microbit.tiltDirectionMenu.right": "向右",
    "microbit.whenButtonPressed": "當按鈕 [BTN] 被按下",
    "microbit.whenGesture": "當 [GESTURE]",
    "microbit.whenPinConnected": "當腳位 [PIN] 接地",
    "microbit.whenTilted": "當傾斜 [DIRECTION]",
    "microbit.wireless.closeWirelessCommunication": "關閉無線通訊",
    "microbit.wireless.openWirelessCommunication": "打開無線通訊",
    "microbit.wireless.receiveWirelessMessage": "收到無線消息",
    "microbit.wireless.resetWirelessCommunication": "復位無線通訊",
    "microbit.wireless.sendWirelessMessage": "發送無線消息 [TEXT]",
    "microbit.wireless.setWirelessCommunicationChannel": "設置無線通訊頻道為 [CH]",
    "music.categoryName": "音樂",
    "music.changeTempo": "演奏速度改變 [TEMPO]",
    "music.drumBass": "(2) 低音鼓",
    "music.drumBongo": "(13) 邦加鼓",
    "music.drumCabasa": "(15) 鐵沙鈴",
    "music.drumClaves": "(9) 梆子",
    "music.drumClosedHiHat": "(6) 合起的腳踏鈸",
    "music.drumConga": "(14) 康加鼓",
    "music.drumCowbell": "(11) 牛鈴",
    "music.drumCrashCymbal": "(4) 碎音鈸",
    "music.drumCuica": "(18) 庫加鼓",
    "music.drumGuiro": "(16) 刮瓜",
    "music.drumHandClap": "(8) 拍掌",
    "music.drumOpenHiHat": "(5) 打開的腳踏鈸",
    "music.drumSideStick": "(3) 鼓邊敲擊",
    "music.drumSnare": "(1) 軍鼓",
    "music.drumTambourine": "(7) 鈴鼓",
    "music.drumTriangle": "(12) 三角鐵",
    "music.drumVibraslap": "(17) 振盪器",
    "music.drumWoodBlock": "(10) 木魚",
    "music.getTempo": "演奏速度",
    "music.instrumentBass": "(6) 貝斯",
    "music.instrumentBassoon": "(14) 低音管",
    "music.instrumentCello": "(8) 大提琴",
    "music.instrumentChoir": "(15) 人聲合唱",
    "music.instrumentClarinet": "(10) 單簧管",
    "music.instrumentElectricGuitar": "(5) 電吉他",
    "music.instrumentElectricPiano": "(2) 電子琴",
    "music.instrumentFlute": "(12) 長笛",
    "music.instrumentGuitar": "(4) 吉他",
    "music.instrumentMarimba": "(19) 馬林巴",
    "music.instrumentMusicBox": "(17) 音樂盒",
    "music.instrumentOrgan": "(3) 風琴",
    "music.instrumentPiano": "(1) 鋼琴",
    "music.instrumentPizzicato": "(7) 撥奏",
    "music.instrumentSaxophone": "(11) 薩克斯風",
    "music.instrumentSteelDrum": "(18) 鋼鼓",
    "music.instrumentSynthLead": "(20) 合成主音",
    "music.instrumentSynthPad": "(21) 合成柔音",
    "music.instrumentTrombone": "(9) 長號",
    "music.instrumentVibraphone": "(16) 顫音琴",
    "music.instrumentWoodenFlute": "(13) 木笛",
    "music.midiPlayDrumForBeats": "演奏節拍 [DRUM] [BEATS] 拍",
    "music.midiSetInstrument": "演奏樂器設為 [INSTRUMENT]",
    "music.playDrumForBeats": "演奏節拍 [DRUM] [BEATS] 拍",
    "music.playNoteForBeats": "演奏音階 [NOTE] [BEATS] 拍",
    "music.restForBeats": "演奏休息 [BEATS] 拍",
    "music.setInstrument": "演奏樂器設為 [INSTRUMENT]",
    "music.setTempo": "演奏速度設為 [TEMPO]",
    "pen.categoryName": "畫筆",
    "pen.changeColorParam": "筆跡 [COLOR_PARAM] 改變 [VALUE]",
    "pen.changeHue": "筆跡顏色改變 [HUE]",
    "pen.changeShade": "筆跡亮度改變 [SHADE]",
    "pen.changeSize": "筆跡寬度改變 [SIZE]",
    "pen.clear": "筆跡全部清除",
    "pen.colorMenu.brightness": "亮度",
    "pen.colorMenu.color": "顏色",
    "pen.colorMenu.saturation": "彩度",
    "pen.colorMenu.transparency": "透明度",
    "pen.penDown": "下筆",
    "pen.penUp": "停筆",
    "pen.setColor": "筆跡顏色設為 [COLOR]",
    "pen.setColorParam": "筆跡 [COLOR_PARAM] 設為 [VALUE]",
    "pen.setHue": "筆跡顏色設為 [HUE]",
    "pen.setShade": "筆跡亮度設為 [SHADE]",
    "pen.setSize": "筆跡寬度設為 [SIZE]",
    "pen.stamp": "蓋章",
    "speech.defaultWhenIHearValue": "開始吧",
    "speech.extensionName": "語音識別",
    "speech.listenAndWait": "收聽並等待",
    "speech.speechReporter": "語音文本",
    "speech.whenIHear": "當收到語音 [PHRASE]",
    "text2speech.alto": "alto",
    "text2speech.categoryName": "文字轉語音",
    "text2speech.defaultTextToSpeak": "hello",
    "text2speech.giant": "低沉",
    "text2speech.kitten": "小貓",
    "text2speech.setLanguageBlock": "語言設為 [LANGUAGE]",
    "text2speech.setVoiceBlock": "語音設為 [VOICE]",
    "text2speech.speakAndWaitBlock": "唸出 [WORDS]",
    "text2speech.squeak": "尖細",
    "text2speech.tenor": "tenor",
    "translate.categoryName": "翻譯",
    "translate.defaultTextToTranslate": "hello",
    "translate.translateBlock": "文字 [WORDS] 翻譯成 [LANGUAGE]",
    "translate.viewerLanguage": "瀏覽者的語言",
    "videoSensing.categoryName": "視訊偵測",
    "videoSensing.direction": "方向",
    "videoSensing.motion": "動作",
    "videoSensing.off": "關閉",
    "videoSensing.on": "開啟",
    "videoSensing.onFlipped": "翻轉",
    "videoSensing.setVideoTransparency": "視訊透明度設為 [TRANSPARENCY]",
    "videoSensing.sprite": "角色",
    "videoSensing.stage": "舞台",
    "videoSensing.videoOn": "[SUBJECT] 的視訊 [ATTRIBUTE]",
    "videoSensing.videoToggle": "視訊設為 [VIDEO_STATE]",
    "videoSensing.whenMotionGreaterThan": "當視訊動作 > [REFERENCE]",
    "wedo2.getDistance": "距離",
    "wedo2.getTiltAngle": "傾斜角度 [TILT_DIRECTION]",
    "wedo2.isTilted": "傾斜 [TILT_DIRECTION_ANY]？",
    "wedo2.motorDirection.backward": "逆時針",
    "wedo2.motorDirection.forward": "順時針",
    "wedo2.motorDirection.reverse": "反轉",
    "wedo2.motorId.a": "馬達 A",
    "wedo2.motorId.all": "馬達 A 與 B",
    "wedo2.motorId.b": "馬達 B",
    "wedo2.motorId.default": "馬達",
    "wedo2.motorOff": "[MOTOR_ID] 停止",
    "wedo2.motorOn": "[MOTOR_ID] 啟動",
    "wedo2.motorOnFor": "[MOTOR_ID] 啟動 持續 [DURATION] 秒",
    "wedo2.playNoteFor": "演奏音階 [NOTE] 持續 [DURATION] 秒",
    "wedo2.setLightHue": "LED 顏色設為 [HUE]",
    "wedo2.setMotorDirection": "[MOTOR_ID] 方向設為 [MOTOR_DIRECTION]",
    "wedo2.startMotorPower": "[MOTOR_ID] 動力設為 [POWER]",
    "wedo2.tiltDirection.any": "任何",
    "wedo2.tiltDirection.down": "向下",
    "wedo2.tiltDirection.left": "向左",
    "wedo2.tiltDirection.right": "向右",
    "wedo2.tiltDirection.up": "向上",
    "wedo2.whenDistance": "當距離 [OP] [REFERENCE]",
    "wedo2.whenTilted": "當傾斜 [TILT_DIRECTION_ANY]",
    "yiFlash.categoryName": "燈光",
    "yiFlash.setLightMode": "將燈光模式設為[MODE]",
    "yiFlash.setLightMode.1": "常亮",
    "yiFlash.setLightMode.2": "閃爍",
    "yiFlash.setLightMode.3": "呼吸",
    "yiFlash.setLightSwitch": "將燈光開關設為[SWITCH]",
    "yiFlash.setLightSwitch.1": "開",
    "yiFlash.setLightSwitch.0": "關",
    "yiFlash.setBrightness": "將亮度設為[BRIGHTNESS]",
    "yiFlash.setFlashFrequency": "將閃爍頻率設為[FREQUENCY]",
    "yiFlash.setFlashFrequency.0": "慢",
    "yiFlash.setFlashFrequency.1": "快",
    "yiFlash.setFlashMode": "將閃光燈模式設為[MODE]",
    "yiFlash.setFlashMode.0": "關",
    "yiFlash.setFlashMode.1": "開",
    "yiFlash.ble": "藍芽",
    "yiFlash.ble.connect": "連線裝置藍芽[DEVICE_NAME]",
    "yiFlash.ble.disconnect": "斷開藍芽",
    "yi.ble": "藍芽",
    "yi.ble.connect": "連線裝置藍芽[DEVICE_NAME]",
    "yi.ble.disconnect": "斷開連線",
    "yiIrmotion.categoryName": "人體感應",
    "yiIrmotion.getStatus": "檢測感應狀態",
    "yiLight.categoryName": "光敏",
    "yiLight.getBrightness": "獲取光照強度",
    "yiPlug.categoryName": "智慧插座",
    "yiPlug.setPluginSwitch": "[SWITCH]插座開關",
    "yiPlug.setPluginSwitch.0": "關閉",
    "yiPlug.setPluginSwitch.1": "開啟",
    "yiThermeter.categoryName": "溫溼度",
    "yiThermeter.getTemperature": "獲取溫度",
    "yiThermeter.getHumidity": "獲取溼度",
    "yiNightLamp.categoryName": "小夜燈",
    "yiNightLamp.setLightSwitch": "將燈光開關設為[SWITCH]",
    "yiNightLamp.setBrightness": "將亮度設為[BRIGHTNESS]",
    "yiNightLamp.setFlashMode": "將閃光燈模式設為[MODE]",
    "yiNightLamp.getBrightness": "獲取光照強度",
    "yiNightLamp.setLightSwitch.1": "開",
    "yiNightLamp.setLightSwitch.0": "關",
    "yiNightLamp.setFlashMode.1": "拍照閃光",
    "yiNightLamp.setFlashMode.0": "關",
    "yiThermeterA.categoryName": "溫度",
    "yiThermeterA.getTemperature": "獲取溫度",
    "yiAudio.categoryName": "蜂鳴器",
    "yiAudio.setPromptTone": "設定提示音為 [PROMPT_TONE]",
    "yiAudio.setPromptTone.1": "聲音1",
    "yiAudio.setPromptTone.2": "聲音2",
    "yiAudio.setPromptTone.3": "聲音3",
    "yiAudio.setPromptTone.4": "聲音4",
    "yiAudio.setPromptTone.5": "聲音5",
    "yiImu06.categoryName": "六軸",
    "yiImu06.getRollAngle": "獲取橫滾角",
    "yiImu06.getPitchAngle": "獲取俯仰角",
    "yiImu06.getYawAngle": "獲取偏航角",
    "yiImu06x.categoryName": "九軸",
    "yiImu06x.getRollAngle": "獲取橫滾角",
    "yiImu06x.getPitchAngle": "獲取俯仰角",
    "yiImu06x.getYawAngle": "獲取偏航角",
    "paint.colorPicker.swap": "交換",
    "paint.paintEditor.hue": "顏色",
    "paint.paintEditor.saturation": "彩度",
    "paint.paintEditor.brightness": "亮度",
    "paint.paintEditor.costume": "造型",
    "paint.paintEditor.group": "建立群組",
    "paint.paintEditor.ungroup": "解散群組",
    "paint.paintEditor.undo": "復原",
    "paint.paintEditor.redo": "重做",
    "paint.paintEditor.forward": "上移一層",
    "paint.paintEditor.backward": "下移一層",
    "paint.paintEditor.front": "移到最上層",
    "paint.paintEditor.back": "移到最下層",
    "paint.paintEditor.more": "更多",
    "paint.modeTools.brushSize": "尺寸",
    "paint.modeTools.eraserSize": "擦子寬度",
    "paint.modeTools.copy": "複製",
    "paint.modeTools.paste": "貼上",
    "paint.modeTools.delete": "刪除",
    "paint.modeTools.curved": "圓弧",
    "paint.modeTools.pointed": "尖角",
    "paint.modeTools.thickness": "線條寬度",
    "paint.modeTools.flipHorizontal": "橫向翻轉",
    "paint.modeTools.flipVertical": "直向翻轉",
    "paint.modeTools.filled": "填滿",
    "paint.modeTools.outlined": "外框",
    "paint.paintEditor.bitmap": "轉換成點陣圖",
    "paint.paintEditor.vector": "轉換成向量圖",
    "paint.paintEditor.fill": "填滿",
    "paint.paintEditor.stroke": "外框",
    "paint.brushMode.brush": "筆刷",
    "paint.eraserMode.eraser": "擦子",
    "paint.fillMode.fill": "填滿",
    "paint.lineMode.line": "線條",
    "paint.ovalMode.oval": "圓形",
    "paint.rectMode.rect": "方形",
    "paint.reshapeMode.reshape": "重新塑形",
    "paint.roundedRectMode.roundedRect": "圓角方形",
    "paint.selectMode.select": "選取",
    "paint.textMode.text": "文字"
  }
};
